// PLANTS CORE VEGETABLES
// Clean database with regional names support

import { PlantData } from './plants-master-database'

export const coreVegetablesData: PlantData[] = [
  {
    id: 'tomato-beefsteak',
    name: 'Tomato - Beefsteak',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot'],
    enemies: ['potato', 'fennel'],
    description: 'Large, meaty tomatoes perfect for slicing. Indeterminate vines need staking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Beefsteak', 'Brandywine', 'Cherokee Purple'],
    uses: ['fresh', 'slicing', 'sandwiches']
  },
  {
    id: 'tomato-roma',
    name: 'Tomato - Roma',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'onion'],
    enemies: ['potato'],
    description: 'Paste tomato with thick walls and few seeds. Great for sauces and canning.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '2 feet',
    family: 'Solanaceae',
    varieties: ['Roma', 'San Marzano', 'Amish Paste'],
    uses: ['sauce', 'canning', 'paste']
  },
  {
    id: 'tomato-cherry',
    name: 'Tomato - Cherry',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'parsley'],
    enemies: ['potato'],
    description: 'Small, sweet tomatoes in clusters. Heavy producers all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-6 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Sweet 100', 'Sun Gold', 'Black Cherry'],
    uses: ['fresh', 'salads', 'snacking']
  },
  {
    id: 'pepper-bell',
    name: 'Pepper - Bell',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion'],
    enemies: ['fennel'],
    description: 'Sweet bell peppers in various colors. Start indoors 8-10 weeks before last frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['California Wonder', 'Red Knight', 'Golden Calwonder'],
    uses: ['fresh', 'stuffed', 'salads']
  },
  {
    id: 'pepper-jalapeno',
    name: 'Pepper - Jalapeno',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 14,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil'],
    enemies: ['fennel'],
    description: 'Medium-hot pepper perfect for salsa and pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Jalapeno M', 'Early Jalapeno', 'Mucho Nacho'],
    uses: ['salsa', 'pickling', 'cooking']
  },
  {
    id: 'lettuce-romaine',
    name: 'Lettuce - Romaine',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry'],
    enemies: ['celery'],
    description: 'Upright lettuce with crisp, sweet leaves. Heat tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Parris Island', 'Little Gem', 'Red Romaine'],
    uses: ['salads', 'sandwiches', 'caesar']
  },
  {
    id: 'lettuce-leaf',
    name: 'Lettuce - Leaf',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['radish', 'carrot'],
    enemies: ['celery'],
    description: 'Loose leaf lettuce, harvest outer leaves for continuous production.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Black Seeded Simpson', 'Red Sails', 'Oak Leaf'],
    uses: ['salads', 'sandwiches']
  },
  {
    id: 'carrot-nantes',
    name: 'Carrot - Nantes',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce', 'onion'],
    enemies: ['dill'],
    description: 'Sweet, cylindrical carrots with blunt tips. Best for fresh eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Nantes', 'Scarlet Nantes', 'Nelson'],
    uses: ['fresh', 'cooking', 'juice']
  },
  {
    id: 'carrot-danvers',
    name: 'Carrot - Danvers',
    scientificName: 'Daucus carota',
    category: 'vegetable',
    spacing: 2,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'lettuce'],
    enemies: ['dill'],
    description: 'Classic heirloom carrot, tapered shape. Good for heavy soils.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '7-8 inches',
    spread: '1-2 inches',
    family: 'Apiaceae',
    varieties: ['Danvers 126', 'Danvers Half Long'],
    uses: ['cooking', 'storage', 'fresh']
  },
  {
    id: 'onion-yellow',
    name: 'Onion - Yellow',
    scientificName: 'Allium cepa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'lettuce', 'tomato'],
    enemies: ['bean', 'pea'],
    description: 'Versatile cooking onion with strong flavor. Good storage variety.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '3-4 inches',
    family: 'Amaryllidaceae',
    varieties: ['Yellow Sweet Spanish', 'Walla Walla', 'Texas Grano'],
    uses: ['cooking', 'storage', 'caramelizing']
  },
  {
    id: 'cucumber-slicing',
    name: 'Cucumber - Slicing',
    scientificName: 'Cucumis sativus',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish'],
    enemies: ['potato', 'aromatic herbs'],
    description: 'Long, dark green cucumbers for fresh eating. Vining habit.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Marketmore 76', 'Straight Eight', 'Diva'],
    uses: ['fresh', 'salads', 'sandwiches']
  },
  {
    id: 'cucumber-pickling',
    name: 'Cucumber - Pickling',
    scientificName: 'Cucumis sativus',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean'],
    enemies: ['potato'],
    description: 'Short, blocky cucumbers with thin skin. Perfect for pickling.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Cucurbitaceae',
    varieties: ['Boston Pickling', 'National Pickling', 'Calico'],
    uses: ['pickling', 'fresh']
  },
  {
    id: 'zucchini-black-beauty',
    name: 'Zucchini - Black Beauty',
    scientificName: 'Cucurbita pepo',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'bean', 'radish'],
    enemies: ['potato'],
    description: 'Dark green, glossy zucchini. Heavy producer all summer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '3-4 feet',
    family: 'Cucurbitaceae',
    varieties: ['Black Beauty', 'Raven', 'Dunja'],
    uses: ['cooking', 'baking', 'grilling']
  },
  {
    id: 'bean-bush-blue-lake',
    name: 'Bean - Bush Blue Lake',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 4,
    rowSpacing: 18,
    daysToGermination: 8,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber', 'radish'],
    enemies: ['onion', 'garlic'],
    description: 'Stringless green beans on compact bushes. No staking needed.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Blue Lake 274', 'Contender', 'Provider'],
    uses: ['fresh', 'canning', 'freezing']
  },
  {
    id: 'bean-pole-kentucky-wonder',
    name: 'Bean - Pole Kentucky Wonder',
    scientificName: 'Phaseolus vulgaris',
    category: 'legume',
    spacing: 6,
    rowSpacing: 36,
    daysToGermination: 8,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['corn', 'cucumber'],
    enemies: ['onion', 'garlic'],
    description: 'Classic pole bean with stringless pods. Needs trellis.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '12-18 inches',
    family: 'Fabaceae',
    varieties: ['Kentucky Wonder', 'Kentucky Blue', 'Fortex'],
    uses: ['fresh', 'canning', 'drying']
  },
  {
    id: 'spinach-bloomsdale',
    name: 'Spinach - Bloomsdale',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'Savoyed (crinkled) leaves with rich flavor. Slow to bolt.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Bloomsdale Long Standing', 'Space'],
    uses: ['salads', 'cooking', 'smoothies']
  },
  {
    id: 'kale-lacinato',
    name: 'Kale - Lacinato',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'Dinosaur kale with dark blue-green bumpy leaves. Very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Brassicaceae',
    varieties: ['Lacinato', 'Dinosaur', 'Toscano'],
    uses: ['cooking', 'salads', 'chips', 'smoothies']
  },
  {
    id: 'broccoli-calabrese',
    name: 'Broccoli - Calabrese',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery'],
    enemies: ['strawberry', 'tomato'],
    description: 'Large heads with side shoots after main harvest. Italian heirloom.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Calabrese', 'Green Magic', 'Belstar'],
    uses: ['fresh', 'cooking', 'freezing']
  },
  {
    id: 'radish-cherry-belle',
    name: 'Radish - Cherry Belle',
    scientificName: 'Raphanus sativus',
    category: 'vegetable',
    spacing: 1,
    rowSpacing: 6,
    daysToGermination: 5,
    daysToHarvest: 25,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['lettuce', 'carrot', 'bean'],
    enemies: ['hyssop'],
    description: 'Round, bright red radishes. Fast growing, ready in 3-4 weeks.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '2-3 inches',
    family: 'Brassicaceae',
    varieties: ['Cherry Belle', 'Champion', 'Crimson Giant'],
    uses: ['fresh', 'salads', 'pickling']
  },
  {
    id: 'beet-detroit-dark-red',
    name: 'Beet - Detroit Dark Red',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'lettuce'],
    enemies: ['mustard', 'charlock'],
    description: 'Classic dark red beet with sweet flavor. Edible greens too.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '3-4 inches',
    family: 'Amaranthaceae',
    varieties: ['Detroit Dark Red', 'Early Wonder', 'Cylindra'],
    uses: ['cooking', 'pickling', 'greens']
  }
,
  {
    id: 'pea-snap',
    name: 'Pea - Snap',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot', 'radish'],
    enemies: ['onion', 'garlic'],
    description: 'Edible pod peas, sweet and crunchy. Eat whole pod and peas.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Sugar Snap', 'Super Sugar Snap'],
    uses: ['fresh', 'stir fry', 'salads']
  },
  {
    id: 'pea-snow',
    name: 'Pea - Snow',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot'],
    enemies: ['onion'],
    description: 'Flat edible pods used in Asian cooking. Harvest before peas swell.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Oregon Giant', 'Mammoth Melting'],
    uses: ['stir fry', 'asian cuisine', 'fresh']
  },
  {
    id: 'pea-shelling',
    name: 'Pea - Shelling',
    scientificName: 'Pisum sativum',
    category: 'legume',
    spacing: 2,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['carrot'],
    enemies: ['onion'],
    description: 'Traditional garden peas. Remove from pod before eating.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '6-8 inches',
    family: 'Fabaceae',
    varieties: ['Green Arrow', 'Little Marvel'],
    uses: ['fresh', 'freezing', 'cooking']
  },
  {
    id: 'potato-kennebec',
    name: 'Potato - Kennebec',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean', 'corn'],
    enemies: ['tomato', 'sunflower'],
    description: 'White potato, excellent all-purpose. Good for frying and baking.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Kennebec', 'Superior'],
    uses: ['baking', 'frying', 'mashed']
  },
  {
    id: 'potato-red-la-soda',
    name: 'Potato - Red La Soda',
    scientificName: 'Solanum tuberosum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 14,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 5,
    phMax: 6.5,
    companions: ['bean'],
    enemies: ['tomato'],
    description: 'Red skin, white flesh. Waxy texture, holds shape when boiled.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Solanaceae',
    varieties: ['Red La Soda', 'Red Pontiac'],
    uses: ['boiling', 'salads', 'roasting']
  },
  {
    id: 'sweet-potato-beauregard',
    name: 'Sweet Potato - Beauregard',
    scientificName: 'Ipomoea batatas',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 36,
    daysToGermination: 0,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 5.5,
    phMax: 6.5,
    companions: [],
    enemies: [],
    description: 'Orange flesh, copper skin. Most popular commercial variety.',
    hardinessZones: '5-11',
    plantingSeason: 'spring',
    height: ' vines to 10 feet',
    spread: '3-4 feet',
    family: 'Convolvulaceae',
    varieties: ['Beauregard', 'Jewel'],
    uses: ['baking', 'fries', 'pies']
  },
  {
    id: 'celery-tall-utah',
    name: 'Celery - Tall Utah',
    scientificName: 'Apium graveolens',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 14,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['cabbage', 'tomato'],
    enemies: [],
    description: 'Crisp green stalks with mild flavor. Needs consistent moisture.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '8-12 inches',
    family: 'Apiaceae',
    varieties: ['Tall Utah', 'Golden Self-Blanching'],
    uses: ['salads', 'soup', 'snacking']
  },
  {
    id: 'artichoke-green-globe',
    name: 'Artichoke - Green Globe',
    scientificName: 'Cynara cardunculus',
    category: 'vegetable',
    spacing: 36,
    rowSpacing: 48,
    daysToGermination: 14,
    daysToHarvest: 150,
    sun: 'full',
    water: 'medium',
    soil: 'sandy',
    phMin: 6.5,
    phMax: 7.5,
    companions: [],
    enemies: [],
    description: 'Large green artichokes with tender hearts. Perennial in mild climates.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '3-4 feet',
    spread: '4-6 feet',
    family: 'Asteraceae',
    varieties: ['Green Globe', 'Imperial Star'],
    uses: ['hearts', 'steaming', 'dipping']
  }
,
  {
    id: 'tomato-brandywine',
    name: 'Tomato - Brandywine',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Pink beefsteak variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Brandywine'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-brandywine-red',
    name: 'Tomato - Brandywine Red',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red beefsteak variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Brandywine Red'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-brandywine-yellow',
    name: 'Tomato - Brandywine Yellow',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Yellow beefsteak variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Brandywine Yellow'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-cherokee-purple',
    name: 'Tomato - Cherokee Purple',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Purple tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Cherokee Purple'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-black-krim',
    name: 'Tomato - Black Krim',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Purple-Black tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Black Krim'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-mortgage-lifter',
    name: 'Tomato - Mortgage Lifter',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Pink tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Mortgage Lifter'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-german-johnson',
    name: 'Tomato - German Johnson',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Pink tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['German Johnson'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-hillbilly',
    name: 'Tomato - Hillbilly',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Yellow-Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Hillbilly'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-pineapple',
    name: 'Tomato - Pineapple',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Yellow-Red tomato variety. Large fruit, longer season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Pineapple'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-big-rainbow',
    name: 'Tomato - Big Rainbow',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Yellow-Red tomato variety. Large fruit, longer season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Big Rainbow'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-copia',
    name: 'Tomato - Copia',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Yellow-Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Copia'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-mr-stripey',
    name: 'Tomato - Mr Stripey',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Yellow-Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Mr Stripey'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-gold-medal',
    name: 'Tomato - Gold Medal',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Yellow tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Gold Medal'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-yellow-brandywine',
    name: 'Tomato - Yellow Brandywine',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Yellow beefsteak variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Yellow Brandywine'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-paul-robeson',
    name: 'Tomato - Paul Robeson',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Purple tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Paul Robeson'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-carbon',
    name: 'Tomato - Carbon',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Purple tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Carbon'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-pruden-purple',
    name: 'Tomato - Pruden Purple',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Purple tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Pruden Purple'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-black-prince',
    name: 'Tomato - Black Prince',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Purple-Black tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Black Prince'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-kelloggs-breakfast',
    name: 'Tomato - Kelloggs Breakfast',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Orange tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Kelloggs Breakfast'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-amana-orange',
    name: 'Tomato - Amana Orange',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Orange tomato variety. Large fruit, longer season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Amana Orange'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-persimmon',
    name: 'Tomato - Persimmon',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Orange tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Persimmon'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-nebraska-wedding',
    name: 'Tomato - Nebraska Wedding',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Orange tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Nebraska Wedding'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-costoluto-genovese',
    name: 'Tomato - Costoluto Genovese',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Costoluto Genovese'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-costoluto-fiorentino',
    name: 'Tomato - Costoluto Fiorentino',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Costoluto Fiorentino'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-giant-belgium',
    name: 'Tomato - Giant Belgium',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Pink tomato variety. Large fruit, longer season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Giant Belgium'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-delicious',
    name: 'Tomato - Delicious',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Delicious'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-beefmaster',
    name: 'Tomato - Beefmaster',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Beefmaster'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-supersteak',
    name: 'Tomato - Supersteak',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Supersteak'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-bucks-county',
    name: 'Tomato - Bucks County',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Bucks County'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-box-car-willie',
    name: 'Tomato - Box Car Willie',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Box Car Willie'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-rutgers',
    name: 'Tomato - Rutgers',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Rutgers'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-bonny-best',
    name: 'Tomato - Bonny Best',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Bonny Best'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-ace-55',
    name: 'Tomato - Ace 55',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Ace 55'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-ponderosa-red',
    name: 'Tomato - Ponderosa Red',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Large fruit, longer season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Ponderosa Red'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-ponderosa-pink',
    name: 'Tomato - Ponderosa Pink',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Pink tomato variety. Large fruit, longer season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Ponderosa Pink'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-ponderosa-yellow',
    name: 'Tomato - Ponderosa Yellow',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Yellow tomato variety. Large fruit, longer season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Ponderosa Yellow'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-oxheart-red',
    name: 'Tomato - Oxheart Red',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Oxheart Red'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-oxheart-pink',
    name: 'Tomato - Oxheart Pink',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Pink tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Oxheart Pink'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-oxheart-yellow',
    name: 'Tomato - Oxheart Yellow',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Yellow tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Oxheart Yellow'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-oxheart-orange',
    name: 'Tomato - Oxheart Orange',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Orange tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Oxheart Orange'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-caspian-pink',
    name: 'Tomato - Caspian Pink',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Pink tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Caspian Pink'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-arkansas-traveler',
    name: 'Tomato - Arkansas Traveler',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Pink tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Arkansas Traveler'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-marianas-peace',
    name: 'Tomato - Marianas Peace',
    scientificName: 'Solanum lycopersicum',
    category: 'legume',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Pink tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Marianas Peace'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-dads-sunset',
    name: 'Tomato - Dads Sunset',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Orange tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Dads Sunset'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-virginia-sweets',
    name: 'Tomato - Virginia Sweets',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Yellow-Red tomato variety. Large fruit, longer season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Virginia Sweets'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-trophy',
    name: 'Tomato - Trophy',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Trophy'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-red-brandywine',
    name: 'Tomato - Red Brandywine',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red beefsteak variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Red Brandywine'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-black-from-tula',
    name: 'Tomato - Black from Tula',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Purple-Black tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Black from Tula'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-purple-cherokee',
    name: 'Tomato - Purple Cherokee',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Purple tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Purple Cherokee'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-cherokee-chocolate',
    name: 'Tomato - Cherokee Chocolate',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Chocolate tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Cherokee Chocolate'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-chocolate-stripes',
    name: 'Tomato - Chocolate Stripes',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Chocolate-Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Chocolate Stripes'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-vintage-wine',
    name: 'Tomato - Vintage Wine',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Pink-Green tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Vintage Wine'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-big-zac',
    name: 'Tomato - Big Zac',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Large fruit, longer season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Big Zac'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-goliath',
    name: 'Tomato - Goliath',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Goliath'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-giant-syrian',
    name: 'Tomato - Giant Syrian',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Pink tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Giant Syrian'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-grandmas-pick',
    name: 'Tomato - Grandmas Pick',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Pink tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Grandmas Pick'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-mexico-midget',
    name: 'Tomato - Mexico Midget',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Mexico Midget'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-red-currant',
    name: 'Tomato - Red Currant',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red cherry variety. Early maturing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Red Currant'],
    uses: ['fresh', 'salads', 'snacking']
  },
  {
    id: 'tomato-yellow-currant',
    name: 'Tomato - Yellow Currant',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Yellow cherry variety. Early maturing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Yellow Currant'],
    uses: ['fresh', 'salads', 'snacking']
  },
  {
    id: 'tomato-matt-wild',
    name: 'Tomato - Matt Wild',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Matt Wild'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-san-marzano',
    name: 'Tomato - San Marzano',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['San Marzano'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-san-marzano-redorta',
    name: 'Tomato - San Marzano Redorta',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['San Marzano Redorta'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-amish-paste',
    name: 'Tomato - Amish Paste',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red paste variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Amish Paste'],
    uses: ['sauce', 'canning', 'paste']
  },
  {
    id: 'tomato-jersey-devil',
    name: 'Tomato - Jersey Devil',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Jersey Devil'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-opalka',
    name: 'Tomato - Opalka',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Opalka'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-polish-linguisa',
    name: 'Tomato - Polish Linguisa',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Polish Linguisa'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-speckled-roman',
    name: 'Tomato - Speckled Roman',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red-Yellow paste variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Speckled Roman'],
    uses: ['sauce', 'canning', 'paste']
  },
  {
    id: 'tomato-striped-roman',
    name: 'Tomato - Striped Roman',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red-Yellow paste variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Striped Roman'],
    uses: ['sauce', 'canning', 'paste']
  },
  {
    id: 'tomato-martinos-roma',
    name: 'Tomato - Martinos Roma',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red paste variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Martinos Roma'],
    uses: ['sauce', 'canning', 'paste']
  },
  {
    id: 'tomato-viva-italia',
    name: 'Tomato - Viva Italia',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Viva Italia'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-golden-rave',
    name: 'Tomato - Golden Rave',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Yellow tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Golden Rave'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-orange-banana',
    name: 'Tomato - Orange Banana',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Orange tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Orange Banana'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-yellow-plum',
    name: 'Tomato - Yellow Plum',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Yellow tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Yellow Plum'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-plum-lemon',
    name: 'Tomato - Plum Lemon',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Yellow tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Plum Lemon'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-purple-russian',
    name: 'Tomato - Purple Russian',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Purple tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Purple Russian'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-black-plum',
    name: 'Tomato - Black Plum',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Purple-Black tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Black Plum'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-japanese-black-trifele',
    name: 'Tomato - Japanese Black Trifele',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Purple-Black tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Japanese Black Trifele'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-ukrainian-purple',
    name: 'Tomato - Ukrainian Purple',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Purple tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Ukrainian Purple'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-roma-vf',
    name: 'Tomato - Roma VF',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red paste variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Roma VF'],
    uses: ['sauce', 'canning', 'paste']
  },
  {
    id: 'tomato-heinz-2653',
    name: 'Tomato - Heinz 2653',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Heinz 2653'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-la-roma',
    name: 'Tomato - La Roma',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red paste variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['La Roma'],
    uses: ['sauce', 'canning', 'paste']
  },
  {
    id: 'tomato-paisano',
    name: 'Tomato - Paisano',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Paisano'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-sweet-100',
    name: 'Tomato - Sweet 100',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Sweet 100'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-sweet-million',
    name: 'Tomato - Sweet Million',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Sweet Million'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-sun-gold',
    name: 'Tomato - Sun Gold',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Orange tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Sun Gold'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-sun-sugar',
    name: 'Tomato - Sun Sugar',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Orange tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Sun Sugar'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-black-cherry',
    name: 'Tomato - Black Cherry',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Purple-Black cherry variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Black Cherry'],
    uses: ['fresh', 'salads', 'snacking']
  },
  {
    id: 'tomato-chocolate-cherry',
    name: 'Tomato - Chocolate Cherry',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Chocolate cherry variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Chocolate Cherry'],
    uses: ['fresh', 'salads', 'snacking']
  },
  {
    id: 'tomato-yellow-pear',
    name: 'Tomato - Yellow Pear',
    scientificName: 'Solanum lycopersicum',
    category: 'legume',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Yellow tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Yellow Pear'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-red-pear',
    name: 'Tomato - Red Pear',
    scientificName: 'Solanum lycopersicum',
    category: 'legume',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Red Pear'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-black-plum-cherry',
    name: 'Tomato - Black Plum Cherry',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Purple-Black cherry variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Black Plum Cherry'],
    uses: ['fresh', 'salads', 'snacking']
  },
  {
    id: 'tomato-honeydrop',
    name: 'Tomato - Honeydrop',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Yellow tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Honeydrop'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-isis-candy',
    name: 'Tomato - Isis Candy',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 67,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Orange-Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Isis Candy'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-jasper',
    name: 'Tomato - Jasper',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Jasper'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-sungella',
    name: 'Tomato - Sungella',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Orange tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Sungella'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-blush',
    name: 'Tomato - Blush',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Yellow-Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Blush'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-artisan-blush-tiger',
    name: 'Tomato - Artisan Blush Tiger',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Yellow-Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Artisan Blush Tiger'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-artisan-purple-bumble-bee',
    name: 'Tomato - Artisan Purple Bumble Bee',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Purple tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Artisan Purple Bumble Bee'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-artisan-pink-bumble-bee',
    name: 'Tomato - Artisan Pink Bumble Bee',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Pink tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Artisan Pink Bumble Bee'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-artisan-green-tiger',
    name: 'Tomato - Artisan Green Tiger',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Green tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Artisan Green Tiger'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-indigo-rose',
    name: 'Tomato - Indigo Rose',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Purple-Black tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Indigo Rose'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-indigo-cherry-drops',
    name: 'Tomato - Indigo Cherry Drops',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Purple cherry variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '5-7 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Indigo Cherry Drops'],
    uses: ['fresh', 'salads', 'snacking']
  },
  {
    id: 'tomato-midnight-snack',
    name: 'Tomato - Midnight Snack',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Purple-Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Midnight Snack'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-blueberries',
    name: 'Tomato - Blueberries',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Purple tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Blueberries'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-esterina',
    name: 'Tomato - Esterina',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Yellow tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Esterina'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-favorita',
    name: 'Tomato - Favorita',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Favorita'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-sunchocola',
    name: 'Tomato - Sunchocola',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Chocolate tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Sunchocola'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-sunpeach',
    name: 'Tomato - Sunpeach',
    scientificName: 'Solanum lycopersicum',
    category: 'legume',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Pink tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Sunpeach'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-supersweet-100',
    name: 'Tomato - Supersweet 100',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Supersweet 100'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-candyland-red',
    name: 'Tomato - Candyland Red',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Early maturing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Candyland Red'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-candyland-yellow',
    name: 'Tomato - Candyland Yellow',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Yellow tomato variety. Early maturing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Candyland Yellow'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-power-pops',
    name: 'Tomato - Power Pops',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Early maturing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Power Pops'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-tempting-tomatoes-goodhearted',
    name: 'Tomato - Tempting Tomatoes Goodhearted',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Tempting Tomatoes Goodhearted'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-nova',
    name: 'Tomato - Nova',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Nova'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-heidi',
    name: 'Tomato - Heidi',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Heidi'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-chico-iii',
    name: 'Tomato - Chico III',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Chico III'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-pozzano',
    name: 'Tomato - Pozzano',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Pozzano'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-granadero',
    name: 'Tomato - Granadero',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Granadero'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-cupido',
    name: 'Tomato - Cupido',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Cupido'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-tiren',
    name: 'Tomato - Tiren',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Tiren'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-siletz',
    name: 'Tomato - Siletz',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Siletz'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-bhn-589',
    name: 'Tomato - BHN 589',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['BHN 589'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-bhn-968',
    name: 'Tomato - BHN 968',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['BHN 968'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-defiant-phr',
    name: 'Tomato - Defiant PHR',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Defiant PHR'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-iron-lady',
    name: 'Tomato - Iron Lady',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Iron Lady'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-mountain-magic',
    name: 'Tomato - Mountain Magic',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Mountain Magic'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-mountain-merit',
    name: 'Tomato - Mountain Merit',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Mountain Merit'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-mountain-rouge',
    name: 'Tomato - Mountain Rouge',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Mountain Rouge'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-mountain-fresh-plus',
    name: 'Tomato - Mountain Fresh Plus',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Mountain Fresh Plus'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-plum-regal',
    name: 'Tomato - Plum Regal',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Plum Regal'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-juliet',
    name: 'Tomato - Juliet',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Juliet'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-verona',
    name: 'Tomato - Verona',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Verona'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-federle',
    name: 'Tomato - Federle',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Federle'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-longkeeper',
    name: 'Tomato - Longkeeper',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Longkeeper'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-garden-peach',
    name: 'Tomato - Garden Peach',
    scientificName: 'Solanum lycopersicum',
    category: 'legume',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Yellow tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Garden Peach'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-green-zebra',
    name: 'Tomato - Green Zebra',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Green tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Green Zebra'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-lucky-tiger',
    name: 'Tomato - Lucky Tiger',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Green-Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Lucky Tiger'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-berkeley-tie-dye',
    name: 'Tomato - Berkeley Tie Dye',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Green-Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Berkeley Tie Dye'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-cherokee-green',
    name: 'Tomato - Cherokee Green',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Green tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Cherokee Green'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-aunt-rubys-german-green',
    name: 'Tomato - Aunt Rubys German Green',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Green tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Aunt Rubys German Green'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-emerald-evergreen',
    name: 'Tomato - Emerald Evergreen',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Green tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Emerald Evergreen'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-green-giant',
    name: 'Tomato - Green Giant',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Green tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Green Giant'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-malakhitovaya-shkatulka',
    name: 'Tomato - Malakhitovaya Shkatulka',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Green tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Malakhitovaya Shkatulka'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-tiny-tim',
    name: 'Tomato - Tiny Tim',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Early maturing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Tiny Tim'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-red-robin',
    name: 'Tomato - Red Robin',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Early maturing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Red Robin'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-tumbling-tom-red',
    name: 'Tomato - Tumbling Tom Red',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Tumbling Tom Red'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-tumbling-tom-yellow',
    name: 'Tomato - Tumbling Tom Yellow',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Yellow tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Tumbling Tom Yellow'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-patio-princess',
    name: 'Tomato - Patio Princess',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Patio Princess'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-bush-early-girl',
    name: 'Tomato - Bush Early Girl',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Bush Early Girl'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-bush-big-boy',
    name: 'Tomato - Bush Big Boy',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Bush Big Boy'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-bush-goliath',
    name: 'Tomato - Bush Goliath',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Bush Goliath'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-celebrity',
    name: 'Tomato - Celebrity',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Celebrity'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-better-boy',
    name: 'Tomato - Better Boy',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Better Boy'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-big-boy',
    name: 'Tomato - Big Boy',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 78,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Big Boy'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-whopper',
    name: 'Tomato - Whopper',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Whopper'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-early-girl',
    name: 'Tomato - Early Girl',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Early maturing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Early Girl'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-fourth-of-july',
    name: 'Tomato - Fourth of July',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 49,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Early maturing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Fourth of July'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-sub-arctic-plenty',
    name: 'Tomato - Sub Arctic Plenty',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Early maturing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Sub Arctic Plenty'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-siberian',
    name: 'Tomato - Siberian',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Siberian'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-glacier',
    name: 'Tomato - Glacier',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Early maturing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Glacier'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-oregon-spring',
    name: 'Tomato - Oregon Spring',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Oregon Spring'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-siletz',
    name: 'Tomato - Siletz',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Early maturing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Siletz'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-stupice',
    name: 'Tomato - Stupice',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Early maturing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Stupice'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-bloody-butcher',
    name: 'Tomato - Bloody Butcher',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Red tomato variety. Early maturing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Bloody Butcher'],
    uses: ['fresh', 'slicing', 'cooking']
  },
  {
    id: 'tomato-black-sea-man',
    name: 'Tomato - Black Sea Man',
    scientificName: 'Solanum lycopersicum',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['basil', 'marigold', 'carrot', 'onion'],
    enemies: ['potato', 'fennel', 'corn'],
    description: 'Purple-Black tomato variety. Reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-8 feet',
    spread: '2-3 feet',
    family: 'Solanaceae',
    varieties: ['Black Sea Man'],
    uses: ['fresh', 'slicing', 'cooking']
  }
,
  {
    id: 'pepper-california-wonder',
    name: 'Pepper - California Wonder',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['California Wonder'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-yolo-wonder',
    name: 'Pepper - Yolo Wonder',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Yolo Wonder'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-golden-california-wonder',
    name: 'Pepper - Golden California Wonder',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Yellow sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Golden California Wonder'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-orange-sun',
    name: 'Pepper - Orange Sun',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Orange sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Orange Sun'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-purple-beauty',
    name: 'Pepper - Purple Beauty',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Purple sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Purple Beauty'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-chocolate-beauty',
    name: 'Pepper - Chocolate Beauty',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Chocolate sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Chocolate Beauty'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-white-bell',
    name: 'Pepper - White Bell',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'White sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['White Bell'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-black-bell',
    name: 'Pepper - Black Bell',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Purple-Black sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Black Bell'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-candy-apple-red',
    name: 'Pepper - Candy Apple Red',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Candy Apple Red'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-big-bertha',
    name: 'Pepper - Big Bertha',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 72,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Big Bertha'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-king-arthur',
    name: 'Pepper - King Arthur',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['King Arthur'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-ace',
    name: 'Pepper - Ace',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Ace'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-lipstick',
    name: 'Pepper - Lipstick',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Lipstick'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-gypsy',
    name: 'Pepper - Gypsy',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Yellow-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Gypsy'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-carmen',
    name: 'Pepper - Carmen',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Carmen'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-islander',
    name: 'Pepper - Islander',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Purple-Yellow-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Islander'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-blushing-beauty',
    name: 'Pepper - Blushing Beauty',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 72,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'White-Pink sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Blushing Beauty'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-cutting-edge',
    name: 'Pepper - Cutting Edge',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'White-Purple sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Cutting Edge'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-diamond',
    name: 'Pepper - Diamond',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'White sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Diamond'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-flamingo',
    name: 'Pepper - Flamingo',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Pink sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Flamingo'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-horizon-orange',
    name: 'Pepper - Horizon Orange',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Orange sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Horizon Orange'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-horizon-red',
    name: 'Pepper - Horizon Red',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Horizon Red'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-horizon-yellow',
    name: 'Pepper - Horizon Yellow',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Yellow sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Horizon Yellow'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-keystone-resistant-giant',
    name: 'Pepper - Keystone Resistant Giant',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Keystone Resistant Giant'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-northstar',
    name: 'Pepper - Northstar',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Northstar'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-paladin',
    name: 'Pepper - Paladin',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Paladin'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-revolution',
    name: 'Pepper - Revolution',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Revolution'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-admiral',
    name: 'Pepper - Admiral',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Admiral'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-commandant',
    name: 'Pepper - Commandant',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Commandant'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-socrates',
    name: 'Pepper - Socrates',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Yellow sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Socrates'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-zephyr',
    name: 'Pepper - Zephyr',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Yellow sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Zephyr'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-quadrato-asti-giallo',
    name: 'Pepper - Quadrato Asti Giallo',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Yellow sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Quadrato Asti Giallo'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-quadrato-rosso-d-asti',
    name: 'Pepper - Quadrato Rosso D Asti',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Quadrato Rosso D Asti'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-corno-di-toro-red',
    name: 'Pepper - Corno di Toro Red',
    scientificName: 'Capsicum annuum',
    category: 'grain',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Corno di Toro Red'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-corno-di-toro-yellow',
    name: 'Pepper - Corno di Toro Yellow',
    scientificName: 'Capsicum annuum',
    category: 'grain',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Yellow sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Corno di Toro Yellow'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-corno-di-toro-orange',
    name: 'Pepper - Corno di Toro Orange',
    scientificName: 'Capsicum annuum',
    category: 'grain',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Orange sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Corno di Toro Orange'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-jimmy-nardello',
    name: 'Pepper - Jimmy Nardello',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Jimmy Nardello'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-marconi-red',
    name: 'Pepper - Marconi Red',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Marconi Red'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-marconi-golden',
    name: 'Pepper - Marconi Golden',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Yellow sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Marconi Golden'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-carmen',
    name: 'Pepper - Carmen',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Carmen'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-jalapeno-m',
    name: 'Pepper - Jalapeno M',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red hot pepper. Heat level varies by variety. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Jalapeno M'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-jalapeno-early',
    name: 'Pepper - Jalapeno Early',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red hot pepper. Heat level varies by variety. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Jalapeno Early'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-mucho-nacho',
    name: 'Pepper - Mucho Nacho',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Mucho Nacho'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-el-jefe',
    name: 'Pepper - El Jefe',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['El Jefe'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-fresno',
    name: 'Pepper - Fresno',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Fresno'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-serrano',
    name: 'Pepper - Serrano',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red hot pepper. Heat level varies by variety. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Serrano'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-serrano-tampiqueno',
    name: 'Pepper - Serrano Tampiqueno',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red hot pepper. Heat level varies by variety. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Serrano Tampiqueno'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-habanero',
    name: 'Pepper - Habanero',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Orange hot pepper. Heat level varies by variety. Long season, start early indoors.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Habanero'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-habanero-red',
    name: 'Pepper - Habanero Red',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red hot pepper. Heat level varies by variety. Long season, start early indoors.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Habanero Red'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-habanero-chocolate',
    name: 'Pepper - Habanero Chocolate',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Chocolate hot pepper. Heat level varies by variety. Long season, start early indoors.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Habanero Chocolate'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-scotch-bonnet',
    name: 'Pepper - Scotch Bonnet',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Yellow-Orange sweet pepper. Mild, sweet flavor. Long season, start early indoors.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Scotch Bonnet'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-ghost-pepper',
    name: 'Pepper - Ghost Pepper',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red hot pepper. Heat level varies by variety. Long season, start early indoors.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Ghost Pepper'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-carolina-reaper',
    name: 'Pepper - Carolina Reaper',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red hot pepper. Heat level varies by variety. Long season, start early indoors.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Carolina Reaper'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-trinidad-scorpion',
    name: 'Pepper - Trinidad Scorpion',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red hot pepper. Heat level varies by variety. Long season, start early indoors.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Trinidad Scorpion'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-7-pot',
    name: 'Pepper - 7 Pot',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red hot pepper. Heat level varies by variety. Long season, start early indoors.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['7 Pot'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-7-pot-douglah',
    name: 'Pepper - 7 Pot Douglah',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Chocolate hot pepper. Heat level varies by variety. Long season, start early indoors.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['7 Pot Douglah'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-7-pot-primo',
    name: 'Pepper - 7 Pot Primo',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red hot pepper. Heat level varies by variety. Long season, start early indoors.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['7 Pot Primo'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-7-pot-brain-strain',
    name: 'Pepper - 7 Pot Brain Strain',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red hot pepper. Heat level varies by variety. Long season, start early indoors.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['7 Pot Brain Strain'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-bhut-jolokia',
    name: 'Pepper - Bhut Jolokia',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red hot pepper. Heat level varies by variety. Long season, start early indoors.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Bhut Jolokia'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-naga-viper',
    name: 'Pepper - Naga Viper',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red hot pepper. Heat level varies by variety. Long season, start early indoors.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Naga Viper'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-infinity-chili',
    name: 'Pepper - Infinity Chili',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red hot pepper. Heat level varies by variety. Long season, start early indoors.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Infinity Chili'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-komodo-dragon',
    name: 'Pepper - Komodo Dragon',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red hot pepper. Heat level varies by variety. Long season, start early indoors.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Komodo Dragon'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-dragon-breath',
    name: 'Pepper - Dragon Breath',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red hot pepper. Heat level varies by variety. Long season, start early indoors.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Dragon Breath'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-pepper-x',
    name: 'Pepper - Pepper X',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green sweet pepper. Mild, sweet flavor. Long season, start early indoors.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Pepper X'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-cayenne',
    name: 'Pepper - Cayenne',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 72,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red hot pepper. Heat level varies by variety. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Cayenne'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-cayenne-long-slim',
    name: 'Pepper - Cayenne Long Slim',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 72,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red hot pepper. Heat level varies by variety. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Cayenne Long Slim'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-golden-cayenne',
    name: 'Pepper - Golden Cayenne',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 72,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Yellow hot pepper. Heat level varies by variety. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Golden Cayenne'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-purple-cayenne',
    name: 'Pepper - Purple Cayenne',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 72,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Purple hot pepper. Heat level varies by variety. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Purple Cayenne'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-thai-hot',
    name: 'Pepper - Thai Hot',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red hot pepper. Heat level varies by variety. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Thai Hot'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-thai-dragon',
    name: 'Pepper - Thai Dragon',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red hot pepper. Heat level varies by variety. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Thai Dragon'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-birds-eye',
    name: 'Pepper - Birds Eye',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red hot pepper. Heat level varies by variety. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Birds Eye'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-tabasco',
    name: 'Pepper - Tabasco',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Yellow-Orange-Red hot pepper. Heat level varies by variety. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Tabasco'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-poblano',
    name: 'Pepper - Poblano',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Poblano'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-ancho-101',
    name: 'Pepper - Ancho 101',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Ancho 101'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-ancho-san-martin',
    name: 'Pepper - Ancho San Martin',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Ancho San Martin'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-mulato-isleno',
    name: 'Pepper - Mulato Isleno',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Brown sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Mulato Isleno'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-pasilla-bajio',
    name: 'Pepper - Pasilla Bajio',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Brown sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Pasilla Bajio'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-chilaca',
    name: 'Pepper - Chilaca',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Brown sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Chilaca'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-new-mexico-big-jim',
    name: 'Pepper - New Mexico Big Jim',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['New Mexico Big Jim'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-new-mexico-6-4',
    name: 'Pepper - New Mexico 6-4',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['New Mexico 6-4'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-anaheim',
    name: 'Pepper - Anaheim',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Anaheim'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-anaheim-chili',
    name: 'Pepper - Anaheim Chili',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 78,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red hot pepper. Heat level varies by variety. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Anaheim Chili'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-numex-joe-e-parker',
    name: 'Pepper - NuMex Joe E Parker',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['NuMex Joe E Parker'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-numex-heritage-6-4',
    name: 'Pepper - NuMex Heritage 6-4',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['NuMex Heritage 6-4'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-numex-twilight',
    name: 'Pepper - NuMex Twilight',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Multi sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['NuMex Twilight'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-numex-easter',
    name: 'Pepper - NuMex Easter',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Multi sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['NuMex Easter'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-numex-suave-orange',
    name: 'Pepper - NuMex Suave Orange',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Orange sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['NuMex Suave Orange'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-numex-suave-red',
    name: 'Pepper - NuMex Suave Red',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['NuMex Suave Red'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-santa-fe-grande',
    name: 'Pepper - Santa Fe Grande',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Yellow-Orange-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Santa Fe Grande'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-hungarian-wax',
    name: 'Pepper - Hungarian Wax',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Yellow-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Hungarian Wax'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-hungarian-hot',
    name: 'Pepper - Hungarian Hot',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red hot pepper. Heat level varies by variety. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Hungarian Hot'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-banana-pepper',
    name: 'Pepper - Banana Pepper',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Yellow-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Banana Pepper'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-sweet-banana',
    name: 'Pepper - Sweet Banana',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Yellow-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Sweet Banana'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-hot-banana',
    name: 'Pepper - Hot Banana',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Yellow-Red hot pepper. Heat level varies by variety. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Hot Banana'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-pepperoncini',
    name: 'Pepper - Pepperoncini',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Yellow-Red hot pepper. Heat level varies by variety. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Pepperoncini'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-golden-greek',
    name: 'Pepper - Golden Greek',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Yellow sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Golden Greek'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-cubanelle',
    name: 'Pepper - Cubanelle',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Cubanelle'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-italian-long-hot',
    name: 'Pepper - Italian Long Hot',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red hot pepper. Heat level varies by variety. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Italian Long Hot'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-shishito',
    name: 'Pepper - Shishito',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Shishito'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-padron',
    name: 'Pepper - Padron',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Padron'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-pimento',
    name: 'Pepper - Pimento',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Pimento'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-cheese-pimento',
    name: 'Pepper - Cheese Pimento',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Cheese Pimento'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-cherry-bomb',
    name: 'Pepper - Cherry Bomb',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Cherry Bomb'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-hot-cherry',
    name: 'Pepper - Hot Cherry',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red hot pepper. Heat level varies by variety. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Hot Cherry'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-sweet-cherry',
    name: 'Pepper - Sweet Cherry',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Sweet Cherry'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-cherry-pick',
    name: 'Pepper - Cherry Pick',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Cherry Pick'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-red-cherry-large',
    name: 'Pepper - Red Cherry Large',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Red Cherry Large'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-tam-jalapeno',
    name: 'Pepper - Tam Jalapeno',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red hot pepper. Heat level varies by variety. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Tam Jalapeno'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-jalafuego',
    name: 'Pepper - Jalafuego',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Jalafuego'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  },
  {
    id: 'pepper-jalapeno-gigante',
    name: 'Pepper - Jalapeno Gigante',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red hot pepper. Heat level varies by variety. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Jalapeno Gigante'],
    uses: ['cooking', 'salsa', 'hot sauce', 'drying']
  },
  {
    id: 'pepper-conchos',
    name: 'Pepper - Conchos',
    scientificName: 'Capsicum annuum',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['tomato', 'basil', 'onion', 'carrot'],
    enemies: ['fennel'],
    description: 'Green-Red sweet pepper. Mild, sweet flavor. ',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '1-2 feet',
    family: 'Solanaceae',
    varieties: ['Conchos'],
    uses: ['fresh', 'salads', 'stuffed', 'cooking']
  }
,
  {
    id: 'lettuce-black-seeded-simpson',
    name: 'Lettuce - Black Seeded Simpson',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Green leaf lettuce. Quick growing, good for succession planting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Black Seeded Simpson'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-grand-rapids',
    name: 'Lettuce - Grand Rapids',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Green leaf lettuce. Quick growing, good for succession planting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Grand Rapids'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-oak-leaf',
    name: 'Lettuce - Oak Leaf',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Green loose leaf lettuce. Quick growing, good for succession planting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Oak Leaf'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-red-oak-leaf',
    name: 'Lettuce - Red Oak Leaf',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red loose leaf lettuce. Quick growing, good for succession planting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Red Oak Leaf'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-salad-bowl',
    name: 'Lettuce - Salad Bowl',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Green loose leaf lettuce. Quick growing, good for succession planting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Salad Bowl'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-red-salad-bowl',
    name: 'Lettuce - Red Salad Bowl',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red loose leaf lettuce. Quick growing, good for succession planting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Red Salad Bowl'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-buttercrunch',
    name: 'Lettuce - Buttercrunch',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Green butterhead lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Buttercrunch'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-bibb',
    name: 'Lettuce - Bibb',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Green butterhead lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Bibb'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-tom-thumb',
    name: 'Lettuce - Tom Thumb',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Green butterhead lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Tom Thumb'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-little-gem',
    name: 'Lettuce - Little Gem',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Green leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Little Gem'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-winter-density',
    name: 'Lettuce - Winter Density',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Green leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Winter Density'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-sylvesta',
    name: 'Lettuce - Sylvesta',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Green leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Sylvesta'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-yugoslavian-red',
    name: 'Lettuce - Yugoslavian Red',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Yugoslavian Red'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-drunken-woman-frizzy-headed',
    name: 'Lettuce - Drunken Woman Frizzy Headed',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Drunken Woman Frizzy Headed'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-flashy-butter-oak',
    name: 'Lettuce - Flashy Butter Oak',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red-Green butterhead lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Flashy Butter Oak'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-speckled',
    name: 'Lettuce - Speckled',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red-Green leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Speckled'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-freckles',
    name: 'Lettuce - Freckles',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red-Green leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Freckles'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-deer-tongue',
    name: 'Lettuce - Deer Tongue',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Green leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Deer Tongue'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-amish-deer-tongue',
    name: 'Lettuce - Amish Deer Tongue',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Green leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Amish Deer Tongue'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-bronze-mignonette',
    name: 'Lettuce - Bronze Mignonette',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Bronze Mignonette'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-red-velvet',
    name: 'Lettuce - Red Velvet',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Red Velvet'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-lollo-rossa',
    name: 'Lettuce - Lollo Rossa',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Lollo Rossa'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-lollo-bionda',
    name: 'Lettuce - Lollo Bionda',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Green leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Lollo Bionda'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-nevada',
    name: 'Lettuce - Nevada',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Green leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Nevada'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-parris-island-cos',
    name: 'Lettuce - Parris Island Cos',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Green romaine lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Parris Island Cos'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-romaine',
    name: 'Lettuce - Romaine',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Green romaine lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Romaine'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-red-romaine',
    name: 'Lettuce - Red Romaine',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red romaine lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Red Romaine'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-cimarron',
    name: 'Lettuce - Cimarron',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Cimarron'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-green-towers',
    name: 'Lettuce - Green Towers',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Green leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Green Towers'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-jericho',
    name: 'Lettuce - Jericho',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Green leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Jericho'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-rouge-d-hiver',
    name: 'Lettuce - Rouge d Hiver',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Rouge d Hiver'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-winter-density',
    name: 'Lettuce - Winter Density',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Green leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Winter Density'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-four-seasons',
    name: 'Lettuce - Four Seasons',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red-Green leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Four Seasons'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-merveille-des-quatre-saisons',
    name: 'Lettuce - Merveille des Quatre Saisons',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red-Green leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Merveille des Quatre Saisons'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-marvel-of-four-seasons',
    name: 'Lettuce - Marvel of Four Seasons',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red-Green leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Marvel of Four Seasons'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-red-cross',
    name: 'Lettuce - Red Cross',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Red Cross'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-new-red-fire',
    name: 'Lettuce - New Red Fire',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['New Red Fire'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-galactic',
    name: 'Lettuce - Galactic',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Galactic'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-outredgeous',
    name: 'Lettuce - Outredgeous',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Outredgeous'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-sparx',
    name: 'Lettuce - Sparx',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Sparx'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-cherokee',
    name: 'Lettuce - Cherokee',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Cherokee'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-red-sails',
    name: 'Lettuce - Red Sails',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red leaf lettuce. Quick growing, good for succession planting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Red Sails'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-ruby-red',
    name: 'Lettuce - Ruby Red',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red leaf lettuce. Quick growing, good for succession planting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Ruby Red'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-red-flame',
    name: 'Lettuce - Red Flame',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red leaf lettuce. Quick growing, good for succession planting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Red Flame'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-tango',
    name: 'Lettuce - Tango',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Green leaf lettuce. Quick growing, good for succession planting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Tango'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-green-ice',
    name: 'Lettuce - Green Ice',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Green leaf lettuce. Quick growing, good for succession planting.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Green Ice'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-ithaca',
    name: 'Lettuce - Ithaca',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Green leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Ithaca'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-vivian',
    name: 'Lettuce - Vivian',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Green leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Vivian'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-coastal-star',
    name: 'Lettuce - Coastal Star',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Green leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Coastal Star'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-australe',
    name: 'Lettuce - Australe',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Australe'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-truchas',
    name: 'Lettuce - Truchas',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Truchas'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-pirat',
    name: 'Lettuce - Pirat',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Pirat'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-bronze-arrow',
    name: 'Lettuce - Bronze Arrow',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Bronze Arrow'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-blushed-butter-oak',
    name: 'Lettuce - Blushed Butter Oak',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red-Green butterhead lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Blushed Butter Oak'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-yugoslavian-red-butterhead',
    name: 'Lettuce - Yugoslavian Red Butterhead',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red butterhead lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Yugoslavian Red Butterhead'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-kagraner-sommer',
    name: 'Lettuce - Kagraner Sommer',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Green leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Kagraner Sommer'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-santander',
    name: 'Lettuce - Santander',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Green leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Santander'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-muir',
    name: 'Lettuce - Muir',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Green leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Muir'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-summer-crisp',
    name: 'Lettuce - Summer Crisp',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Green crisphead lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Summer Crisp'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-nevada',
    name: 'Lettuce - Nevada',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Green leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Nevada'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-magenta',
    name: 'Lettuce - Magenta',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Magenta'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-red-tide',
    name: 'Lettuce - Red Tide',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Red Tide'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-cardinale',
    name: 'Lettuce - Cardinale',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Cardinale'],
    uses: ['salads', 'sandwiches', 'fresh']
  },
  {
    id: 'lettuce-red-velvet',
    name: 'Lettuce - Red Velvet',
    scientificName: 'Lactuca sativa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 10,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 6.8,
    companions: ['carrot', 'radish', 'strawberry', 'onion'],
    enemies: ['celery'],
    description: 'Red leaf lettuce. Full size heads, excellent flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Asteraceae',
    varieties: ['Red Velvet'],
    uses: ['salads', 'sandwiches', 'fresh']
  }
,
  {
    id: 'corn-honey-select',
    name: 'Corn - Honey Select',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'yellow Sugary Enhanced corn. Sweet and tender, good for home garden.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Honey Select'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-ambrosia',
    name: 'Corn - Ambrosia',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'bi-color Sugary Enhanced corn. Sweet and tender, good for home garden.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Ambrosia'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-peaches-and-cream',
    name: 'Corn - Peaches and Cream',
    scientificName: 'Zea mays',
    category: 'legume',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'bi-color Sugary Enhanced corn. Sweet and tender, good for home garden.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Peaches and Cream'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-bodacious',
    name: 'Corn - Bodacious',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'yellow Sugary Enhanced corn. Sweet and tender, good for home garden.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Bodacious'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-incredible',
    name: 'Corn - Incredible',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'yellow Sugary Enhanced corn. Sweet and tender, good for home garden.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Incredible'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-sugar-buns',
    name: 'Corn - Sugar Buns',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'yellow Sugary Enhanced corn. Sweet and tender, good for home garden.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Sugar Buns'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-champ',
    name: 'Corn - Champ',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'yellow Sugary Enhanced corn. Sweet and tender, good for home garden.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Champ'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-gotta-have-it',
    name: 'Corn - Gotta Have It',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 78,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'bi-color Sugary Enhanced corn. Sweet and tender, good for home garden.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Gotta Have It'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-luscious',
    name: 'Corn - Luscious',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'bi-color Sugary Enhanced corn. Sweet and tender, good for home garden.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Luscious'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-serendipity',
    name: 'Corn - Serendipity',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'tri-color Supersweet corn. Extra sweet, isolate from other corn.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Serendipity'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-honey-and-pearl',
    name: 'Corn - Honey and Pearl',
    scientificName: 'Zea mays',
    category: 'legume',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 78,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'bi-color Supersweet corn. Extra sweet, isolate from other corn.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Honey and Pearl'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-avalon',
    name: 'Corn - Avalon',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 78,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'bi-color Supersweet corn. Extra sweet, isolate from other corn.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Avalon'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-obsession',
    name: 'Corn - Obsession',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'bi-color Supersweet corn. Extra sweet, isolate from other corn.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Obsession'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-passion',
    name: 'Corn - Passion',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'bi-color Supersweet corn. Extra sweet, isolate from other corn.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Passion'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-temptation',
    name: 'Corn - Temptation',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'bi-color Supersweet corn. Extra sweet, isolate from other corn.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Temptation'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-precious-gem',
    name: 'Corn - Precious Gem',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 78,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'bi-color Supersweet corn. Extra sweet, isolate from other corn.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Precious Gem'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-honeycomb',
    name: 'Corn - Honeycomb',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 78,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'yellow Supersweet corn. Extra sweet, isolate from other corn.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Honeycomb'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-sweetness',
    name: 'Corn - Sweetness',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'white Supersweet corn. Extra sweet, isolate from other corn.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Sweetness'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-silver-queen',
    name: 'Corn - Silver Queen',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 92,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'white Standard corn. Classic sweet corn.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Silver Queen'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-stowells-evergreen',
    name: 'Corn - Stowells Evergreen',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'white Standard corn. Classic sweet corn.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Stowells Evergreen'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-country-gentleman',
    name: 'Corn - Country Gentleman',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'white Standard corn. Classic sweet corn.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Country Gentleman'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-golden-bantam',
    name: 'Corn - Golden Bantam',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'yellow Standard corn. Classic sweet corn.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Golden Bantam'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-early-sunglow',
    name: 'Corn - Early Sunglow',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'yellow Standard corn. Classic sweet corn.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Early Sunglow'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-truckers-favorite',
    name: 'Corn - Truckers Favorite',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'white Standard corn. Classic sweet corn.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Truckers Favorite'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-bloody-butcher',
    name: 'Corn - Bloody Butcher',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'red Field/Flint corn. Heirloom grain corn for grinding.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Bloody Butcher'],
    uses: ['grinding', 'decoration']
  },
  {
    id: 'corn-glass-gem',
    name: 'Corn - Glass Gem',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'multi Ornamental corn. Classic sweet corn.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Glass Gem'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-oaxacan-green',
    name: 'Corn - Oaxacan Green',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'green Field/Flint corn. Heirloom grain corn for grinding.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Oaxacan Green'],
    uses: ['grinding', 'decoration']
  },
  {
    id: 'corn-kulli',
    name: 'Corn - Kulli',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'purple Field/Flint corn. Heirloom grain corn for grinding.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Kulli'],
    uses: ['grinding', 'decoration']
  },
  {
    id: 'corn-blue-hopi',
    name: 'Corn - Blue Hopi',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'blue Field/Flint corn. Heirloom grain corn for grinding.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Blue Hopi'],
    uses: ['grinding', 'decoration']
  },
  {
    id: 'corn-flint-indian',
    name: 'Corn - Flint Indian',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'multi Field/Flint corn. Heirloom grain corn for grinding.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Flint Indian'],
    uses: ['grinding', 'decoration']
  },
  {
    id: 'corn-floriani-red',
    name: 'Corn - Floriani Red',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'red Field/Flint corn. Heirloom grain corn for grinding.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Floriani Red'],
    uses: ['grinding', 'decoration']
  },
  {
    id: 'corn-mandan-bride',
    name: 'Corn - Mandan Bride',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'multi Field/Flint corn. Heirloom grain corn for grinding.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Mandan Bride'],
    uses: ['grinding', 'decoration']
  },
  {
    id: 'corn-painted-mountain',
    name: 'Corn - Painted Mountain',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'multi Field/Flint corn. Heirloom grain corn for grinding.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Painted Mountain'],
    uses: ['grinding', 'decoration']
  },
  {
    id: 'corn-hopi-pink',
    name: 'Corn - Hopi Pink',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'pink Field/Flint corn. Heirloom grain corn for grinding.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Hopi Pink'],
    uses: ['grinding', 'decoration']
  },
  {
    id: 'corn-dakota-black',
    name: 'Corn - Dakota Black',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'black Field/Flint corn. Heirloom grain corn for grinding.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Dakota Black'],
    uses: ['grinding', 'decoration']
  },
  {
    id: 'corn-earth-tones',
    name: 'Corn - Earth Tones',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'multi Ornamental corn. Classic sweet corn.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Earth Tones'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-reid-yellow-dent',
    name: 'Corn - Reid Yellow Dent',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 110,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'yellow Ornamental corn. Classic sweet corn.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Reid Yellow Dent'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-ottofile',
    name: 'Corn - Ottofile',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'yellow Ornamental corn. Classic sweet corn.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Ottofile'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-eight-row-flint',
    name: 'Corn - Eight Row Flint',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 12,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'multi Ornamental corn. Classic sweet corn.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Eight Row Flint'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-calico',
    name: 'Corn - Calico',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'multi Ornamental corn. Classic sweet corn.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Calico'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-indian-berries',
    name: 'Corn - Indian Berries',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'multi Ornamental corn. Classic sweet corn.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Indian Berries'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-mini-blue',
    name: 'Corn - Mini Blue',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'blue Popcorn corn. Hard kernels for popping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Mini Blue'],
    uses: ['popping', 'ornamental']
  },
  {
    id: 'corn-tom-thumb',
    name: 'Corn - Tom Thumb',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'multi Popcorn corn. Hard kernels for popping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Tom Thumb'],
    uses: ['popping', 'ornamental']
  },
  {
    id: 'corn-strawberry',
    name: 'Corn - Strawberry',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 100,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'red Popcorn corn. Hard kernels for popping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Strawberry'],
    uses: ['popping', 'ornamental']
  },
  {
    id: 'corn-robust-997',
    name: 'Corn - Robust 997',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 105,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'yellow Popcorn corn. Hard kernels for popping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Robust 997'],
    uses: ['popping', 'ornamental']
  },
  {
    id: 'corn-snow-puff',
    name: 'Corn - Snow Puff',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'white Popcorn corn. Hard kernels for popping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Snow Puff'],
    uses: ['popping', 'ornamental']
  },
  {
    id: 'corn-shaman-blue',
    name: 'Corn - Shaman Blue',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'blue Popcorn corn. Hard kernels for popping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Shaman Blue'],
    uses: ['popping', 'ornamental']
  },
  {
    id: 'corn-dakota-ivory',
    name: 'Corn - Dakota Ivory',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'white Popcorn corn. Hard kernels for popping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Dakota Ivory'],
    uses: ['popping', 'ornamental']
  },
  {
    id: 'corn-pennsylvania-dutch-butter',
    name: 'Corn - Pennsylvania Dutch Butter',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 95,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'yellow Popcorn corn. Hard kernels for popping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Pennsylvania Dutch Butter'],
    uses: ['popping', 'ornamental']
  },
  {
    id: 'corn-japanese-hulless',
    name: 'Corn - Japanese Hulless',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'white Popcorn corn. Hard kernels for popping.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Japanese Hulless'],
    uses: ['popping', 'ornamental']
  },
  {
    id: 'corn-double-red-sweet',
    name: 'Corn - Double Red Sweet',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'red Sugary Enhanced corn. Sweet and tender, good for home garden.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Double Red Sweet'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-whiteout',
    name: 'Corn - Whiteout',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'white Sugary Enhanced corn. Sweet and tender, good for home garden.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Whiteout'],
    uses: ['fresh', 'grilling', 'freezing']
  },
  {
    id: 'corn-sparkler',
    name: 'Corn - Sparkler',
    scientificName: 'Zea mays',
    category: 'grain',
    spacing: 8,
    rowSpacing: 30,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 5.8,
    phMax: 6.8,
    companions: ['bean', 'cucumber', 'squash'],
    enemies: ['tomato'],
    description: 'bi-color Standard corn. Classic sweet corn.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-7 feet',
    spread: '12-18 inches',
    family: 'Poaceae',
    varieties: ['Sparkler'],
    uses: ['fresh', 'grilling', 'freezing']
  }
,
  {
    id: 'spinach-bloomsdale-long-standing',
    name: 'Spinach - Bloomsdale Long Standing',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'savoy spinach. Crinkled leaves, cold hardy. Full size leaves.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Bloomsdale Long Standing'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-bloomsdale',
    name: 'Spinach - Bloomsdale',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'savoy spinach. Crinkled leaves, cold hardy. Full size leaves.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Bloomsdale'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-america',
    name: 'Spinach - America',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'savoy spinach. Crinkled leaves, cold hardy. Full size leaves.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['America'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-melody',
    name: 'Spinach - Melody',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 42,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'savoy spinach. Crinkled leaves, cold hardy. Quick growing.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Melody'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-tyee',
    name: 'Spinach - Tyee',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'savoy spinach. Crinkled leaves, cold hardy. Full size leaves.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Tyee'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-indian-summer',
    name: 'Spinach - Indian Summer',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'savoy spinach. Crinkled leaves, cold hardy. Quick growing.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Indian Summer'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-space',
    name: 'Spinach - Space',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'savoy spinach. Crinkled leaves, cold hardy. Quick growing.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Space'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-corvair',
    name: 'Spinach - Corvair',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'savoy spinach. Crinkled leaves, cold hardy. Quick growing.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Corvair'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-renegade',
    name: 'Spinach - Renegade',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 42,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'savoy spinach. Crinkled leaves, cold hardy. Quick growing.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Renegade'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-avon',
    name: 'Spinach - Avon',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'savoy spinach. Crinkled leaves, cold hardy. Full size leaves.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Avon'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-emperor',
    name: 'Spinach - Emperor',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 48,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'savoy spinach. Crinkled leaves, cold hardy. Full size leaves.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Emperor'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-giant-winter',
    name: 'Spinach - Giant Winter',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'savoy spinach. Crinkled leaves, cold hardy. Full size leaves.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Giant Winter'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-winter-bloomsdale',
    name: 'Spinach - Winter Bloomsdale',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'savoy spinach. Crinkled leaves, cold hardy. Full size leaves.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Winter Bloomsdale'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-viroflay',
    name: 'Spinach - Viroflay',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'flat spinach. Reliable garden spinach. Quick growing.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Viroflay'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-monstrueux-de-viroflay',
    name: 'Spinach - Monstrueux de Viroflay',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'flat spinach. Reliable garden spinach. Full size leaves.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Monstrueux de Viroflay'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-giant-noble',
    name: 'Spinach - Giant Noble',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'flat spinach. Reliable garden spinach. Full size leaves.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Giant Noble'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-olympia',
    name: 'Spinach - Olympia',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'smooth spinach. Flat leaves, easy to clean. Quick growing.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Olympia'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-space',
    name: 'Spinach - Space',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'smooth spinach. Flat leaves, easy to clean. Quick growing.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Space'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-correnta',
    name: 'Spinach - Correnta',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 38,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'smooth spinach. Flat leaves, easy to clean. Quick growing.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Correnta'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-red-kitten',
    name: 'Spinach - Red Kitten',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'smooth spinach. Flat leaves, easy to clean. Quick growing.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Red Kitten'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-red-tabby',
    name: 'Spinach - Red Tabby',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'smooth spinach. Flat leaves, easy to clean. Quick growing.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Red Tabby'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-new-zealand',
    name: 'Spinach - New Zealand',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'perpetual spinach. Reliable garden spinach. Full size leaves.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['New Zealand'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-perpetual-spinach',
    name: 'Spinach - Perpetual Spinach',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'perpetual spinach. Reliable garden spinach. Full size leaves.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Perpetual Spinach'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-malabar',
    name: 'Spinach - Malabar',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'vine spinach. Reliable garden spinach. Full size leaves.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Malabar'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-basella',
    name: 'Spinach - Basella',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'vine spinach. Reliable garden spinach. Full size leaves.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Basella'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-teton',
    name: 'Spinach - Teton',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'hybrid spinach. Reliable garden spinach. Quick growing.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Teton'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-reflect',
    name: 'Spinach - Reflect',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 38,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'hybrid spinach. Reliable garden spinach. Quick growing.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Reflect'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-spinner',
    name: 'Spinach - Spinner',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'hybrid spinach. Reliable garden spinach. Quick growing.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Spinner'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-lizard',
    name: 'Spinach - Lizard',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 42,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'hybrid spinach. Reliable garden spinach. Quick growing.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Lizard'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-pigeon',
    name: 'Spinach - Pigeon',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'hybrid spinach. Reliable garden spinach. Quick growing.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Pigeon'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-seaside',
    name: 'Spinach - Seaside',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'hybrid spinach. Reliable garden spinach. Quick growing.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Seaside'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-cheetah',
    name: 'Spinach - Cheetah',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 38,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'hybrid spinach. Reliable garden spinach. Quick growing.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Cheetah'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-flamingo',
    name: 'Spinach - Flamingo',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'hybrid spinach. Reliable garden spinach. Quick growing.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Flamingo'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-kolibri',
    name: 'Spinach - Kolibri',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'hybrid spinach. Reliable garden spinach. Quick growing.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Kolibri'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-palco',
    name: 'Spinach - Palco',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 38,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'hybrid spinach. Reliable garden spinach. Quick growing.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Palco'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-regal',
    name: 'Spinach - Regal',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'hybrid spinach. Reliable garden spinach. Quick growing.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Regal'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-samish',
    name: 'Spinach - Samish',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'hybrid spinach. Reliable garden spinach. Quick growing.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Samish'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-skookum',
    name: 'Spinach - Skookum',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'hybrid spinach. Reliable garden spinach. Quick growing.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Skookum'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-unipack-151',
    name: 'Spinach - Unipack 151',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'hybrid spinach. Reliable garden spinach. Quick growing.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Unipack 151'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-whale',
    name: 'Spinach - Whale',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 42,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'hybrid spinach. Reliable garden spinach. Quick growing.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Whale'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-winter-giant',
    name: 'Spinach - Winter Giant',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'savoy spinach. Crinkled leaves, cold hardy. Full size leaves.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Winter Giant'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  },
  {
    id: 'spinach-mustard-spinach',
    name: 'Spinach - Mustard Spinach',
    scientificName: 'Spinacia oleracea',
    category: 'vegetable',
    spacing: 3,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['strawberry', 'onion'],
    enemies: ['potato'],
    description: 'asian spinach. Reliable garden spinach. Quick growing.',
    hardinessZones: '3-9',
    plantingSeason: 'spring',
    height: '6-10 inches',
    spread: '6-8 inches',
    family: 'Amaranthaceae',
    varieties: ['Mustard Spinach'],
    uses: ['salads', 'cooking', 'smoothies', 'freezing']
  }
,
  {
    id: 'kale-lacinato',
    name: 'Kale - Lacinato',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'blue-green dinosaur kale. Italian heirloom, bumpy leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Lacinato'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-dinosaur',
    name: 'Kale - Dinosaur',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'blue-green dinosaur kale. Italian heirloom, bumpy leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Dinosaur'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-toscano',
    name: 'Kale - Toscano',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'blue-green dinosaur kale. Italian heirloom, bumpy leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Toscano'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-nero-di-toscana',
    name: 'Kale - Nero di Toscana',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'blue-green dinosaur kale. Italian heirloom, bumpy leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Nero di Toscana'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-black-magic',
    name: 'Kale - Black Magic',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'blue-green dinosaur kale. Italian heirloom, bumpy leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Black Magic'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-dazzling-blue',
    name: 'Kale - Dazzling Blue',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'blue dinosaur kale. Italian heirloom, bumpy leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Dazzling Blue'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-premier',
    name: 'Kale - Premier',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green curly kale. Frilly leaves, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Premier'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-winterbor',
    name: 'Kale - Winterbor',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green curly kale. Frilly leaves, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Winterbor'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-starbor',
    name: 'Kale - Starbor',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green curly kale. Frilly leaves, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Starbor'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-dwarf-blue-curled',
    name: 'Kale - Dwarf Blue Curled',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'blue curly kale. Frilly leaves, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Dwarf Blue Curled'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-blue-knight',
    name: 'Kale - Blue Knight',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'blue curly kale. Frilly leaves, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Blue Knight'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-prizm',
    name: 'Kale - Prizm',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green curly kale. Frilly leaves, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Prizm'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-siberian',
    name: 'Kale - Siberian',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'blue-green flat kale. Nutritious superfood.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Siberian'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-red-russian',
    name: 'Kale - Red Russian',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'red flat kale. Nutritious superfood.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Red Russian'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-white-russian',
    name: 'Kale - White Russian',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'white flat kale. Nutritious superfood.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['White Russian'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-red-ursa',
    name: 'Kale - Red Ursa',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'red flat kale. Nutritious superfood.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Red Ursa'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-ragged-jack',
    name: 'Kale - Ragged Jack',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'red flat kale. Nutritious superfood.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Ragged Jack'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-scarlet',
    name: 'Kale - Scarlet',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'red ornamental kale. Beautiful colors, edible and decorative.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Scarlet'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-peacock-red',
    name: 'Kale - Peacock Red',
    scientificName: 'Brassica oleracea',
    category: 'legume',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'red ornamental kale. Beautiful colors, edible and decorative.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Peacock Red'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-peacock-white',
    name: 'Kale - Peacock White',
    scientificName: 'Brassica oleracea',
    category: 'legume',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'white ornamental kale. Beautiful colors, edible and decorative.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Peacock White'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-nagoya-red',
    name: 'Kale - Nagoya Red',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'red ornamental kale. Beautiful colors, edible and decorative.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Nagoya Red'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-nagoya-white',
    name: 'Kale - Nagoya White',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'white ornamental kale. Beautiful colors, edible and decorative.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Nagoya White'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-kamome-red',
    name: 'Kale - Kamome Red',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'red ornamental kale. Beautiful colors, edible and decorative.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Kamome Red'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-kamome-white',
    name: 'Kale - Kamome White',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'white ornamental kale. Beautiful colors, edible and decorative.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Kamome White'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-redbor',
    name: 'Kale - Redbor',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'red curly kale. Frilly leaves, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Redbor'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-purplebor',
    name: 'Kale - Purplebor',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'purple curly kale. Frilly leaves, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Purplebor'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-red-russian',
    name: 'Kale - Red Russian',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'red siberian kale. Flat leaves, tender, cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Red Russian'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-white-russian',
    name: 'Kale - White Russian',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'white siberian kale. Flat leaves, tender, cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['White Russian'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-red-ursa',
    name: 'Kale - Red Ursa',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'red siberian kale. Flat leaves, tender, cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Red Ursa'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-improved-dwarf-siberian',
    name: 'Kale - Improved Dwarf Siberian',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green siberian kale. Flat leaves, tender, cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Improved Dwarf Siberian'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-winter-red',
    name: 'Kale - Winter Red',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'red siberian kale. Flat leaves, tender, cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Winter Red'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-flash',
    name: 'Kale - Flash',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green hybrid kale. Nutritious superfood.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Flash'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-darkibor',
    name: 'Kale - Darkibor',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green hybrid kale. Nutritious superfood.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Darkibor'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-thousandheads',
    name: 'Kale - Thousandheads',
    scientificName: 'Brassica oleracea var. costata',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green portuguese kale. Nutritious superfood.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Thousandheads'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-tronchuda-beira',
    name: 'Kale - Tronchuda Beira',
    scientificName: 'Brassica oleracea var. costata',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green portuguese kale. Nutritious superfood.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Tronchuda Beira'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-portuguese-cabbage',
    name: 'Kale - Portuguese Cabbage',
    scientificName: 'Brassica oleracea var. costata',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green portuguese kale. Nutritious superfood.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Portuguese Cabbage'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-galega-de-folhas-lisas',
    name: 'Kale - Galega de Folhas Lisas',
    scientificName: 'Brassica oleracea var. costata',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green portuguese kale. Nutritious superfood.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Galega de Folhas Lisas'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-walking-stick',
    name: 'Kale - Walking Stick',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green tall kale. Nutritious superfood.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '3-6 feet',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Walking Stick'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-asparagus-kale',
    name: 'Kale - Asparagus Kale',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green perennial kale. Multi-year harvest from one plant.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '2-3 feet',
    family: 'Brassicaceae',
    varieties: ['Asparagus Kale'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-daubenton',
    name: 'Kale - Daubenton',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green perennial kale. Multi-year harvest from one plant.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '2-3 feet',
    family: 'Brassicaceae',
    varieties: ['Daubenton'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-taunton-deane',
    name: 'Kale - Taunton Deane',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 24,
    rowSpacing: 36,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green perennial kale. Multi-year harvest from one plant.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '2-3 feet',
    family: 'Brassicaceae',
    varieties: ['Taunton Deane'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  },
  {
    id: 'kale-pentland-brig',
    name: 'Kale - Pentland Brig',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['herbs', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green curly kale. Frilly leaves, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-24 inches',
    family: 'Brassicaceae',
    varieties: ['Pentland Brig'],
    uses: ['cooking', 'salads', 'chips', 'smoothies', 'juicing']
  }
,
  {
    id: 'broccoli-calabrese',
    name: 'Broccoli - Calabrese',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'heirloom broccoli. Classic Italian heirloom, large heads with side shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Calabrese'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-green-magic',
    name: 'Broccoli - Green Magic',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Green Magic'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-belstar',
    name: 'Broccoli - Belstar',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Belstar'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-packman',
    name: 'Broccoli - Packman',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Packman'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-premium-crop',
    name: 'Broccoli - Premium Crop',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Premium Crop'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-arcadia',
    name: 'Broccoli - Arcadia',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Arcadia'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-marathon',
    name: 'Broccoli - Marathon',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 68,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Marathon'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-diplomat',
    name: 'Broccoli - Diplomat',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Diplomat'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-lieutenant',
    name: 'Broccoli - Lieutenant',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Lieutenant'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-imperial',
    name: 'Broccoli - Imperial',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Imperial'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-green-goliath',
    name: 'Broccoli - Green Goliath',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Green Goliath'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-nutribud',
    name: 'Broccoli - Nutribud',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Nutribud'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-pirate',
    name: 'Broccoli - Pirate',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Pirate'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-sessantina-grossa',
    name: 'Broccoli - Sessantina Grossa',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Sessantina Grossa'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-sun-king',
    name: 'Broccoli - Sun King',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Sun King'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-gypsy',
    name: 'Broccoli - Gypsy',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Gypsy'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-blue-wind',
    name: 'Broccoli - Blue Wind',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Blue Wind'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-bay-meadows',
    name: 'Broccoli - Bay Meadows',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Bay Meadows'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-burgundy',
    name: 'Broccoli - Burgundy',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'sprouting broccoli. Produces many small purple or white heads over extended harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Burgundy'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-purple-sprouting',
    name: 'Broccoli - Purple Sprouting',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'sprouting broccoli. Produces many small purple or white heads over extended harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Purple Sprouting'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-early-purple-sprouting',
    name: 'Broccoli - Early Purple Sprouting',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'sprouting broccoli. Produces many small purple or white heads over extended harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Early Purple Sprouting'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-rudolph',
    name: 'Broccoli - Rudolph',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'sprouting broccoli. Produces many small purple or white heads over extended harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Rudolph'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-santee',
    name: 'Broccoli - Santee',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'sprouting broccoli. Produces many small purple or white heads over extended harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Santee'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-red-fire',
    name: 'Broccoli - Red Fire',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'sprouting broccoli. Produces many small purple or white heads over extended harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Red Fire'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-red-arrow',
    name: 'Broccoli - Red Arrow',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'sprouting broccoli. Produces many small purple or white heads over extended harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Red Arrow'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-red-spear',
    name: 'Broccoli - Red Spear',
    scientificName: 'Brassica oleracea',
    category: 'legume',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'sprouting broccoli. Produces many small purple or white heads over extended harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Red Spear'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-early-dividend',
    name: 'Broccoli - Early Dividend',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Early Dividend'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-everest',
    name: 'Broccoli - Everest',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Everest'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-fiesta',
    name: 'Broccoli - Fiesta',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Fiesta'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-green-duke',
    name: 'Broccoli - Green Duke',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Green Duke'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-ironman',
    name: 'Broccoli - Ironman',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Ironman'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-legacy',
    name: 'Broccoli - Legacy',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Legacy'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-major',
    name: 'Broccoli - Major',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Major'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-montop',
    name: 'Broccoli - Montop',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Montop'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-patriot',
    name: 'Broccoli - Patriot',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Patriot'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-tahoe',
    name: 'Broccoli - Tahoe',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Tahoe'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-windsor',
    name: 'Broccoli - Windsor',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Windsor'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-amadeus',
    name: 'Broccoli - Amadeus',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Amadeus'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-belstar-f1',
    name: 'Broccoli - Belstar F1',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Belstar F1'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  },
  {
    id: 'broccoli-blue-wonder',
    name: 'Broccoli - Blue Wonder',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['onion', 'celery', 'beet'],
    enemies: ['strawberry', 'tomato'],
    description: 'hybrid broccoli. Disease resistant, uniform heads, reliable producer.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Blue Wonder'],
    uses: ['fresh', 'cooking', 'freezing', 'steaming']
  }
,
  {
    id: 'cauliflower-snowball-y',
    name: 'Cauliflower - Snowball Y',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'white cauliflower. Classic white, blanch by tying leaves over curd.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Snowball Y'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-snowball-self-blanching',
    name: 'Cauliflower - Snowball Self-Blanching',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'white cauliflower. Classic white, blanch by tying leaves over curd.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Snowball Self-Blanching'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-early-snowball',
    name: 'Cauliflower - Early Snowball',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'white cauliflower. Classic white, blanch by tying leaves over curd.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Early Snowball'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-snow-crown',
    name: 'Cauliflower - Snow Crown',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'hybrid cauliflower. Classic white, blanch by tying leaves over curd.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Snow Crown'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-cheddar',
    name: 'Cauliflower - Cheddar',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'orange cauliflower. Beta-carotene rich, mild and sweet.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Cheddar'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-graffiti',
    name: 'Cauliflower - Graffiti',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'purple cauliflower. Vibrant purple, turns green when cooked, high antioxidants.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Graffiti'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-veronica',
    name: 'Cauliflower - Veronica',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'romanesco cauliflower. Stunning fractal pattern, nutty flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Veronica'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-romanesco',
    name: 'Cauliflower - Romanesco',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'romanesco cauliflower. Stunning fractal pattern, nutty flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Romanesco'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-violet-queen',
    name: 'Cauliflower - Violet Queen',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'purple cauliflower. Vibrant purple, turns green when cooked, high antioxidants.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Violet Queen'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-snowball-improved',
    name: 'Cauliflower - Snowball Improved',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'white cauliflower. Classic white, blanch by tying leaves over curd.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Snowball Improved'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-amazing',
    name: 'Cauliflower - Amazing',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'hybrid cauliflower. Classic white, blanch by tying leaves over curd.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Amazing'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-attribute',
    name: 'Cauliflower - Attribute',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'hybrid cauliflower. Classic white, blanch by tying leaves over curd.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Attribute'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-autumn-giant',
    name: 'Cauliflower - Autumn Giant',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'white cauliflower. Classic white, blanch by tying leaves over curd.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Autumn Giant'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-bishop',
    name: 'Cauliflower - Bishop',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'hybrid cauliflower. Classic white, blanch by tying leaves over curd.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Bishop'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-casper',
    name: 'Cauliflower - Casper',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'white cauliflower. Classic white, blanch by tying leaves over curd.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Casper'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-depurple-hybrid',
    name: 'Cauliflower - Depurple Hybrid',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'purple cauliflower. Vibrant purple, turns green when cooked, high antioxidants.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Depurple Hybrid'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-fremont',
    name: 'Cauliflower - Fremont',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'hybrid cauliflower. Classic white, blanch by tying leaves over curd.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Fremont'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-freedom',
    name: 'Cauliflower - Freedom',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'hybrid cauliflower. Classic white, blanch by tying leaves over curd.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Freedom'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-giant-of-naples',
    name: 'Cauliflower - Giant of Naples',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'white cauliflower. Classic white, blanch by tying leaves over curd.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Giant of Naples'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-graffiti',
    name: 'Cauliflower - Graffiti',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'purple cauliflower. Vibrant purple, turns green when cooked, high antioxidants.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Graffiti'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-lavender',
    name: 'Cauliflower - Lavender',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'purple cauliflower. Vibrant purple, turns green when cooked, high antioxidants.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Lavender'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-minuteman',
    name: 'Cauliflower - Minuteman',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'hybrid cauliflower. Classic white, blanch by tying leaves over curd.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Minuteman'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-multi-head',
    name: 'Cauliflower - Multi-Head',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'white cauliflower. Classic white, blanch by tying leaves over curd.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Multi-Head'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-panther',
    name: 'Cauliflower - Panther',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'hybrid cauliflower. Classic white, blanch by tying leaves over curd.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Panther'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-purple-cape',
    name: 'Cauliflower - Purple Cape',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'purple cauliflower. Vibrant purple, turns green when cooked, high antioxidants.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Purple Cape'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-skywalker',
    name: 'Cauliflower - Skywalker',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'hybrid cauliflower. Classic white, blanch by tying leaves over curd.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Skywalker'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-snowball-a',
    name: 'Cauliflower - Snowball A',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'white cauliflower. Classic white, blanch by tying leaves over curd.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Snowball A'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-snowball-early',
    name: 'Cauliflower - Snowball Early',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'white cauliflower. Classic white, blanch by tying leaves over curd.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Snowball Early'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-snowball-x',
    name: 'Cauliflower - Snowball X',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'white cauliflower. Classic white, blanch by tying leaves over curd.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Snowball X'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-snowball-y-improved',
    name: 'Cauliflower - Snowball Y Improved',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'white cauliflower. Classic white, blanch by tying leaves over curd.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Snowball Y Improved'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-snowberry',
    name: 'Cauliflower - Snowberry',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'hybrid cauliflower. Classic white, blanch by tying leaves over curd.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Snowberry'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-snowcrown',
    name: 'Cauliflower - Snowcrown',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'hybrid cauliflower. Classic white, blanch by tying leaves over curd.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Snowcrown'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-synergy',
    name: 'Cauliflower - Synergy',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'hybrid cauliflower. Classic white, blanch by tying leaves over curd.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Synergy'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-tango',
    name: 'Cauliflower - Tango',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'hybrid cauliflower. Classic white, blanch by tying leaves over curd.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Tango'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-twister',
    name: 'Cauliflower - Twister',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'romanesco cauliflower. Stunning fractal pattern, nutty flavor.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Twister'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-violet-queen',
    name: 'Cauliflower - Violet Queen',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'purple cauliflower. Vibrant purple, turns green when cooked, high antioxidants.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Violet Queen'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-white-corona',
    name: 'Cauliflower - White Corona',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'white cauliflower. Classic white, blanch by tying leaves over curd.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['White Corona'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-white-express',
    name: 'Cauliflower - White Express',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 55,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'white cauliflower. Classic white, blanch by tying leaves over curd.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['White Express'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-white-rock',
    name: 'Cauliflower - White Rock',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'white cauliflower. Classic white, blanch by tying leaves over curd.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['White Rock'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  },
  {
    id: 'cauliflower-white-cloud',
    name: 'Cauliflower - White Cloud',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['celery', 'onion'],
    enemies: ['strawberry'],
    description: 'white cauliflower. Classic white, blanch by tying leaves over curd.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['White Cloud'],
    uses: ['cooking', 'roasting', 'raw', 'salads']
  }
,
  {
    id: 'cabbage-golden-acre',
    name: 'Cabbage - Golden Acre',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green cabbage. Classic green cabbage, versatile for cooking and slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Golden Acre'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-copenhagen-market',
    name: 'Cabbage - Copenhagen Market',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green cabbage. Classic green cabbage, versatile for cooking and slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Copenhagen Market'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-early-jersey-wakefield',
    name: 'Cabbage - Early Jersey Wakefield',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green cabbage. Classic green cabbage, versatile for cooking and slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Early Jersey Wakefield'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-daneshead',
    name: 'Cabbage - Daneshead',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green cabbage. Classic green cabbage, versatile for cooking and slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Daneshead'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-stonehead',
    name: 'Cabbage - Stonehead',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green cabbage. Classic green cabbage, versatile for cooking and slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Stonehead'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-blue-vantage',
    name: 'Cabbage - Blue Vantage',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green cabbage. Classic green cabbage, versatile for cooking and slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Blue Vantage'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-bravo',
    name: 'Cabbage - Bravo',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green cabbage. Classic green cabbage, versatile for cooking and slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Bravo'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-bronco',
    name: 'Cabbage - Bronco',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green cabbage. Classic green cabbage, versatile for cooking and slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Bronco'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-capture',
    name: 'Cabbage - Capture',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green cabbage. Classic green cabbage, versatile for cooking and slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Capture'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-cheers',
    name: 'Cabbage - Cheers',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green cabbage. Classic green cabbage, versatile for cooking and slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Cheers'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-conquistador',
    name: 'Cabbage - Conquistador',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green cabbage. Classic green cabbage, versatile for cooking and slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Conquistador'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-copperhead',
    name: 'Cabbage - Copperhead',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green cabbage. Classic green cabbage, versatile for cooking and slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Copperhead'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-crosscut',
    name: 'Cabbage - Crosscut',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green cabbage. Classic green cabbage, versatile for cooking and slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Crosscut'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-defender',
    name: 'Cabbage - Defender',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green cabbage. Classic green cabbage, versatile for cooking and slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Defender'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-dimension',
    name: 'Cabbage - Dimension',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green cabbage. Classic green cabbage, versatile for cooking and slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Dimension'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-diplomat',
    name: 'Cabbage - Diplomat',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green cabbage. Classic green cabbage, versatile for cooking and slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Diplomat'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-dynasty',
    name: 'Cabbage - Dynasty',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green cabbage. Classic green cabbage, versatile for cooking and slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Dynasty'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-emblem',
    name: 'Cabbage - Emblem',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green cabbage. Classic green cabbage, versatile for cooking and slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Emblem'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-excelsior',
    name: 'Cabbage - Excelsior',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green cabbage. Classic green cabbage, versatile for cooking and slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Excelsior'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-famosa',
    name: 'Cabbage - Famosa',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green cabbage. Classic green cabbage, versatile for cooking and slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Famosa'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-fast-vantage',
    name: 'Cabbage - Fast Vantage',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green cabbage. Classic green cabbage, versatile for cooking and slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Fast Vantage'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-farao',
    name: 'Cabbage - Farao',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green cabbage. Classic green cabbage, versatile for cooking and slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Farao'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-gourmet',
    name: 'Cabbage - Gourmet',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green cabbage. Classic green cabbage, versatile for cooking and slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Gourmet'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-green-boy',
    name: 'Cabbage - Green Boy',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green cabbage. Classic green cabbage, versatile for cooking and slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Green Boy'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-green-coronet',
    name: 'Cabbage - Green Coronet',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green cabbage. Classic green cabbage, versatile for cooking and slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Green Coronet'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-green-express',
    name: 'Cabbage - Green Express',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green cabbage. Classic green cabbage, versatile for cooking and slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Green Express'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-green-flash',
    name: 'Cabbage - Green Flash',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green cabbage. Classic green cabbage, versatile for cooking and slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Green Flash'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-green-gem',
    name: 'Cabbage - Green Gem',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green cabbage. Classic green cabbage, versatile for cooking and slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Green Gem'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-golden-cross',
    name: 'Cabbage - Golden Cross',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'yellow cabbage. Sweet and mild, early variety. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Golden Cross'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-premium-late-dutch',
    name: 'Cabbage - Premium Late Dutch',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'green cabbage. Classic green cabbage, versatile for cooking and slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Premium Late Dutch'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-january-king',
    name: 'Cabbage - January King',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 100,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'red cabbage. Beautiful purple-red, great for slaw and pickling. Storage variety, keeps for months.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['January King'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-deadon',
    name: 'Cabbage - Deadon',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 95,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'red cabbage. Beautiful purple-red, great for slaw and pickling. Storage variety, keeps for months.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Deadon'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-integro',
    name: 'Cabbage - Integro',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 95,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'red cabbage. Beautiful purple-red, great for slaw and pickling. Storage variety, keeps for months.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Integro'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-marner-lagerrot',
    name: 'Cabbage - Marner Lagerrot',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 95,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'red cabbage. Beautiful purple-red, great for slaw and pickling. Storage variety, keeps for months.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Marner Lagerrot'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-red-acre',
    name: 'Cabbage - Red Acre',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'red cabbage. Beautiful purple-red, great for slaw and pickling. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Red Acre'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-red-dynasty',
    name: 'Cabbage - Red Dynasty',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'red cabbage. Beautiful purple-red, great for slaw and pickling. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Red Dynasty'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-red-express',
    name: 'Cabbage - Red Express',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 65,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'red cabbage. Beautiful purple-red, great for slaw and pickling. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Red Express'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-red-jewel',
    name: 'Cabbage - Red Jewel',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'red cabbage. Beautiful purple-red, great for slaw and pickling. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Red Jewel'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-red-meteor',
    name: 'Cabbage - Red Meteor',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'red cabbage. Beautiful purple-red, great for slaw and pickling. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Red Meteor'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-red-perfection',
    name: 'Cabbage - Red Perfection',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'red cabbage. Beautiful purple-red, great for slaw and pickling. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Red Perfection'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-ruby-perfection',
    name: 'Cabbage - Ruby Perfection',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'red cabbage. Beautiful purple-red, great for slaw and pickling. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Ruby Perfection'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-savoy-ace',
    name: 'Cabbage - Savoy Ace',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'savoy cabbage. Crinkled leaves, tender and mild, excellent for slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Savoy Ace'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-savoy-king',
    name: 'Cabbage - Savoy King',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'savoy cabbage. Crinkled leaves, tender and mild, excellent for slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Savoy King'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-savoy-queen',
    name: 'Cabbage - Savoy Queen',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'savoy cabbage. Crinkled leaves, tender and mild, excellent for slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Savoy Queen'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-alcosa',
    name: 'Cabbage - Alcosa',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'savoy cabbage. Crinkled leaves, tender and mild, excellent for slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Alcosa'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-best-of-all',
    name: 'Cabbage - Best of All',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'savoy cabbage. Crinkled leaves, tender and mild, excellent for slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Best of All'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-castello',
    name: 'Cabbage - Castello',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'savoy cabbage. Crinkled leaves, tender and mild, excellent for slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Castello'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-chieftain',
    name: 'Cabbage - Chieftain',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 85,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'savoy cabbage. Crinkled leaves, tender and mild, excellent for slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Chieftain'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-deseo',
    name: 'Cabbage - Deseo',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'savoy cabbage. Crinkled leaves, tender and mild, excellent for slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Deseo'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  },
  {
    id: 'cabbage-famosa',
    name: 'Cabbage - Famosa',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'dill', 'onion'],
    enemies: ['strawberry', 'tomato'],
    description: 'savoy cabbage. Crinkled leaves, tender and mild, excellent for slaw. Early variety, quick harvest.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Famosa'],
    uses: ['slaw', 'cooking', 'fermenting', 'sauerkraut', 'storage']
  }
,
  {
    id: 'swiss-chard-bright-lights',
    name: 'Swiss Chard - Bright Lights',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'mixed Swiss chard. Rainbow of stem colors, beautiful and tasty. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Bright Lights'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-rainbow',
    name: 'Swiss Chard - Rainbow',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'mixed Swiss chard. Rainbow of stem colors, beautiful and tasty. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Rainbow'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-five-color-silverbeet',
    name: 'Swiss Chard - Five Color Silverbeet',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'mixed Swiss chard. Rainbow of stem colors, beautiful and tasty. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Five Color Silverbeet'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-neon-glow',
    name: 'Swiss Chard - Neon Glow',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'mixed Swiss chard. Rainbow of stem colors, beautiful and tasty. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Neon Glow'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-celebration',
    name: 'Swiss Chard - Celebration',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'mixed Swiss chard. Rainbow of stem colors, beautiful and tasty. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Celebration'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-fantasy',
    name: 'Swiss Chard - Fantasy',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'mixed Swiss chard. Rainbow of stem colors, beautiful and tasty. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Fantasy'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-peppermint-stick',
    name: 'Swiss Chard - Peppermint Stick',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'pink Swiss chard. Vibrant red stems, mild flavor. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Peppermint Stick'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-pink-lipstick',
    name: 'Swiss Chard - Pink Lipstick',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'pink Swiss chard. Vibrant red stems, mild flavor. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Pink Lipstick'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-flamingo-pink',
    name: 'Swiss Chard - Flamingo Pink',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'pink Swiss chard. Vibrant red stems, mild flavor. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Flamingo Pink'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-magenta-sunset',
    name: 'Swiss Chard - Magenta Sunset',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'magenta Swiss chard. Vibrant red stems, mild flavor. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Magenta Sunset'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-rhubarb-red',
    name: 'Swiss Chard - Rhubarb Red',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'red Swiss chard. Vibrant red stems, mild flavor. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Rhubarb Red'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-ruby-red',
    name: 'Swiss Chard - Ruby Red',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'red Swiss chard. Vibrant red stems, mild flavor. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Ruby Red'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-charlotte',
    name: 'Swiss Chard - Charlotte',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'red Swiss chard. Vibrant red stems, mild flavor. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Charlotte'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-vulcan',
    name: 'Swiss Chard - Vulcan',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'red Swiss chard. Vibrant red stems, mild flavor. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Vulcan'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-red-magic',
    name: 'Swiss Chard - Red Magic',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'red Swiss chard. Vibrant red stems, mild flavor. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Red Magic'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-scarlet',
    name: 'Swiss Chard - Scarlet',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'red Swiss chard. Vibrant red stems, mild flavor. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Scarlet'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-golden',
    name: 'Swiss Chard - Golden',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'yellow Swiss chard. Bright stems, mild and sweet. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Golden'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-oriole',
    name: 'Swiss Chard - Oriole',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'orange Swiss chard. Bright stems, mild and sweet. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Oriole'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-canary-yellow',
    name: 'Swiss Chard - Canary Yellow',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'yellow Swiss chard. Bright stems, mild and sweet. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Canary Yellow'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-el-dorado',
    name: 'Swiss Chard - El Dorado',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'yellow Swiss chard. Bright stems, mild and sweet. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['El Dorado'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-fordhook-giant',
    name: 'Swiss Chard - Fordhook Giant',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'white Swiss chard. Classic white stems, reliable producer. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Fordhook Giant'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-lucullus',
    name: 'Swiss Chard - Lucullus',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'white Swiss chard. Classic white stems, reliable producer. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Lucullus'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-giant-fordhook',
    name: 'Swiss Chard - Giant Fordhook',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'white Swiss chard. Classic white stems, reliable producer. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Giant Fordhook'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-large-white-ribbed',
    name: 'Swiss Chard - Large White Ribbed',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'white Swiss chard. Classic white stems, reliable producer. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Large White Ribbed'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-perpetual-spinach',
    name: 'Swiss Chard - Perpetual Spinach',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'green Swiss chard. Classic white stems, reliable producer. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Perpetual Spinach'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-erbette',
    name: 'Swiss Chard - Erbette',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'green Swiss chard. Classic white stems, reliable producer. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Erbette'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-verde-da-taglio',
    name: 'Swiss Chard - Verde da Taglio',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'green Swiss chard. Classic white stems, reliable producer. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Verde da Taglio'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-bionda-di-lione',
    name: 'Swiss Chard - Bionda di Lione',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'yellow Swiss chard. Bright stems, mild and sweet. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Bionda di Lione'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-barese',
    name: 'Swiss Chard - Barese',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'white Swiss chard. Classic white stems, reliable producer. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Barese'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-bianco-verde',
    name: 'Swiss Chard - Bianco Verde',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'white Swiss chard. Classic white stems, reliable producer. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Bianco Verde'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-cardoon',
    name: 'Swiss Chard - Cardoon',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'specialty Swiss chard. Classic white stems, reliable producer. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Cardoon'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-argentata',
    name: 'Swiss Chard - Argentata',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'white Swiss chard. Classic white stems, reliable producer. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Argentata'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-piacenza',
    name: 'Swiss Chard - Piacenza',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'white Swiss chard. Classic white stems, reliable producer. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Piacenza'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-ravenna',
    name: 'Swiss Chard - Ravenna',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'white Swiss chard. Classic white stems, reliable producer. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Ravenna'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-verde-a-costa-bianca',
    name: 'Swiss Chard - Verde a Costa Bianca',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'white Swiss chard. Classic white stems, reliable producer. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Verde a Costa Bianca'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-verde-a-costa-argento',
    name: 'Swiss Chard - Verde a Costa Argento',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'white Swiss chard. Classic white stems, reliable producer. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Verde a Costa Argento'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-rainbow-lights',
    name: 'Swiss Chard - Rainbow Lights',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'mixed Swiss chard. Rainbow of stem colors, beautiful and tasty. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Rainbow Lights'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-bright-yellow',
    name: 'Swiss Chard - Bright Yellow',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'yellow Swiss chard. Bright stems, mild and sweet. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Bright Yellow'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-orange-fantasia',
    name: 'Swiss Chard - Orange Fantasia',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'orange Swiss chard. Bright stems, mild and sweet. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Orange Fantasia'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  },
  {
    id: 'swiss-chard-magenta',
    name: 'Swiss Chard - Magenta',
    scientificName: 'Beta vulgaris',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion', 'lettuce', 'carrot'],
    enemies: [],
    description: 'magenta Swiss chard. Vibrant red stems, mild flavor. Heat and cold tolerant, harvest all season.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '18-24 inches',
    spread: '12-18 inches',
    family: 'Amaranthaceae',
    varieties: ['Magenta'],
    uses: ['greens', 'cooking', 'salads', 'saute', 'quiche']
  }
,
  {
    id: 'collard-georgia-southern',
    name: 'Collard - Georgia Southern',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'green collard greens. Large blue-green leaves, Southern staple. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Georgia Southern'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  },
  {
    id: 'collard-vates',
    name: 'Collard - Vates',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'green collard greens. Large blue-green leaves, Southern staple. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Vates'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  },
  {
    id: 'collard-morris-heading',
    name: 'Collard - Morris Heading',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'green collard greens. Large blue-green leaves, Southern staple. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Morris Heading'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  },
  {
    id: 'collard-champion',
    name: 'Collard - Champion',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'green collard greens. Large blue-green leaves, Southern staple. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Champion'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  },
  {
    id: 'collard-blue-max',
    name: 'Collard - Blue Max',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'blue collard greens. Blue-green leaves, very cold hardy. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Blue Max'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  },
  {
    id: 'collard-flash',
    name: 'Collard - Flash',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'green collard greens. Large blue-green leaves, Southern staple. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Flash'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  },
  {
    id: 'collard-top-bunch',
    name: 'Collard - Top Bunch',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'green collard greens. Large blue-green leaves, Southern staple. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Top Bunch'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  },
  {
    id: 'collard-hi-crop',
    name: 'Collard - Hi Crop',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'green collard greens. Large blue-green leaves, Southern staple. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Hi Crop'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  },
  {
    id: 'collard-hevi-crop',
    name: 'Collard - Hevi Crop',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'green collard greens. Large blue-green leaves, Southern staple. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Hevi Crop'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  },
  {
    id: 'collard-tiger',
    name: 'Collard - Tiger',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'green collard greens. Large blue-green leaves, Southern staple. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Tiger'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  },
  {
    id: 'collard-hybrid-6',
    name: 'Collard - Hybrid 6',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'green collard greens. Large blue-green leaves, Southern staple. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Hybrid 6'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  },
  {
    id: 'collard-hybrid-10',
    name: 'Collard - Hybrid 10',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'green collard greens. Large blue-green leaves, Southern staple. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Hybrid 10'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  },
  {
    id: 'collard-asteroid',
    name: 'Collard - Asteroid',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'green collard greens. Large blue-green leaves, Southern staple. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Asteroid'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  },
  {
    id: 'collard-bulldog',
    name: 'Collard - Bulldog',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'green collard greens. Large blue-green leaves, Southern staple. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Bulldog'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  },
  {
    id: 'collard-cabbage-collard',
    name: 'Collard - Cabbage Collard',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'green collard greens. Large blue-green leaves, Southern staple. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Cabbage Collard'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  },
  {
    id: 'collard-carolina',
    name: 'Collard - Carolina',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'green collard greens. Large blue-green leaves, Southern staple. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Carolina'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  },
  {
    id: 'collard-cathedral',
    name: 'Collard - Cathedral',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'green collard greens. Large blue-green leaves, Southern staple. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Cathedral'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  },
  {
    id: 'collard-couve-tronchuda',
    name: 'Collard - Couve Tronchuda',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'portuguese collard greens. Large blue-green leaves, Southern staple. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Couve Tronchuda'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  },
  {
    id: 'collard-glorious',
    name: 'Collard - Glorious',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'green collard greens. Large blue-green leaves, Southern staple. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Glorious'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  },
  {
    id: 'collard-green-glaze',
    name: 'Collard - Green Glaze',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'green collard greens. Large blue-green leaves, Southern staple. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Green Glaze'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  },
  {
    id: 'collard-hicote',
    name: 'Collard - Hicote',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'green collard greens. Large blue-green leaves, Southern staple. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Hicote'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  },
  {
    id: 'collard-long-standing',
    name: 'Collard - Long Standing',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'green collard greens. Large blue-green leaves, Southern staple. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Long Standing'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  },
  {
    id: 'collard-macgregor',
    name: 'Collard - MacGregor',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'green collard greens. Large blue-green leaves, Southern staple. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['MacGregor'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  },
  {
    id: 'collard-old-timey-blue',
    name: 'Collard - Old Timey Blue',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'blue collard greens. Blue-green leaves, very cold hardy. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Old Timey Blue'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  },
  {
    id: 'collard-principe',
    name: 'Collard - Principe',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'green collard greens. Large blue-green leaves, Southern staple. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Principe'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  },
  {
    id: 'collard-sabel',
    name: 'Collard - Sabel',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 70,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'green collard greens. Large blue-green leaves, Southern staple. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Sabel'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  },
  {
    id: 'collard-sandringham',
    name: 'Collard - Sandringham',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'green collard greens. Large blue-green leaves, Southern staple. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Sandringham'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  },
  {
    id: 'collard-variegated',
    name: 'Collard - Variegated',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'variegated collard greens. Large blue-green leaves, Southern staple. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Variegated'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  },
  {
    id: 'collard-whaleys',
    name: 'Collard - Whaleys',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 75,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'green collard greens. Large blue-green leaves, Southern staple. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Whaleys'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  },
  {
    id: 'collard-yellow-cabbage',
    name: 'Collard - Yellow Cabbage',
    scientificName: 'Brassica oleracea',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 10,
    daysToHarvest: 80,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['onion'],
    enemies: ['strawberry'],
    description: 'yellow collard greens. Unique yellow-green, mild flavor. Very cold hardy, flavor improves after frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '24-36 inches',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Yellow Cabbage'],
    uses: ['cooking', 'greens', 'soup', 'saute', 'soul food']
  }
,
  {
    id: 'bok-choy-joi-choi',
    name: 'Bok Choy - Joi Choi',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'standard bok choy. Classic Chinese cabbage, crisp and mild. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Joi Choi'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  },
  {
    id: 'bok-choy-mei-qing-choi',
    name: 'Bok Choy - Mei Qing Choi',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'standard bok choy. Classic Chinese cabbage, crisp and mild. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Mei Qing Choi'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  },
  {
    id: 'bok-choy-black-summer',
    name: 'Bok Choy - Black Summer',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'standard bok choy. Classic Chinese cabbage, crisp and mild. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Black Summer'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  },
  {
    id: 'bok-choy-win-win-choi',
    name: 'Bok Choy - Win Win Choi',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'standard bok choy. Classic Chinese cabbage, crisp and mild. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Win Win Choi'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  },
  {
    id: 'bok-choy-rosie',
    name: 'Bok Choy - Rosie',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'red bok choy. Beautiful colored stems, mild flavor. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Rosie'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  },
  {
    id: 'bok-choy-red-choi',
    name: 'Bok Choy - Red Choi',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'red bok choy. Beautiful colored stems, mild flavor. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Red Choi'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  },
  {
    id: 'bok-choy-violetta',
    name: 'Bok Choy - Violetta',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'purple bok choy. Beautiful colored stems, mild flavor. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Violetta'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  },
  {
    id: 'bok-choy-purple-choi',
    name: 'Bok Choy - Purple Choi',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'purple bok choy. Beautiful colored stems, mild flavor. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Purple Choi'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  },
  {
    id: 'bok-choy-toy-choi',
    name: 'Bok Choy - Toy Choi',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'baby bok choy. Mini size, tender and sweet, quick growing. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '4-6 inches',
    family: 'Brassicaceae',
    varieties: ['Toy Choi'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  },
  {
    id: 'bok-choy-li-ren-choi',
    name: 'Bok Choy - Li Ren Choi',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'baby bok choy. Mini size, tender and sweet, quick growing. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '4-6 inches',
    family: 'Brassicaceae',
    varieties: ['Li Ren Choi'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  },
  {
    id: 'bok-choy-extra-dwarf',
    name: 'Bok Choy - Extra Dwarf',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 7,
    daysToHarvest: 35,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'baby bok choy. Mini size, tender and sweet, quick growing. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '4-6 inches',
    family: 'Brassicaceae',
    varieties: ['Extra Dwarf'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  },
  {
    id: 'bok-choy-shanghai',
    name: 'Bok Choy - Shanghai',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'baby bok choy. Mini size, tender and sweet, quick growing. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '4-6 inches',
    family: 'Brassicaceae',
    varieties: ['Shanghai'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  },
  {
    id: 'bok-choy-ching-chang',
    name: 'Bok Choy - Ching Chang',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'baby bok choy. Mini size, tender and sweet, quick growing. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '4-6 inches',
    family: 'Brassicaceae',
    varieties: ['Ching Chang'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  },
  {
    id: 'bok-choy-choko',
    name: 'Bok Choy - Choko',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'baby bok choy. Mini size, tender and sweet, quick growing. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 inches',
    spread: '4-6 inches',
    family: 'Brassicaceae',
    varieties: ['Choko'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  },
  {
    id: 'bok-choy-long-white',
    name: 'Bok Choy - Long White',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'tall bok choy. Full size with long white stems. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-15 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Long White'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  },
  {
    id: 'bok-choy-joi-choi-xl',
    name: 'Bok Choy - Joi Choi XL',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'tall bok choy. Full size with long white stems. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-15 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Joi Choi XL'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  },
  {
    id: 'bok-choy-tokyo-bekana',
    name: 'Bok Choy - Tokyo Bekana',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'loose bok choy. Classic Chinese cabbage, crisp and mild. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Tokyo Bekana'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  },
  {
    id: 'bok-choy-mizuna',
    name: 'Bok Choy - Mizuna',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'mizuna bok choy. Classic Chinese cabbage, crisp and mild. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Mizuna'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  },
  {
    id: 'bok-choy-mibuna',
    name: 'Bok Choy - Mibuna',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'mibuna bok choy. Classic Chinese cabbage, crisp and mild. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Mibuna'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  },
  {
    id: 'bok-choy-golden-yellow',
    name: 'Bok Choy - Golden Yellow',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'yellow bok choy. Classic Chinese cabbage, crisp and mild. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Golden Yellow'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  },
  {
    id: 'bok-choy-white-stem',
    name: 'Bok Choy - White Stem',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'white bok choy. Classic Chinese cabbage, crisp and mild. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['White Stem'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  },
  {
    id: 'bok-choy-green-stem',
    name: 'Bok Choy - Green Stem',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'green bok choy. Classic Chinese cabbage, crisp and mild. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Green Stem'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  },
  {
    id: 'bok-choy-prize-choy',
    name: 'Bok Choy - Prize Choy',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'standard bok choy. Classic Chinese cabbage, crisp and mild. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Prize Choy'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  },
  {
    id: 'bok-choy-summer-choy',
    name: 'Bok Choy - Summer Choy',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'standard bok choy. Classic Chinese cabbage, crisp and mild. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Summer Choy'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  },
  {
    id: 'bok-choy-spring-choy',
    name: 'Bok Choy - Spring Choy',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'standard bok choy. Classic Chinese cabbage, crisp and mild. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Spring Choy'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  },
  {
    id: 'bok-choy-winter-choy',
    name: 'Bok Choy - Winter Choy',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'standard bok choy. Classic Chinese cabbage, crisp and mild. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Winter Choy'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  },
  {
    id: 'bok-choy-pac-choi',
    name: 'Bok Choy - Pac Choi',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'standard bok choy. Classic Chinese cabbage, crisp and mild. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Pac Choi'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  },
  {
    id: 'bok-choy-fun-jen',
    name: 'Bok Choy - Fun Jen',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'white bok choy. Classic Chinese cabbage, crisp and mild. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Fun Jen'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  },
  {
    id: 'bok-choy-koji',
    name: 'Bok Choy - Koji',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'standard bok choy. Classic Chinese cabbage, crisp and mild. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Koji'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  },
  {
    id: 'bok-choy-asian-delight',
    name: 'Bok Choy - Asian Delight',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'standard bok choy. Classic Chinese cabbage, crisp and mild. Quick growing Asian green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-10 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Asian Delight'],
    uses: ['stir fry', 'soup', 'salads', 'steaming', 'asian cuisine']
  }
,
  {
    id: 'arugula-wild',
    name: 'Arugula - Wild',
    scientificName: 'Diplotaxis tenuifolia',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 5,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['bush bean'],
    enemies: [],
    description: 'wild arugula. Perennial, deeply serrated leaves, intense peppery flavor. Quick growing, succession plant every 2 weeks.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Wild'],
    uses: ['salads', 'pesto', 'pizza', 'garnish', 'sandwiches']
  },
  {
    id: 'arugula-sylvetta',
    name: 'Arugula - Sylvetta',
    scientificName: 'Diplotaxis tenuifolia',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 5,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['bush bean'],
    enemies: [],
    description: 'wild arugula. Perennial, deeply serrated leaves, intense peppery flavor. Quick growing, succession plant every 2 weeks.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Sylvetta'],
    uses: ['salads', 'pesto', 'pizza', 'garnish', 'sandwiches']
  },
  {
    id: 'arugula-astro',
    name: 'Arugula - Astro',
    scientificName: 'Eruca vesicaria',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 5,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['bush bean'],
    enemies: [],
    description: 'cultivated arugula. Classic salad green, nutty and peppery. Quick growing, succession plant every 2 weeks.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Astro'],
    uses: ['salads', 'pesto', 'pizza', 'garnish', 'sandwiches']
  },
  {
    id: 'arugula-rocket',
    name: 'Arugula - Rocket',
    scientificName: 'Eruca vesicaria',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 5,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['bush bean'],
    enemies: [],
    description: 'cultivated arugula. Classic salad green, nutty and peppery. Quick growing, succession plant every 2 weeks.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Rocket'],
    uses: ['salads', 'pesto', 'pizza', 'garnish', 'sandwiches']
  },
  {
    id: 'arugula-apollo',
    name: 'Arugula - Apollo',
    scientificName: 'Eruca vesicaria',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 5,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['bush bean'],
    enemies: [],
    description: 'cultivated arugula. Classic salad green, nutty and peppery. Quick growing, succession plant every 2 weeks.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Apollo'],
    uses: ['salads', 'pesto', 'pizza', 'garnish', 'sandwiches']
  },
  {
    id: 'arugula-speedy',
    name: 'Arugula - Speedy',
    scientificName: 'Eruca vesicaria',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 5,
    daysToHarvest: 35,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['bush bean'],
    enemies: [],
    description: 'cultivated arugula. Classic salad green, nutty and peppery. Quick growing, succession plant every 2 weeks.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Speedy'],
    uses: ['salads', 'pesto', 'pizza', 'garnish', 'sandwiches']
  },
  {
    id: 'arugula-dragon-tongue',
    name: 'Arugula - Dragon Tongue',
    scientificName: 'Eruca vesicaria',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 5,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['bush bean'],
    enemies: [],
    description: 'red arugula. Beautiful red-veined leaves, spicy. Quick growing, succession plant every 2 weeks.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Dragon Tongue'],
    uses: ['salads', 'pesto', 'pizza', 'garnish', 'sandwiches']
  },
  {
    id: 'arugula-red-dragon',
    name: 'Arugula - Red Dragon',
    scientificName: 'Eruca vesicaria',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 5,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['bush bean'],
    enemies: [],
    description: 'red arugula. Beautiful red-veined leaves, spicy. Quick growing, succession plant every 2 weeks.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Red Dragon'],
    uses: ['salads', 'pesto', 'pizza', 'garnish', 'sandwiches']
  },
  {
    id: 'arugula-wasabi',
    name: 'Arugula - Wasabi',
    scientificName: 'Eruca vesicaria',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 5,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['bush bean'],
    enemies: [],
    description: 'spicy arugula. Extra hot wasabi-like flavor. Quick growing, succession plant every 2 weeks.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Wasabi'],
    uses: ['salads', 'pesto', 'pizza', 'garnish', 'sandwiches']
  },
  {
    id: 'arugula-surrey',
    name: 'Arugula - Surrey',
    scientificName: 'Eruca vesicaria',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 5,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['bush bean'],
    enemies: [],
    description: 'cultivated arugula. Classic salad green, nutty and peppery. Quick growing, succession plant every 2 weeks.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Surrey'],
    uses: ['salads', 'pesto', 'pizza', 'garnish', 'sandwiches']
  },
  {
    id: 'arugula-italian-cress',
    name: 'Arugula - Italian Cress',
    scientificName: 'Eruca vesicaria',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 5,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['bush bean'],
    enemies: [],
    description: 'cultivated arugula. Classic salad green, nutty and peppery. Quick growing, succession plant every 2 weeks.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Italian Cress'],
    uses: ['salads', 'pesto', 'pizza', 'garnish', 'sandwiches']
  },
  {
    id: 'arugula-olive-leaf',
    name: 'Arugula - Olive Leaf',
    scientificName: 'Eruca vesicaria',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 5,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['bush bean'],
    enemies: [],
    description: 'cultivated arugula. Classic salad green, nutty and peppery. Quick growing, succession plant every 2 weeks.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Olive Leaf'],
    uses: ['salads', 'pesto', 'pizza', 'garnish', 'sandwiches']
  },
  {
    id: 'arugula-runway',
    name: 'Arugula - Runway',
    scientificName: 'Eruca vesicaria',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 5,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['bush bean'],
    enemies: [],
    description: 'cultivated arugula. Classic salad green, nutty and peppery. Quick growing, succession plant every 2 weeks.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Runway'],
    uses: ['salads', 'pesto', 'pizza', 'garnish', 'sandwiches']
  },
  {
    id: 'arugula-selvatica',
    name: 'Arugula - Selvatica',
    scientificName: 'Diplotaxis tenuifolia',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 5,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['bush bean'],
    enemies: [],
    description: 'wild arugula. Perennial, deeply serrated leaves, intense peppery flavor. Quick growing, succession plant every 2 weeks.',
    hardinessZones: '6-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Selvatica'],
    uses: ['salads', 'pesto', 'pizza', 'garnish', 'sandwiches']
  },
  {
    id: 'arugula-adagio',
    name: 'Arugula - Adagio',
    scientificName: 'Eruca vesicaria',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 5,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['bush bean'],
    enemies: [],
    description: 'cultivated arugula. Classic salad green, nutty and peppery. Quick growing, succession plant every 2 weeks.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Adagio'],
    uses: ['salads', 'pesto', 'pizza', 'garnish', 'sandwiches']
  },
  {
    id: 'arugula-bambi',
    name: 'Arugula - Bambi',
    scientificName: 'Eruca vesicaria',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 5,
    daysToHarvest: 35,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['bush bean'],
    enemies: [],
    description: 'baby arugula. Classic salad green, nutty and peppery. Quick growing, succession plant every 2 weeks.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Bambi'],
    uses: ['salads', 'pesto', 'pizza', 'garnish', 'sandwiches']
  },
  {
    id: 'arugula-cool-season',
    name: 'Arugula - Cool Season',
    scientificName: 'Eruca vesicaria',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 5,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['bush bean'],
    enemies: [],
    description: 'cultivated arugula. Classic salad green, nutty and peppery. Quick growing, succession plant every 2 weeks.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Cool Season'],
    uses: ['salads', 'pesto', 'pizza', 'garnish', 'sandwiches']
  },
  {
    id: 'arugula-esmee',
    name: 'Arugula - Esmee',
    scientificName: 'Eruca vesicaria',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 5,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['bush bean'],
    enemies: [],
    description: 'cultivated arugula. Classic salad green, nutty and peppery. Quick growing, succession plant every 2 weeks.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Esmee'],
    uses: ['salads', 'pesto', 'pizza', 'garnish', 'sandwiches']
  },
  {
    id: 'arugula-grazia',
    name: 'Arugula - Grazia',
    scientificName: 'Eruca vesicaria',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 5,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['bush bean'],
    enemies: [],
    description: 'cultivated arugula. Classic salad green, nutty and peppery. Quick growing, succession plant every 2 weeks.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Grazia'],
    uses: ['salads', 'pesto', 'pizza', 'garnish', 'sandwiches']
  },
  {
    id: 'arugula-napoli',
    name: 'Arugula - Napoli',
    scientificName: 'Eruca vesicaria',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 5,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['bush bean'],
    enemies: [],
    description: 'cultivated arugula. Classic salad green, nutty and peppery. Quick growing, succession plant every 2 weeks.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Napoli'],
    uses: ['salads', 'pesto', 'pizza', 'garnish', 'sandwiches']
  },
  {
    id: 'arugula-parmex',
    name: 'Arugula - Parmex',
    scientificName: 'Eruca vesicaria',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 5,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['bush bean'],
    enemies: [],
    description: 'cultivated arugula. Classic salad green, nutty and peppery. Quick growing, succession plant every 2 weeks.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Parmex'],
    uses: ['salads', 'pesto', 'pizza', 'garnish', 'sandwiches']
  },
  {
    id: 'arugula-rucola',
    name: 'Arugula - Rucola',
    scientificName: 'Eruca vesicaria',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 5,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['bush bean'],
    enemies: [],
    description: 'cultivated arugula. Classic salad green, nutty and peppery. Quick growing, succession plant every 2 weeks.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Rucola'],
    uses: ['salads', 'pesto', 'pizza', 'garnish', 'sandwiches']
  },
  {
    id: 'arugula-sicilian',
    name: 'Arugula - Sicilian',
    scientificName: 'Eruca vesicaria',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 5,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['bush bean'],
    enemies: [],
    description: 'cultivated arugula. Classic salad green, nutty and peppery. Quick growing, succession plant every 2 weeks.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Sicilian'],
    uses: ['salads', 'pesto', 'pizza', 'garnish', 'sandwiches']
  },
  {
    id: 'arugula-slow-bolt',
    name: 'Arugula - Slow Bolt',
    scientificName: 'Eruca vesicaria',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 5,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['bush bean'],
    enemies: [],
    description: 'cultivated arugula. Classic salad green, nutty and peppery. Quick growing, succession plant every 2 weeks.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Slow Bolt'],
    uses: ['salads', 'pesto', 'pizza', 'garnish', 'sandwiches']
  },
  {
    id: 'arugula-voyager',
    name: 'Arugula - Voyager',
    scientificName: 'Eruca vesicaria',
    category: 'vegetable',
    spacing: 4,
    rowSpacing: 8,
    daysToGermination: 5,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7,
    companions: ['bush bean'],
    enemies: [],
    description: 'cultivated arugula. Classic salad green, nutty and peppery. Quick growing, succession plant every 2 weeks.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '6-12 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Voyager'],
    uses: ['salads', 'pesto', 'pizza', 'garnish', 'sandwiches']
  }
,
  {
    id: 'asian-green-tatsoi',
    name: 'Asian Green - Tatsoi',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'rosette Asian green. Beautiful flat rosette, spoon-shaped leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Tatsoi'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-rosette-tatsoi',
    name: 'Asian Green - Rosette Tatsoi',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'rosette Asian green. Beautiful flat rosette, spoon-shaped leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Rosette Tatsoi'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-purple-tatsoi',
    name: 'Asian Green - Purple Tatsoi',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'rosette Asian green. Beautiful flat rosette, spoon-shaped leaves.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Purple Tatsoi'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-yukina-savoy',
    name: 'Asian Green - Yukina Savoy',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'savoy Asian green. Crinkled dark green leaves, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Yukina Savoy'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-savoy-tatsoi',
    name: 'Asian Green - Savoy Tatsoi',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'savoy Asian green. Crinkled dark green leaves, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Savoy Tatsoi'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-komatsuna',
    name: 'Asian Green - Komatsuna',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'mustard Asian green. Spicy mustard flavor, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Komatsuna'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-red-komatsuna',
    name: 'Asian Green - Red Komatsuna',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'mustard Asian green. Spicy mustard flavor, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Red Komatsuna'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-green-boy',
    name: 'Asian Green - Green Boy',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'mustard Asian green. Spicy mustard flavor, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Green Boy'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-maruba-santoh',
    name: 'Asian Green - Maruba Santoh',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'loose Asian green. Versatile Asian cooking green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Maruba Santoh'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-choy-sum',
    name: 'Asian Green - Choy Sum',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'flowering Asian green. Grown for tender flowering stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Choy Sum'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-hon-tsai-tai',
    name: 'Asian Green - Hon Tsai Tai',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'flowering Asian green. Grown for tender flowering stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Hon Tsai Tai'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-yu-choy',
    name: 'Asian Green - Yu Choy',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'flowering Asian green. Grown for tender flowering stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Yu Choy'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-gai-lan',
    name: 'Asian Green - Gai Lan',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'chinese broccoli Asian green. Versatile Asian cooking green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Gai Lan'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-chinese-kale',
    name: 'Asian Green - Chinese Kale',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'chinese broccoli Asian green. Versatile Asian cooking green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Chinese Kale'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-kailaan',
    name: 'Asian Green - Kailaan',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'chinese broccoli Asian green. Versatile Asian cooking green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Kailaan'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-siberian-kale',
    name: 'Asian Green - Siberian Kale',
    scientificName: 'Brassica napus',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'kale Asian green. Versatile Asian cooking green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Siberian Kale'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-red-russian',
    name: 'Asian Green - Red Russian',
    scientificName: 'Brassica napus',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 55,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'kale Asian green. Versatile Asian cooking green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Red Russian'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-hanakan',
    name: 'Asian Green - Hanakan',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'ornamental Asian green. Versatile Asian cooking green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Hanakan'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-mizuna',
    name: 'Asian Green - Mizuna',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'mizuna Asian green. Feathery serrated leaves, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mizuna'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-red-mizuna',
    name: 'Asian Green - Red Mizuna',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'mizuna Asian green. Feathery serrated leaves, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Red Mizuna'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-kyona',
    name: 'Asian Green - Kyona',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'mizuna Asian green. Feathery serrated leaves, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Kyona'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-mustard-mizuna',
    name: 'Asian Green - Mustard Mizuna',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'mizuna Asian green. Feathery serrated leaves, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mustard Mizuna'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-mibuna',
    name: 'Asian Green - Mibuna',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'mibuna Asian green. Versatile Asian cooking green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mibuna'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-chinese-mustard',
    name: 'Asian Green - Chinese Mustard',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'mustard Asian green. Spicy mustard flavor, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Chinese Mustard'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-red-giant',
    name: 'Asian Green - Red Giant',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'mustard Asian green. Spicy mustard flavor, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Red Giant'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-southern-giant',
    name: 'Asian Green - Southern Giant',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'mustard Asian green. Spicy mustard flavor, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Southern Giant'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-osaka-purple',
    name: 'Asian Green - Osaka Purple',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'mustard Asian green. Spicy mustard flavor, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Osaka Purple'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-green-wave',
    name: 'Asian Green - Green Wave',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'mustard Asian green. Spicy mustard flavor, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Green Wave'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-ruby-streaks',
    name: 'Asian Green - Ruby Streaks',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'mustard Asian green. Spicy mustard flavor, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Ruby Streaks'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-golden-frills',
    name: 'Asian Green - Golden Frills',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'mustard Asian green. Spicy mustard flavor, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Golden Frills'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-scarlet-frills',
    name: 'Asian Green - Scarlet Frills',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'mustard Asian green. Spicy mustard flavor, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Scarlet Frills'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-red-rain',
    name: 'Asian Green - Red Rain',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'mustard Asian green. Spicy mustard flavor, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Red Rain'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-dragon-tongue',
    name: 'Asian Green - Dragon Tongue',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'mustard Asian green. Spicy mustard flavor, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Dragon Tongue'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-amara',
    name: 'Asian Green - Amara',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'mustard Asian green. Spicy mustard flavor, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Amara'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-ethiopian',
    name: 'Asian Green - Ethiopian',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'mustard Asian green. Spicy mustard flavor, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Ethiopian'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-lizard-tail',
    name: 'Asian Green - Lizard Tail',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'mustard Asian green. Spicy mustard flavor, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Lizard Tail'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-senposai',
    name: 'Asian Green - Senposai',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'hybrid Asian green. Versatile Asian cooking green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Senposai'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-greensleeves',
    name: 'Asian Green - Greensleeves',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'hybrid Asian green. Versatile Asian cooking green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Greensleeves'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-tokyo-bekana',
    name: 'Asian Green - Tokyo Bekana',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'lettuce Asian green. Versatile Asian cooking green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Tokyo Bekana'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  },
  {
    id: 'asian-green-vit',
    name: 'Asian Green - Vit',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'mizuna Asian green. Feathery serrated leaves, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Vit'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'pickling']
  }
,
  {
    id: 'mustard-green-wave',
    name: 'Mustard - Green Wave',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Green Wave mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Green Wave'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-red-giant',
    name: 'Mizuna - Red Giant',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Red Giant mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Red Giant'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-southern-giant',
    name: 'Tatsoi - Southern Giant',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Southern Giant tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Southern Giant'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-florida-broadleaf',
    name: 'Komatsuna - Florida Broadleaf',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Florida Broadleaf komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Florida Broadleaf'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-osaka-purple',
    name: 'Pac choi - Osaka Purple',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Osaka Purple pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Osaka Purple'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-ruby-streaks',
    name: 'Gai lan - Ruby Streaks',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Ruby Streaks gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Ruby Streaks'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-golden-frills',
    name: 'Choy sum - Golden Frills',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Golden Frills choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Golden Frills'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-scarlet-frills',
    name: 'Amaranth - Scarlet Frills',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Scarlet Frills amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Scarlet Frills'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-red-rain',
    name: 'Malabar spinach - Red Rain',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Red Rain malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Red Rain'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-dragon-tongue',
    name: 'Water spinach - Dragon Tongue',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Dragon Tongue water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Dragon Tongue'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-kyona',
    name: 'Mustard - Kyona',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Kyona mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Kyona'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-kyoto',
    name: 'Mizuna - Kyoto',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Kyoto mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Kyoto'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-early',
    name: 'Tatsoi - Early',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Early tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Early'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-shogoin',
    name: 'Komatsuna - Shogoin',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Shogoin komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Shogoin'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-mibuna',
    name: 'Pac choi - Mibuna',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Mibuna pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mibuna'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-komatsuna',
    name: 'Gai lan - Komatsuna',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Komatsuna gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Komatsuna'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-japanese-mustard-spinach',
    name: 'Choy sum - Japanese Mustard Spinach',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Japanese Mustard Spinach choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Japanese Mustard Spinach'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-torasan',
    name: 'Amaranth - Torasan',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Torasan amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Torasan'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-summer-fest',
    name: 'Malabar spinach - Summer Fest',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Summer Fest malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Summer Fest'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-carlton',
    name: 'Water spinach - Carlton',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Carlton water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Carlton'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-mei-qing',
    name: 'Mustard - Mei Qing',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Mei Qing mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mei Qing'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-joi-choi',
    name: 'Mizuna - Joi Choi',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Joi Choi mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Joi Choi'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-win-win',
    name: 'Tatsoi - Win Win',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Win Win tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Win Win'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-black-summer',
    name: 'Komatsuna - Black Summer',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Black Summer komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Black Summer'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-rosie',
    name: 'Pac choi - Rosie',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Rosie pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Rosie'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-chinese-broccoli',
    name: 'Gai lan - Chinese Broccoli',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Chinese Broccoli gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Chinese Broccoli'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-kailaan',
    name: 'Choy sum - Kailaan',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Kailaan choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Kailaan'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-white-stem',
    name: 'Amaranth - White Stem',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'White Stem amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['White Stem'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-thousand-head',
    name: 'Malabar spinach - Thousand Head',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Thousand Head malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Thousand Head'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-suiho',
    name: 'Water spinach - Suiho',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Suiho water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Suiho'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-hon-tsai-tai',
    name: 'Mustard - Hon Tsai Tai',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Hon Tsai Tai mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Hon Tsai Tai'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-yu-choy',
    name: 'Mizuna - Yu Choy',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Yu Choy mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Yu Choy'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-choy-sum',
    name: 'Tatsoi - Choy Sum',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Choy Sum tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Choy Sum'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-flowering-cabbage',
    name: 'Komatsuna - Flowering Cabbage',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Flowering Cabbage komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Flowering Cabbage'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-mock-pak-choy',
    name: 'Pac choi - Mock Pak Choy',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Mock Pak Choy pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mock Pak Choy'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-callaloo',
    name: 'Gai lan - Callaloo',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Callaloo gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Callaloo'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-chinese-spinach',
    name: 'Choy sum - Chinese Spinach',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Chinese Spinach choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Chinese Spinach'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-josephs-coat',
    name: 'Amaranth - Josephs Coat',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Josephs Coat amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Josephs Coat'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-love-lies-bleeding',
    name: 'Malabar spinach - Love Lies Bleeding',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Love Lies Bleeding malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Love Lies Bleeding'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-red-leaf',
    name: 'Water spinach - Red Leaf',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Red Leaf water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Red Leaf'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-basella',
    name: 'Mustard - Basella',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Basella mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Basella'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-ceylon-spinach',
    name: 'Mizuna - Ceylon Spinach',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Ceylon Spinach mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Ceylon Spinach'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-indian-spinach',
    name: 'Tatsoi - Indian Spinach',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Indian Spinach tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Indian Spinach'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-vine-spinach',
    name: 'Komatsuna - Vine Spinach',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Vine Spinach komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Vine Spinach'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-malabar',
    name: 'Pac choi - Malabar',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Malabar pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Malabar'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-kangkong',
    name: 'Gai lan - Kangkong',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Kangkong gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Kangkong'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-river-spinach',
    name: 'Choy sum - River Spinach',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'River Spinach choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['River Spinach'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-water-morning-glory',
    name: 'Amaranth - Water Morning Glory',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Water Morning Glory amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Water Morning Glory'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-swamp-cabbage',
    name: 'Malabar spinach - Swamp Cabbage',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Swamp Cabbage malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Swamp Cabbage'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-ong-choy',
    name: 'Water spinach - Ong Choy',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Ong Choy water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Ong Choy'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-tah-tsai',
    name: 'Mustard - Tah Tsai',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Tah Tsai mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Tah Tsai'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-rosette',
    name: 'Mizuna - Rosette',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Rosette mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Rosette'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-spoon',
    name: 'Tatsoi - Spoon',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Spoon tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Spoon'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-flat',
    name: 'Komatsuna - Flat',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Flat komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Flat'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-purple',
    name: 'Pac choi - Purple',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Purple pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Purple'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-golden',
    name: 'Gai lan - Golden',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Golden gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Golden'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-yellow',
    name: 'Choy sum - Yellow',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Yellow choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Yellow'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-green',
    name: 'Amaranth - Green',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Green amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Green'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-red',
    name: 'Malabar spinach - Red',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Red malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Red'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-white',
    name: 'Water spinach - White',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'White water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['White'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-prize-choy',
    name: 'Mustard - Prize Choy',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Prize Choy mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Prize Choy'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-summer',
    name: 'Mizuna - Summer',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Summer mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Summer'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-spring',
    name: 'Tatsoi - Spring',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Spring tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Spring'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-winter',
    name: 'Komatsuna - Winter',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Winter komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Winter'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-mini',
    name: 'Pac choi - Mini',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Mini pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mini'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-long',
    name: 'Gai lan - Long',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Long gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Long'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-short',
    name: 'Choy sum - Short',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Short choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Short'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-fat',
    name: 'Amaranth - Fat',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Fat amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Fat'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-thin',
    name: 'Malabar spinach - Thin',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Thin malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Thin'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-dwarf',
    name: 'Water spinach - Dwarf',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Dwarf water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Dwarf'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-giant',
    name: 'Mustard - Giant',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Giant mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Giant'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-baby',
    name: 'Mizuna - Baby',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Baby mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Baby'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-micro',
    name: 'Tatsoi - Micro',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Micro tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Micro'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-teen',
    name: 'Komatsuna - Teen',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Teen komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Teen'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-tot',
    name: 'Pac choi - Tot',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Tot pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Tot'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-extra-dwarf',
    name: 'Gai lan - Extra Dwarf',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Extra Dwarf gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Extra Dwarf'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-super-dwarf',
    name: 'Choy sum - Super Dwarf',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Super Dwarf choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Super Dwarf'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-dwarf-green',
    name: 'Amaranth - Dwarf Green',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Dwarf Green amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Dwarf Green'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-dwarf-white',
    name: 'Malabar spinach - Dwarf White',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Dwarf White malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Dwarf White'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-dwarf-red',
    name: 'Water spinach - Dwarf Red',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Dwarf Red water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Dwarf Red'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-large',
    name: 'Mustard - Large',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Large mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Large'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-medium',
    name: 'Mizuna - Medium',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Medium mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Medium'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-small',
    name: 'Tatsoi - Small',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Small tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Small'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-extra-large',
    name: 'Komatsuna - Extra Large',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Extra Large komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Extra Large'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-jumbo',
    name: 'Pac choi - Jumbo',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Jumbo pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Jumbo'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-quick',
    name: 'Gai lan - Quick',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Quick gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Quick'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-fast',
    name: 'Choy sum - Fast',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Fast choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Fast'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-speedy',
    name: 'Amaranth - Speedy',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Speedy amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Speedy'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-rapid',
    name: 'Malabar spinach - Rapid',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Rapid malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Rapid'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-swift',
    name: 'Water spinach - Swift',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Swift water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Swift'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-slow',
    name: 'Mustard - Slow',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Slow mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Slow'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-long-season',
    name: 'Mizuna - Long Season',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Long Season mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Long Season'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-extended',
    name: 'Tatsoi - Extended',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Extended tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Extended'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-prolonged',
    name: 'Komatsuna - Prolonged',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Prolonged komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Prolonged'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-delayed',
    name: 'Pac choi - Delayed',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Delayed pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Delayed'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-bolt-resistant',
    name: 'Gai lan - Bolt Resistant',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Bolt Resistant gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Bolt Resistant'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-slow-bolt',
    name: 'Choy sum - Slow Bolt',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Slow Bolt choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Slow Bolt'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-heat-tolerant',
    name: 'Amaranth - Heat Tolerant',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Heat Tolerant amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Heat Tolerant'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-cold-hardy',
    name: 'Malabar spinach - Cold Hardy',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Cold Hardy malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Cold Hardy'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-frost-resistant',
    name: 'Water spinach - Frost Resistant',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Frost Resistant water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Frost Resistant'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-early',
    name: 'Mustard - Early',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Early mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Early'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-mid',
    name: 'Mizuna - Mid',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Mid mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mid'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-late',
    name: 'Tatsoi - Late',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Late tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Late'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-main-season',
    name: 'Komatsuna - Main Season',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Main Season komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Main Season'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-fall',
    name: 'Pac choi - Fall',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Fall pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Fall'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-spring',
    name: 'Gai lan - Spring',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Spring gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Spring'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-summer',
    name: 'Choy sum - Summer',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Summer choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Summer'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-winter',
    name: 'Amaranth - Winter',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Winter amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Winter'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-all-season',
    name: 'Malabar spinach - All Season',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'All Season malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['All Season'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-year-round',
    name: 'Water spinach - Year Round',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Year Round water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Year Round'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-sprint',
    name: 'Mustard - Sprint',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Sprint mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Sprint'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-marathon',
    name: 'Mizuna - Marathon',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Marathon mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Marathon'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-dash',
    name: 'Tatsoi - Dash',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Dash tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Dash'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-race',
    name: 'Komatsuna - Race',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Race komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Race'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-run',
    name: 'Pac choi - Run',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Run pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Run'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-green-wave-2',
    name: 'Gai lan - Green Wave 2',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Green Wave 2 gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Green Wave 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-red-giant-2',
    name: 'Choy sum - Red Giant 2',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Red Giant 2 choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Red Giant 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-southern-giant-2',
    name: 'Amaranth - Southern Giant 2',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Southern Giant 2 amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Southern Giant 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-florida-broadleaf-2',
    name: 'Malabar spinach - Florida Broadleaf 2',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Florida Broadleaf 2 malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Florida Broadleaf 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-osaka-purple-2',
    name: 'Water spinach - Osaka Purple 2',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Osaka Purple 2 water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Osaka Purple 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-ruby-streaks-2',
    name: 'Mustard - Ruby Streaks 2',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Ruby Streaks 2 mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Ruby Streaks 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-golden-frills-2',
    name: 'Mizuna - Golden Frills 2',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Golden Frills 2 mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Golden Frills 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-scarlet-frills-2',
    name: 'Tatsoi - Scarlet Frills 2',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Scarlet Frills 2 tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Scarlet Frills 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-red-rain-2',
    name: 'Komatsuna - Red Rain 2',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Red Rain 2 komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Red Rain 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-dragon-tongue-2',
    name: 'Pac choi - Dragon Tongue 2',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Dragon Tongue 2 pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Dragon Tongue 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-kyona-2',
    name: 'Gai lan - Kyona 2',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Kyona 2 gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Kyona 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-kyoto-2',
    name: 'Choy sum - Kyoto 2',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Kyoto 2 choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Kyoto 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-early-2',
    name: 'Amaranth - Early 2',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Early 2 amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Early 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-shogoin-2',
    name: 'Malabar spinach - Shogoin 2',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Shogoin 2 malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Shogoin 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-mibuna-2',
    name: 'Water spinach - Mibuna 2',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Mibuna 2 water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Mibuna 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-komatsuna-2',
    name: 'Mustard - Komatsuna 2',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Komatsuna 2 mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Komatsuna 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-japanese-mustard-spinach-2',
    name: 'Mizuna - Japanese Mustard Spinach 2',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Japanese Mustard Spinach 2 mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Japanese Mustard Spinach 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-torasan-2',
    name: 'Tatsoi - Torasan 2',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Torasan 2 tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Torasan 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-summer-fest-2',
    name: 'Komatsuna - Summer Fest 2',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Summer Fest 2 komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Summer Fest 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-carlton-2',
    name: 'Pac choi - Carlton 2',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Carlton 2 pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Carlton 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-mei-qing-2',
    name: 'Gai lan - Mei Qing 2',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Mei Qing 2 gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mei Qing 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-joi-choi-2',
    name: 'Choy sum - Joi Choi 2',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Joi Choi 2 choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Joi Choi 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-win-win-2',
    name: 'Amaranth - Win Win 2',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Win Win 2 amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Win Win 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-black-summer-2',
    name: 'Malabar spinach - Black Summer 2',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Black Summer 2 malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Black Summer 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-rosie-2',
    name: 'Water spinach - Rosie 2',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Rosie 2 water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Rosie 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-chinese-broccoli-2',
    name: 'Mustard - Chinese Broccoli 2',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Chinese Broccoli 2 mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Chinese Broccoli 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-kailaan-2',
    name: 'Mizuna - Kailaan 2',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Kailaan 2 mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Kailaan 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-white-stem-2',
    name: 'Tatsoi - White Stem 2',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'White Stem 2 tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['White Stem 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-thousand-head-2',
    name: 'Komatsuna - Thousand Head 2',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Thousand Head 2 komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Thousand Head 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-suiho-2',
    name: 'Pac choi - Suiho 2',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Suiho 2 pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Suiho 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-hon-tsai-tai-2',
    name: 'Gai lan - Hon Tsai Tai 2',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Hon Tsai Tai 2 gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Hon Tsai Tai 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-yu-choy-2',
    name: 'Choy sum - Yu Choy 2',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Yu Choy 2 choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Yu Choy 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-choy-sum-2',
    name: 'Amaranth - Choy Sum 2',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Choy Sum 2 amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Choy Sum 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-flowering-cabbage-2',
    name: 'Malabar spinach - Flowering Cabbage 2',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Flowering Cabbage 2 malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Flowering Cabbage 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-mock-pak-choy-2',
    name: 'Water spinach - Mock Pak Choy 2',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Mock Pak Choy 2 water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Mock Pak Choy 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-callaloo-2',
    name: 'Mustard - Callaloo 2',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Callaloo 2 mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Callaloo 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-chinese-spinach-2',
    name: 'Mizuna - Chinese Spinach 2',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Chinese Spinach 2 mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Chinese Spinach 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-josephs-coat-2',
    name: 'Tatsoi - Josephs Coat 2',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'grain',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Josephs Coat 2 tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Josephs Coat 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-love-lies-bleeding-2',
    name: 'Komatsuna - Love Lies Bleeding 2',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Love Lies Bleeding 2 komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Love Lies Bleeding 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-red-leaf-2',
    name: 'Pac choi - Red Leaf 2',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Red Leaf 2 pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Red Leaf 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-basella-2',
    name: 'Gai lan - Basella 2',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Basella 2 gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Basella 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-ceylon-spinach-2',
    name: 'Choy sum - Ceylon Spinach 2',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Ceylon Spinach 2 choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Ceylon Spinach 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-indian-spinach-2',
    name: 'Amaranth - Indian Spinach 2',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Indian Spinach 2 amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Indian Spinach 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-vine-spinach-2',
    name: 'Malabar spinach - Vine Spinach 2',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Vine Spinach 2 malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Vine Spinach 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-malabar-2',
    name: 'Water spinach - Malabar 2',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Malabar 2 water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Malabar 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-kangkong-2',
    name: 'Mustard - Kangkong 2',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Kangkong 2 mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Kangkong 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-river-spinach-2',
    name: 'Mizuna - River Spinach 2',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'River Spinach 2 mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['River Spinach 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-water-morning-glory-2',
    name: 'Tatsoi - Water Morning Glory 2',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Water Morning Glory 2 tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Water Morning Glory 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-swamp-cabbage-2',
    name: 'Komatsuna - Swamp Cabbage 2',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Swamp Cabbage 2 komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Swamp Cabbage 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-ong-choy-2',
    name: 'Pac choi - Ong Choy 2',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Ong Choy 2 pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Ong Choy 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-tah-tsai-2',
    name: 'Gai lan - Tah Tsai 2',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Tah Tsai 2 gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Tah Tsai 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-rosette-2',
    name: 'Choy sum - Rosette 2',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Rosette 2 choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Rosette 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-spoon-2',
    name: 'Amaranth - Spoon 2',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Spoon 2 amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Spoon 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-flat-2',
    name: 'Malabar spinach - Flat 2',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Flat 2 malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Flat 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-purple-2',
    name: 'Water spinach - Purple 2',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Purple 2 water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Purple 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-golden-2',
    name: 'Mustard - Golden 2',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Golden 2 mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Golden 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-yellow-2',
    name: 'Mizuna - Yellow 2',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Yellow 2 mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Yellow 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-green-2',
    name: 'Tatsoi - Green 2',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Green 2 tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Green 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-red-2',
    name: 'Komatsuna - Red 2',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Red 2 komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Red 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-white-2',
    name: 'Pac choi - White 2',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'White 2 pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['White 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-prize-choy-2',
    name: 'Gai lan - Prize Choy 2',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Prize Choy 2 gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Prize Choy 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-summer-2',
    name: 'Choy sum - Summer 2',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Summer 2 choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Summer 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-spring-2',
    name: 'Amaranth - Spring 2',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Spring 2 amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Spring 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-winter-2',
    name: 'Malabar spinach - Winter 2',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Winter 2 malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Winter 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-mini-2',
    name: 'Water spinach - Mini 2',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Mini 2 water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Mini 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-long-2',
    name: 'Mustard - Long 2',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Long 2 mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Long 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-short-2',
    name: 'Mizuna - Short 2',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Short 2 mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Short 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-fat-2',
    name: 'Tatsoi - Fat 2',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Fat 2 tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Fat 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-thin-2',
    name: 'Komatsuna - Thin 2',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Thin 2 komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Thin 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-dwarf-2',
    name: 'Pac choi - Dwarf 2',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Dwarf 2 pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Dwarf 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-giant-2',
    name: 'Gai lan - Giant 2',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Giant 2 gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Giant 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-baby-2',
    name: 'Choy sum - Baby 2',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Baby 2 choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Baby 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-micro-2',
    name: 'Amaranth - Micro 2',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Micro 2 amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Micro 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-teen-2',
    name: 'Malabar spinach - Teen 2',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Teen 2 malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Teen 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-tot-2',
    name: 'Water spinach - Tot 2',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Tot 2 water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Tot 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-extra-dwarf-2',
    name: 'Mustard - Extra Dwarf 2',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Extra Dwarf 2 mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Extra Dwarf 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-super-dwarf-2',
    name: 'Mizuna - Super Dwarf 2',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Super Dwarf 2 mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Super Dwarf 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-dwarf-green-2',
    name: 'Tatsoi - Dwarf Green 2',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Dwarf Green 2 tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Dwarf Green 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-dwarf-white-2',
    name: 'Komatsuna - Dwarf White 2',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Dwarf White 2 komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Dwarf White 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-dwarf-red-2',
    name: 'Pac choi - Dwarf Red 2',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Dwarf Red 2 pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Dwarf Red 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-large-2',
    name: 'Gai lan - Large 2',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Large 2 gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Large 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-medium-2',
    name: 'Choy sum - Medium 2',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Medium 2 choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Medium 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-small-2',
    name: 'Amaranth - Small 2',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Small 2 amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Small 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-extra-large-2',
    name: 'Malabar spinach - Extra Large 2',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Extra Large 2 malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Extra Large 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-jumbo-2',
    name: 'Water spinach - Jumbo 2',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Jumbo 2 water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Jumbo 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-quick-2',
    name: 'Mustard - Quick 2',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Quick 2 mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Quick 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-fast-2',
    name: 'Mizuna - Fast 2',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Fast 2 mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Fast 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-speedy-2',
    name: 'Tatsoi - Speedy 2',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Speedy 2 tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Speedy 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-rapid-2',
    name: 'Komatsuna - Rapid 2',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Rapid 2 komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Rapid 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-swift-2',
    name: 'Pac choi - Swift 2',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Swift 2 pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Swift 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-slow-2',
    name: 'Gai lan - Slow 2',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Slow 2 gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Slow 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-long-season-2',
    name: 'Choy sum - Long Season 2',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Long Season 2 choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Long Season 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-extended-2',
    name: 'Amaranth - Extended 2',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Extended 2 amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Extended 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-prolonged-2',
    name: 'Malabar spinach - Prolonged 2',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Prolonged 2 malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Prolonged 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-delayed-2',
    name: 'Water spinach - Delayed 2',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Delayed 2 water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Delayed 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-bolt-resistant-2',
    name: 'Mustard - Bolt Resistant 2',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Bolt Resistant 2 mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Bolt Resistant 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-slow-bolt-2',
    name: 'Mizuna - Slow Bolt 2',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Slow Bolt 2 mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Slow Bolt 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-heat-tolerant-2',
    name: 'Tatsoi - Heat Tolerant 2',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Heat Tolerant 2 tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Heat Tolerant 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-cold-hardy-2',
    name: 'Komatsuna - Cold Hardy 2',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Cold Hardy 2 komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Cold Hardy 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-frost-resistant-2',
    name: 'Pac choi - Frost Resistant 2',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Frost Resistant 2 pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Frost Resistant 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-early-2',
    name: 'Gai lan - Early 2',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Early 2 gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Early 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-mid-2',
    name: 'Choy sum - Mid 2',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Mid 2 choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mid 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-late-2',
    name: 'Amaranth - Late 2',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Late 2 amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Late 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-main-season-2',
    name: 'Malabar spinach - Main Season 2',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Main Season 2 malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Main Season 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-fall-2',
    name: 'Water spinach - Fall 2',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Fall 2 water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Fall 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-spring-2',
    name: 'Mustard - Spring 2',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Spring 2 mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Spring 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-summer-2',
    name: 'Mizuna - Summer 2',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Summer 2 mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Summer 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-winter-2',
    name: 'Tatsoi - Winter 2',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Winter 2 tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Winter 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-all-season-2',
    name: 'Komatsuna - All Season 2',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'All Season 2 komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['All Season 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-year-round-2',
    name: 'Pac choi - Year Round 2',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Year Round 2 pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Year Round 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-sprint-2',
    name: 'Gai lan - Sprint 2',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Sprint 2 gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Sprint 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-marathon-2',
    name: 'Choy sum - Marathon 2',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Marathon 2 choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Marathon 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-dash-2',
    name: 'Amaranth - Dash 2',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Dash 2 amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Dash 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-race-2',
    name: 'Malabar spinach - Race 2',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Race 2 malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Race 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-run-2',
    name: 'Water spinach - Run 2',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Run 2 water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Run 2'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-green-wave-3',
    name: 'Mustard - Green Wave 3',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Green Wave 3 mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Green Wave 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-red-giant-3',
    name: 'Mizuna - Red Giant 3',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Red Giant 3 mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Red Giant 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-southern-giant-3',
    name: 'Tatsoi - Southern Giant 3',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Southern Giant 3 tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Southern Giant 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-florida-broadleaf-3',
    name: 'Komatsuna - Florida Broadleaf 3',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Florida Broadleaf 3 komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Florida Broadleaf 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-osaka-purple-3',
    name: 'Pac choi - Osaka Purple 3',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Osaka Purple 3 pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Osaka Purple 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-ruby-streaks-3',
    name: 'Gai lan - Ruby Streaks 3',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Ruby Streaks 3 gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Ruby Streaks 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-golden-frills-3',
    name: 'Choy sum - Golden Frills 3',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Golden Frills 3 choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Golden Frills 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-scarlet-frills-3',
    name: 'Amaranth - Scarlet Frills 3',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Scarlet Frills 3 amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Scarlet Frills 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-red-rain-3',
    name: 'Malabar spinach - Red Rain 3',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Red Rain 3 malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Red Rain 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-dragon-tongue-3',
    name: 'Water spinach - Dragon Tongue 3',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Dragon Tongue 3 water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Dragon Tongue 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-kyona-3',
    name: 'Mustard - Kyona 3',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Kyona 3 mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Kyona 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-kyoto-3',
    name: 'Mizuna - Kyoto 3',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Kyoto 3 mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Kyoto 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-early-3',
    name: 'Tatsoi - Early 3',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Early 3 tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Early 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-shogoin-3',
    name: 'Komatsuna - Shogoin 3',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Shogoin 3 komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Shogoin 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-mibuna-3',
    name: 'Pac choi - Mibuna 3',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Mibuna 3 pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mibuna 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-komatsuna-3',
    name: 'Gai lan - Komatsuna 3',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Komatsuna 3 gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Komatsuna 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-japanese-mustard-spinach-3',
    name: 'Choy sum - Japanese Mustard Spinach 3',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Japanese Mustard Spinach 3 choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Japanese Mustard Spinach 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-torasan-3',
    name: 'Amaranth - Torasan 3',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Torasan 3 amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Torasan 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-summer-fest-3',
    name: 'Malabar spinach - Summer Fest 3',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Summer Fest 3 malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Summer Fest 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-carlton-3',
    name: 'Water spinach - Carlton 3',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Carlton 3 water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Carlton 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-mei-qing-3',
    name: 'Mustard - Mei Qing 3',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Mei Qing 3 mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mei Qing 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-joi-choi-3',
    name: 'Mizuna - Joi Choi 3',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Joi Choi 3 mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Joi Choi 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-win-win-3',
    name: 'Tatsoi - Win Win 3',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Win Win 3 tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Win Win 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-black-summer-3',
    name: 'Komatsuna - Black Summer 3',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Black Summer 3 komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Black Summer 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-rosie-3',
    name: 'Pac choi - Rosie 3',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Rosie 3 pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Rosie 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-chinese-broccoli-3',
    name: 'Gai lan - Chinese Broccoli 3',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Chinese Broccoli 3 gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Chinese Broccoli 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-kailaan-3',
    name: 'Choy sum - Kailaan 3',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Kailaan 3 choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Kailaan 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-white-stem-3',
    name: 'Amaranth - White Stem 3',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'White Stem 3 amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['White Stem 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-thousand-head-3',
    name: 'Malabar spinach - Thousand Head 3',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Thousand Head 3 malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Thousand Head 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-suiho-3',
    name: 'Water spinach - Suiho 3',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Suiho 3 water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Suiho 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-hon-tsai-tai-3',
    name: 'Mustard - Hon Tsai Tai 3',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Hon Tsai Tai 3 mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Hon Tsai Tai 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-yu-choy-3',
    name: 'Mizuna - Yu Choy 3',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Yu Choy 3 mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Yu Choy 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-choy-sum-3',
    name: 'Tatsoi - Choy Sum 3',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Choy Sum 3 tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Choy Sum 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-flowering-cabbage-3',
    name: 'Komatsuna - Flowering Cabbage 3',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Flowering Cabbage 3 komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Flowering Cabbage 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-mock-pak-choy-3',
    name: 'Pac choi - Mock Pak Choy 3',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Mock Pak Choy 3 pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mock Pak Choy 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-callaloo-3',
    name: 'Gai lan - Callaloo 3',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Callaloo 3 gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Callaloo 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-chinese-spinach-3',
    name: 'Choy sum - Chinese Spinach 3',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Chinese Spinach 3 choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Chinese Spinach 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-josephs-coat-3',
    name: 'Amaranth - Josephs Coat 3',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Josephs Coat 3 amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Josephs Coat 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-love-lies-bleeding-3',
    name: 'Malabar spinach - Love Lies Bleeding 3',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Love Lies Bleeding 3 malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Love Lies Bleeding 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-red-leaf-3',
    name: 'Water spinach - Red Leaf 3',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Red Leaf 3 water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Red Leaf 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-basella-3',
    name: 'Mustard - Basella 3',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Basella 3 mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Basella 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-ceylon-spinach-3',
    name: 'Mizuna - Ceylon Spinach 3',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Ceylon Spinach 3 mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Ceylon Spinach 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-indian-spinach-3',
    name: 'Tatsoi - Indian Spinach 3',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Indian Spinach 3 tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Indian Spinach 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-vine-spinach-3',
    name: 'Komatsuna - Vine Spinach 3',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Vine Spinach 3 komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Vine Spinach 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-malabar-3',
    name: 'Pac choi - Malabar 3',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Malabar 3 pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Malabar 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-kangkong-3',
    name: 'Gai lan - Kangkong 3',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Kangkong 3 gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Kangkong 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-river-spinach-3',
    name: 'Choy sum - River Spinach 3',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'River Spinach 3 choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['River Spinach 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-water-morning-glory-3',
    name: 'Amaranth - Water Morning Glory 3',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Water Morning Glory 3 amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Water Morning Glory 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-swamp-cabbage-3',
    name: 'Malabar spinach - Swamp Cabbage 3',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Swamp Cabbage 3 malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Swamp Cabbage 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-ong-choy-3',
    name: 'Water spinach - Ong Choy 3',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Ong Choy 3 water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Ong Choy 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-tah-tsai-3',
    name: 'Mustard - Tah Tsai 3',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Tah Tsai 3 mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Tah Tsai 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-rosette-3',
    name: 'Mizuna - Rosette 3',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Rosette 3 mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Rosette 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-spoon-3',
    name: 'Tatsoi - Spoon 3',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Spoon 3 tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Spoon 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-flat-3',
    name: 'Komatsuna - Flat 3',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Flat 3 komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Flat 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-purple-3',
    name: 'Pac choi - Purple 3',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Purple 3 pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Purple 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-golden-3',
    name: 'Gai lan - Golden 3',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Golden 3 gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Golden 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-yellow-3',
    name: 'Choy sum - Yellow 3',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Yellow 3 choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Yellow 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-green-3',
    name: 'Amaranth - Green 3',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Green 3 amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Green 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-red-3',
    name: 'Malabar spinach - Red 3',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Red 3 malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Red 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-white-3',
    name: 'Water spinach - White 3',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'White 3 water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['White 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-prize-choy-3',
    name: 'Mustard - Prize Choy 3',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Prize Choy 3 mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Prize Choy 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-summer-3',
    name: 'Mizuna - Summer 3',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Summer 3 mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Summer 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-spring-3',
    name: 'Tatsoi - Spring 3',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Spring 3 tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Spring 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-winter-3',
    name: 'Komatsuna - Winter 3',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Winter 3 komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Winter 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-mini-3',
    name: 'Pac choi - Mini 3',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Mini 3 pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mini 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-long-3',
    name: 'Gai lan - Long 3',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Long 3 gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Long 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-short-3',
    name: 'Choy sum - Short 3',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Short 3 choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Short 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-fat-3',
    name: 'Amaranth - Fat 3',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Fat 3 amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Fat 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-thin-3',
    name: 'Malabar spinach - Thin 3',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Thin 3 malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Thin 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-dwarf-3',
    name: 'Water spinach - Dwarf 3',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Dwarf 3 water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Dwarf 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-giant-3',
    name: 'Mustard - Giant 3',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Giant 3 mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Giant 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-baby-3',
    name: 'Mizuna - Baby 3',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Baby 3 mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Baby 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-micro-3',
    name: 'Tatsoi - Micro 3',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Micro 3 tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Micro 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-teen-3',
    name: 'Komatsuna - Teen 3',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Teen 3 komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Teen 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-tot-3',
    name: 'Pac choi - Tot 3',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Tot 3 pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Tot 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-extra-dwarf-3',
    name: 'Gai lan - Extra Dwarf 3',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Extra Dwarf 3 gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Extra Dwarf 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-super-dwarf-3',
    name: 'Choy sum - Super Dwarf 3',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Super Dwarf 3 choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Super Dwarf 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-dwarf-green-3',
    name: 'Amaranth - Dwarf Green 3',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Dwarf Green 3 amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Dwarf Green 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-dwarf-white-3',
    name: 'Malabar spinach - Dwarf White 3',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Dwarf White 3 malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Dwarf White 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-dwarf-red-3',
    name: 'Water spinach - Dwarf Red 3',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Dwarf Red 3 water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Dwarf Red 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-large-3',
    name: 'Mustard - Large 3',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Large 3 mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Large 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-medium-3',
    name: 'Mizuna - Medium 3',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Medium 3 mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Medium 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-small-3',
    name: 'Tatsoi - Small 3',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Small 3 tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Small 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-extra-large-3',
    name: 'Komatsuna - Extra Large 3',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Extra Large 3 komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Extra Large 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-jumbo-3',
    name: 'Pac choi - Jumbo 3',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Jumbo 3 pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Jumbo 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-quick-3',
    name: 'Gai lan - Quick 3',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Quick 3 gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Quick 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-fast-3',
    name: 'Choy sum - Fast 3',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Fast 3 choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Fast 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-speedy-3',
    name: 'Amaranth - Speedy 3',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Speedy 3 amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Speedy 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-rapid-3',
    name: 'Malabar spinach - Rapid 3',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Rapid 3 malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Rapid 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-swift-3',
    name: 'Water spinach - Swift 3',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Swift 3 water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Swift 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-slow-3',
    name: 'Mustard - Slow 3',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Slow 3 mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Slow 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-long-season-3',
    name: 'Mizuna - Long Season 3',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Long Season 3 mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Long Season 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-extended-3',
    name: 'Tatsoi - Extended 3',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Extended 3 tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Extended 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-prolonged-3',
    name: 'Komatsuna - Prolonged 3',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Prolonged 3 komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Prolonged 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-delayed-3',
    name: 'Pac choi - Delayed 3',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Delayed 3 pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Delayed 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-bolt-resistant-3',
    name: 'Gai lan - Bolt Resistant 3',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Bolt Resistant 3 gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Bolt Resistant 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-slow-bolt-3',
    name: 'Choy sum - Slow Bolt 3',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Slow Bolt 3 choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Slow Bolt 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-heat-tolerant-3',
    name: 'Amaranth - Heat Tolerant 3',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Heat Tolerant 3 amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Heat Tolerant 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-cold-hardy-3',
    name: 'Malabar spinach - Cold Hardy 3',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Cold Hardy 3 malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Cold Hardy 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-frost-resistant-3',
    name: 'Water spinach - Frost Resistant 3',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Frost Resistant 3 water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Frost Resistant 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-early-3',
    name: 'Mustard - Early 3',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Early 3 mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Early 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-mid-3',
    name: 'Mizuna - Mid 3',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Mid 3 mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mid 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-late-3',
    name: 'Tatsoi - Late 3',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Late 3 tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Late 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-main-season-3',
    name: 'Komatsuna - Main Season 3',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Main Season 3 komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Main Season 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-fall-3',
    name: 'Pac choi - Fall 3',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Fall 3 pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Fall 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-spring-3',
    name: 'Gai lan - Spring 3',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Spring 3 gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Spring 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-summer-3',
    name: 'Choy sum - Summer 3',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Summer 3 choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Summer 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-winter-3',
    name: 'Amaranth - Winter 3',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Winter 3 amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Winter 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-all-season-3',
    name: 'Malabar spinach - All Season 3',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'All Season 3 malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['All Season 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-year-round-3',
    name: 'Water spinach - Year Round 3',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Year Round 3 water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Year Round 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-sprint-3',
    name: 'Mustard - Sprint 3',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Sprint 3 mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Sprint 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-marathon-3',
    name: 'Mizuna - Marathon 3',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Marathon 3 mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Marathon 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-dash-3',
    name: 'Tatsoi - Dash 3',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Dash 3 tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Dash 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-race-3',
    name: 'Komatsuna - Race 3',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Race 3 komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Race 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-run-3',
    name: 'Pac choi - Run 3',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Run 3 pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Run 3'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-green-wave-4',
    name: 'Gai lan - Green Wave 4',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Green Wave 4 gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Green Wave 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-red-giant-4',
    name: 'Choy sum - Red Giant 4',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Red Giant 4 choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Red Giant 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-southern-giant-4',
    name: 'Amaranth - Southern Giant 4',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Southern Giant 4 amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Southern Giant 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-florida-broadleaf-4',
    name: 'Malabar spinach - Florida Broadleaf 4',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Florida Broadleaf 4 malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Florida Broadleaf 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-osaka-purple-4',
    name: 'Water spinach - Osaka Purple 4',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Osaka Purple 4 water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Osaka Purple 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-ruby-streaks-4',
    name: 'Mustard - Ruby Streaks 4',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Ruby Streaks 4 mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Ruby Streaks 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-golden-frills-4',
    name: 'Mizuna - Golden Frills 4',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Golden Frills 4 mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Golden Frills 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-scarlet-frills-4',
    name: 'Tatsoi - Scarlet Frills 4',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Scarlet Frills 4 tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Scarlet Frills 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-red-rain-4',
    name: 'Komatsuna - Red Rain 4',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Red Rain 4 komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Red Rain 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-dragon-tongue-4',
    name: 'Pac choi - Dragon Tongue 4',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Dragon Tongue 4 pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Dragon Tongue 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-kyona-4',
    name: 'Gai lan - Kyona 4',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Kyona 4 gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Kyona 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-kyoto-4',
    name: 'Choy sum - Kyoto 4',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Kyoto 4 choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Kyoto 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-early-4',
    name: 'Amaranth - Early 4',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Early 4 amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Early 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-shogoin-4',
    name: 'Malabar spinach - Shogoin 4',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Shogoin 4 malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Shogoin 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-mibuna-4',
    name: 'Water spinach - Mibuna 4',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Mibuna 4 water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Mibuna 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-komatsuna-4',
    name: 'Mustard - Komatsuna 4',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Komatsuna 4 mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Komatsuna 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-japanese-mustard-spinach-4',
    name: 'Mizuna - Japanese Mustard Spinach 4',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Japanese Mustard Spinach 4 mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Japanese Mustard Spinach 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-torasan-4',
    name: 'Tatsoi - Torasan 4',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Torasan 4 tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Torasan 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-summer-fest-4',
    name: 'Komatsuna - Summer Fest 4',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Summer Fest 4 komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Summer Fest 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-carlton-4',
    name: 'Pac choi - Carlton 4',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Carlton 4 pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Carlton 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-mei-qing-4',
    name: 'Gai lan - Mei Qing 4',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Mei Qing 4 gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mei Qing 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-joi-choi-4',
    name: 'Choy sum - Joi Choi 4',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Joi Choi 4 choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Joi Choi 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-win-win-4',
    name: 'Amaranth - Win Win 4',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Win Win 4 amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Win Win 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-black-summer-4',
    name: 'Malabar spinach - Black Summer 4',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Black Summer 4 malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Black Summer 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-rosie-4',
    name: 'Water spinach - Rosie 4',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Rosie 4 water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Rosie 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-chinese-broccoli-4',
    name: 'Mustard - Chinese Broccoli 4',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Chinese Broccoli 4 mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Chinese Broccoli 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-kailaan-4',
    name: 'Mizuna - Kailaan 4',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Kailaan 4 mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Kailaan 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-white-stem-4',
    name: 'Tatsoi - White Stem 4',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'White Stem 4 tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['White Stem 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-thousand-head-4',
    name: 'Komatsuna - Thousand Head 4',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Thousand Head 4 komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Thousand Head 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-suiho-4',
    name: 'Pac choi - Suiho 4',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Suiho 4 pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Suiho 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-hon-tsai-tai-4',
    name: 'Gai lan - Hon Tsai Tai 4',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Hon Tsai Tai 4 gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Hon Tsai Tai 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-yu-choy-4',
    name: 'Choy sum - Yu Choy 4',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Yu Choy 4 choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Yu Choy 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-choy-sum-4',
    name: 'Amaranth - Choy Sum 4',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Choy Sum 4 amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Choy Sum 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-flowering-cabbage-4',
    name: 'Malabar spinach - Flowering Cabbage 4',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Flowering Cabbage 4 malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Flowering Cabbage 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-mock-pak-choy-4',
    name: 'Water spinach - Mock Pak Choy 4',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Mock Pak Choy 4 water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Mock Pak Choy 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-callaloo-4',
    name: 'Mustard - Callaloo 4',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Callaloo 4 mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Callaloo 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-chinese-spinach-4',
    name: 'Mizuna - Chinese Spinach 4',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Chinese Spinach 4 mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Chinese Spinach 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-josephs-coat-4',
    name: 'Tatsoi - Josephs Coat 4',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'grain',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Josephs Coat 4 tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Josephs Coat 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-love-lies-bleeding-4',
    name: 'Komatsuna - Love Lies Bleeding 4',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Love Lies Bleeding 4 komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Love Lies Bleeding 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-red-leaf-4',
    name: 'Pac choi - Red Leaf 4',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Red Leaf 4 pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Red Leaf 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-basella-4',
    name: 'Gai lan - Basella 4',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Basella 4 gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Basella 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-ceylon-spinach-4',
    name: 'Choy sum - Ceylon Spinach 4',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Ceylon Spinach 4 choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Ceylon Spinach 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-indian-spinach-4',
    name: 'Amaranth - Indian Spinach 4',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Indian Spinach 4 amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Indian Spinach 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-vine-spinach-4',
    name: 'Malabar spinach - Vine Spinach 4',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Vine Spinach 4 malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Vine Spinach 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-malabar-4',
    name: 'Water spinach - Malabar 4',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Malabar 4 water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Malabar 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mustard-kangkong-4',
    name: 'Mustard - Kangkong 4',
    scientificName: 'Brassica juncea',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Kangkong 4 mustard. Spicy Asian green, quick growing.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Kangkong 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'mizuna-river-spinach-4',
    name: 'Mizuna - River Spinach 4',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'River Spinach 4 mizuna. Feathery mild mustard, salad favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['River Spinach 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'tatsoi-water-morning-glory-4',
    name: 'Tatsoi - Water Morning Glory 4',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Water Morning Glory 4 tatsoi. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Water Morning Glory 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'komatsuna-swamp-cabbage-4',
    name: 'Komatsuna - Swamp Cabbage 4',
    scientificName: 'Brassica rapa var. perviridis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Swamp Cabbage 4 komatsuna. Japanese mustard spinach, mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Swamp Cabbage 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'pac-choi-ong-choy-4',
    name: 'Pac choi - Ong Choy 4',
    scientificName: 'Brassica rapa subsp. chinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Ong Choy 4 pac choi. Chinese cabbage, crisp and mild.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Ong Choy 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'gai-lan-tah-tsai-4',
    name: 'Gai lan - Tah Tsai 4',
    scientificName: 'Brassica oleracea var. alboglabra',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Tah Tsai 4 gai lan. Chinese broccoli, tender stems.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Tah Tsai 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'choy-sum-rosette-4',
    name: 'Choy sum - Rosette 4',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 40,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Rosette 4 choy sum. Flowering stems, sweet and tender.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Rosette 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'amaranth-spoon-4',
    name: 'Amaranth - Spoon 4',
    scientificName: 'Amaranthus spp',
    category: 'grain',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 50,
    sun: 'partial',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Spoon 4 amaranth. Colorful leaves, nutritious grain.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '4-6 feet',
    spread: '2-3 feet',
    family: 'Amaranthaceae',
    varieties: ['Spoon 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'malabar-spinach-flat-4',
    name: 'Malabar spinach - Flat 4',
    scientificName: 'Basella alba',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Flat 4 malabar spinach. Vining spinach substitute, heat loving.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Basellaceae',
    varieties: ['Flat 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  },
  {
    id: 'water-spinach-purple-4',
    name: 'Water spinach - Purple 4',
    scientificName: 'Ipomoea aquatica',
    category: 'vegetable',
    spacing: 12,
    rowSpacing: 18,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'high',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['carrot', 'onion'],
    enemies: ['strawberry'],
    description: 'Purple 4 water spinach. Aquatic green, stir-fry favorite.',
    hardinessZones: '9-11',
    plantingSeason: 'spring',
    height: 'vines to 10 feet',
    spread: '2-3 feet',
    family: 'Convolvulaceae',
    varieties: ['Purple 4'],
    uses: ['stir fry', 'soup', 'salads', 'asian cuisine', 'steaming']
  }
,
  {
    id: 'brussels-sprout-long-island-improved',
    name: 'Brussels sprout - Long Island Improved',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Long Island Improved brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Long Island Improved'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-diablo',
    name: 'Kohlrabi - Diablo',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Diablo kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Diablo'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-jade-cross',
    name: 'Rapini - Jade Cross',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Jade Cross rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Jade Cross'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-oliver',
    name: 'Mizuna - Oliver',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Oliver mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Oliver'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-nautic',
    name: 'Mibuna - Nautic',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Nautic mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Nautic'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-brilliant',
    name: 'Tatsol - Brilliant',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Brilliant tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Brilliant'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-cryptus',
    name: 'Hon tsai tai - Cryptus',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Cryptus hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Cryptus'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-dimitri',
    name: 'Yukina savoy - Dimitri',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Dimitri yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Dimitri'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-doric',
    name: 'Brussels sprout - Doric',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Doric brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Doric'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-gustus',
    name: 'Kohlrabi - Gustus',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Gustus kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Gustus'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-hestia',
    name: 'Rapini - Hestia',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Hestia rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Hestia'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-maximus',
    name: 'Mizuna - Maximus',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Maximus mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Maximus'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-octia',
    name: 'Mibuna - Octia',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Octia mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Octia'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-revenge',
    name: 'Tatsol - Revenge',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Revenge tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Revenge'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-roodnerf',
    name: 'Hon tsai tai - Roodnerf',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Roodnerf hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Roodnerf'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-rubine',
    name: 'Yukina savoy - Rubine',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Rubine yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Rubine'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-ruffles',
    name: 'Brussels sprout - Ruffles',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Ruffles brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Ruffles'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-stratus',
    name: 'Kohlrabi - Stratus',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Stratus kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Stratus'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-tasty-nuggets',
    name: 'Rapini - Tasty Nuggets',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Tasty Nuggets rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Tasty Nuggets'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-valiant',
    name: 'Mizuna - Valiant',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Valiant mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Valiant'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-white-vienna',
    name: 'Mibuna - White Vienna',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'White Vienna mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['White Vienna'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-purple-vienna',
    name: 'Tatsol - Purple Vienna',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Purple Vienna tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Purple Vienna'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-grand-duke',
    name: 'Hon tsai tai - Grand Duke',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Grand Duke hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Grand Duke'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-korridor',
    name: 'Yukina savoy - Korridor',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Korridor yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Korridor'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-kossak',
    name: 'Brussels sprout - Kossak',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Kossak brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Kossak'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-winner',
    name: 'Kohlrabi - Winner',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Winner kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Winner'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-kolibri',
    name: 'Rapini - Kolibri',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Kolibri rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Kolibri'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-azur-star',
    name: 'Mizuna - Azur Star',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Azur Star mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Azur Star'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-blaro',
    name: 'Mibuna - Blaro',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Blaro mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Blaro'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-delicacy',
    name: 'Tatsol - Delicacy',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Delicacy tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Delicacy'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-early-white',
    name: 'Hon tsai tai - Early White',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Early White hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Early White'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-early-purple',
    name: 'Yukina savoy - Early Purple',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Early Purple yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Early Purple'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-gigante',
    name: 'Brussels sprout - Gigante',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Gigante brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Gigante'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-kongo',
    name: 'Kohlrabi - Kongo',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Kongo kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Kongo'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-kossak',
    name: 'Rapini - Kossak',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Kossak rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Kossak'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-rapid',
    name: 'Mizuna - Rapid',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Rapid mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Rapid'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-superschmelz',
    name: 'Mibuna - Superschmelz',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Superschmelz mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Superschmelz'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-white-danube',
    name: 'Tatsol - White Danube',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'White Danube tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['White Danube'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-blanc',
    name: 'Hon tsai tai - Blanc',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Blanc hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Blanc'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-rouge',
    name: 'Yukina savoy - Rouge',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Rouge yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Rouge'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-rapini',
    name: 'Brussels sprout - Rapini',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Rapini brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Rapini'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-broccoli-raab',
    name: 'Kohlrabi - Broccoli Raab',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Broccoli Raab kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Broccoli Raab'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-rabe',
    name: 'Rapini - Rabe',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Rabe rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Rabe'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-rapine',
    name: 'Mizuna - Rapine',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Rapine mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Rapine'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-chinese-broccoli',
    name: 'Mibuna - Chinese Broccoli',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Chinese Broccoli mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Chinese Broccoli'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-sessantina',
    name: 'Tatsol - Sessantina',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Sessantina tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Sessantina'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-quarantina',
    name: 'Hon tsai tai - Quarantina',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Quarantina hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Quarantina'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-cima-di-rapa',
    name: 'Yukina savoy - Cima di Rapa',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Cima di Rapa yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Cima di Rapa'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-spring',
    name: 'Brussels sprout - Spring',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Spring brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Spring'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-fall',
    name: 'Kohlrabi - Fall',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Fall kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Fall'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-zamboni',
    name: 'Rapini - Zamboni',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Zamboni rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Zamboni'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-sorrento',
    name: 'Mizuna - Sorrento',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Sorrento mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Sorrento'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-novantina',
    name: 'Mibuna - Novantina',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Novantina mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Novantina'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-centoventina',
    name: 'Tatsol - Centoventina',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Centoventina tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Centoventina'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-super-rapini',
    name: 'Hon tsai tai - Super Rapini',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Super Rapini hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Super Rapini'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-kyoto',
    name: 'Yukina savoy - Kyoto',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Kyoto yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Kyoto'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-mizuna',
    name: 'Brussels sprout - Mizuna',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Mizuna brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Mizuna'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-kyona',
    name: 'Kohlrabi - Kyona',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Kyona kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Kyona'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-early',
    name: 'Rapini - Early',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Early rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Early'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-shogoin',
    name: 'Mizuna - Shogoin',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Shogoin mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Shogoin'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-mibuna',
    name: 'Mibuna - Mibuna',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Mibuna mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mibuna'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-japanese-mustard',
    name: 'Tatsol - Japanese Mustard',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Japanese Mustard tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Japanese Mustard'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-spoon',
    name: 'Hon tsai tai - Spoon',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Spoon hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Spoon'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-tendergreen',
    name: 'Yukina savoy - Tendergreen',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Tendergreen yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Tendergreen'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-mustard',
    name: 'Brussels sprout - Mustard',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Mustard brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Mustard'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-tatsoi',
    name: 'Kohlrabi - Tatsoi',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Tatsoi kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Tatsoi'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-rosette',
    name: 'Rapini - Rosette',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Rosette rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Rosette'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-spoon',
    name: 'Mizuna - Spoon',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Spoon mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Spoon'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-flat',
    name: 'Mibuna - Flat',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Flat mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Flat'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-purple',
    name: 'Tatsol - Purple',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Purple tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Purple'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-golden',
    name: 'Hon tsai tai - Golden',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Golden hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Golden'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-yellow',
    name: 'Yukina savoy - Yellow',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Yellow yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Yellow'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-green',
    name: 'Brussels sprout - Green',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Green brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Green'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-red',
    name: 'Kohlrabi - Red',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Red kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Red'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-white',
    name: 'Rapini - White',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'White rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['White'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-hon-tsai-tai',
    name: 'Mizuna - Hon Tsai Tai',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Hon Tsai Tai mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Hon Tsai Tai'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-yu-choy',
    name: 'Mibuna - Yu Choy',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Yu Choy mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Yu Choy'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-choy-sum',
    name: 'Tatsol - Choy Sum',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Choy Sum tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Choy Sum'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-mock',
    name: 'Hon tsai tai - Mock',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Mock hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mock'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-chinese',
    name: 'Yukina savoy - Chinese',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Chinese yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Chinese'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-yukina-savoy',
    name: 'Brussels sprout - Yukina Savoy',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Yukina Savoy brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Yukina Savoy'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-savoy',
    name: 'Kohlrabi - Savoy',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Savoy kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Savoy'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-mild',
    name: 'Rapini - Mild',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Mild rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mild'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-tender',
    name: 'Mizuna - Tender',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Tender mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Tender'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-asian',
    name: 'Mibuna - Asian',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Asian mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Asian'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-gai-choy',
    name: 'Tatsol - Gai Choy',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Gai Choy tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Gai Choy'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-chinese-mustard',
    name: 'Hon tsai tai - Chinese Mustard',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Chinese Mustard hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Chinese Mustard'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-indian',
    name: 'Yukina savoy - Indian',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Indian yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Indian'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-leaf',
    name: 'Brussels sprout - Leaf',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Leaf brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Leaf'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-stem',
    name: 'Kohlrabi - Stem',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Stem kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Stem'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-hanakan',
    name: 'Rapini - Hanakan',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Hanakan rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Hanakan'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-ornamental',
    name: 'Mizuna - Ornamental',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Ornamental mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Ornamental'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-edible',
    name: 'Mibuna - Edible',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Edible mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Edible'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-decorative',
    name: 'Tatsol - Decorative',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Decorative tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Decorative'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-beautiful',
    name: 'Hon tsai tai - Beautiful',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Beautiful hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Beautiful'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-red',
    name: 'Yukina savoy - Red',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Red yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Red'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-green',
    name: 'Brussels sprout - Green',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Green brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Green'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-purple',
    name: 'Kohlrabi - Purple',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Purple kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Purple'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-white',
    name: 'Rapini - White',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'White rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['White'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-yellow',
    name: 'Mizuna - Yellow',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Yellow mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Yellow'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-giant',
    name: 'Mibuna - Giant',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Giant mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Giant'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-dwarf',
    name: 'Tatsol - Dwarf',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Dwarf tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Dwarf'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-baby',
    name: 'Hon tsai tai - Baby',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Baby hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Baby'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-micro',
    name: 'Yukina savoy - Micro',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Micro yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Micro'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-mini',
    name: 'Brussels sprout - Mini',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Mini brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Mini'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-large',
    name: 'Kohlrabi - Large',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Large kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Large'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-medium',
    name: 'Rapini - Medium',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Medium rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Medium'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-small',
    name: 'Mizuna - Small',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Small mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Small'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-extra-large',
    name: 'Mibuna - Extra Large',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Extra Large mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Extra Large'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-jumbo',
    name: 'Tatsol - Jumbo',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Jumbo tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Jumbo'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-quick',
    name: 'Hon tsai tai - Quick',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Quick hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Quick'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-fast',
    name: 'Yukina savoy - Fast',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Fast yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Fast'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-speedy',
    name: 'Brussels sprout - Speedy',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Speedy brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Speedy'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-rapid',
    name: 'Kohlrabi - Rapid',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Rapid kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Rapid'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-swift',
    name: 'Rapini - Swift',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Swift rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Swift'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-slow',
    name: 'Mizuna - Slow',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Slow mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Slow'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-long-season',
    name: 'Mibuna - Long Season',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Long Season mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Long Season'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-extended',
    name: 'Tatsol - Extended',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Extended tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Extended'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-prolonged',
    name: 'Hon tsai tai - Prolonged',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Prolonged hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Prolonged'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-delayed',
    name: 'Yukina savoy - Delayed',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Delayed yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Delayed'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-bolt-resistant',
    name: 'Brussels sprout - Bolt Resistant',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Bolt Resistant brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Bolt Resistant'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-slow-bolt',
    name: 'Kohlrabi - Slow Bolt',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Slow Bolt kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Slow Bolt'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-heat-tolerant',
    name: 'Rapini - Heat Tolerant',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Heat Tolerant rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Heat Tolerant'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-cold-hardy',
    name: 'Mizuna - Cold Hardy',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Cold Hardy mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Cold Hardy'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-frost-resistant',
    name: 'Mibuna - Frost Resistant',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Frost Resistant mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Frost Resistant'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-early',
    name: 'Tatsol - Early',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Early tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Early'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-mid',
    name: 'Hon tsai tai - Mid',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Mid hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mid'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-late',
    name: 'Yukina savoy - Late',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Late yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Late'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-main-season',
    name: 'Brussels sprout - Main Season',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Main Season brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Main Season'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-fall',
    name: 'Kohlrabi - Fall',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Fall kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Fall'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-spring',
    name: 'Rapini - Spring',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Spring rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Spring'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-summer',
    name: 'Mizuna - Summer',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Summer mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Summer'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-winter',
    name: 'Mibuna - Winter',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Winter mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Winter'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-all-season',
    name: 'Tatsol - All Season',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'All Season tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['All Season'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-year-round',
    name: 'Hon tsai tai - Year Round',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Year Round hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Year Round'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-long-island-improved-2',
    name: 'Yukina savoy - Long Island Improved 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Long Island Improved 2 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Long Island Improved 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-diablo-2',
    name: 'Brussels sprout - Diablo 2',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Diablo 2 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Diablo 2'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-jade-cross-2',
    name: 'Kohlrabi - Jade Cross 2',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Jade Cross 2 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Jade Cross 2'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-oliver-2',
    name: 'Rapini - Oliver 2',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Oliver 2 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Oliver 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-nautic-2',
    name: 'Mizuna - Nautic 2',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Nautic 2 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Nautic 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-brilliant-2',
    name: 'Mibuna - Brilliant 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Brilliant 2 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Brilliant 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-cryptus-2',
    name: 'Tatsol - Cryptus 2',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Cryptus 2 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Cryptus 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-dimitri-2',
    name: 'Hon tsai tai - Dimitri 2',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Dimitri 2 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Dimitri 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-doric-2',
    name: 'Yukina savoy - Doric 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Doric 2 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Doric 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-gustus-2',
    name: 'Brussels sprout - Gustus 2',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Gustus 2 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Gustus 2'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-hestia-2',
    name: 'Kohlrabi - Hestia 2',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Hestia 2 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Hestia 2'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-maximus-2',
    name: 'Rapini - Maximus 2',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Maximus 2 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Maximus 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-octia-2',
    name: 'Mizuna - Octia 2',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Octia 2 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Octia 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-revenge-2',
    name: 'Mibuna - Revenge 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Revenge 2 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Revenge 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-roodnerf-2',
    name: 'Tatsol - Roodnerf 2',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Roodnerf 2 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Roodnerf 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-rubine-2',
    name: 'Hon tsai tai - Rubine 2',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Rubine 2 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Rubine 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-ruffles-2',
    name: 'Yukina savoy - Ruffles 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Ruffles 2 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Ruffles 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-stratus-2',
    name: 'Brussels sprout - Stratus 2',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Stratus 2 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Stratus 2'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-tasty-nuggets-2',
    name: 'Kohlrabi - Tasty Nuggets 2',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Tasty Nuggets 2 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Tasty Nuggets 2'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-valiant-2',
    name: 'Rapini - Valiant 2',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Valiant 2 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Valiant 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-white-vienna-2',
    name: 'Mizuna - White Vienna 2',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'White Vienna 2 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['White Vienna 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-purple-vienna-2',
    name: 'Mibuna - Purple Vienna 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Purple Vienna 2 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Purple Vienna 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-grand-duke-2',
    name: 'Tatsol - Grand Duke 2',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Grand Duke 2 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Grand Duke 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-korridor-2',
    name: 'Hon tsai tai - Korridor 2',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Korridor 2 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Korridor 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-kossak-2',
    name: 'Yukina savoy - Kossak 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Kossak 2 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Kossak 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-winner-2',
    name: 'Brussels sprout - Winner 2',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Winner 2 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Winner 2'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-kolibri-2',
    name: 'Kohlrabi - Kolibri 2',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Kolibri 2 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Kolibri 2'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-azur-star-2',
    name: 'Rapini - Azur Star 2',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Azur Star 2 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Azur Star 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-blaro-2',
    name: 'Mizuna - Blaro 2',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Blaro 2 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Blaro 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-delicacy-2',
    name: 'Mibuna - Delicacy 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Delicacy 2 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Delicacy 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-early-white-2',
    name: 'Tatsol - Early White 2',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Early White 2 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Early White 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-early-purple-2',
    name: 'Hon tsai tai - Early Purple 2',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Early Purple 2 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Early Purple 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-gigante-2',
    name: 'Yukina savoy - Gigante 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Gigante 2 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Gigante 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-kongo-2',
    name: 'Brussels sprout - Kongo 2',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Kongo 2 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Kongo 2'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-kossak-2',
    name: 'Kohlrabi - Kossak 2',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Kossak 2 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Kossak 2'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-rapid-2',
    name: 'Rapini - Rapid 2',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Rapid 2 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Rapid 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-superschmelz-2',
    name: 'Mizuna - Superschmelz 2',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Superschmelz 2 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Superschmelz 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-white-danube-2',
    name: 'Mibuna - White Danube 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'White Danube 2 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['White Danube 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-blanc-2',
    name: 'Tatsol - Blanc 2',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Blanc 2 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Blanc 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-rouge-2',
    name: 'Hon tsai tai - Rouge 2',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Rouge 2 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Rouge 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-rapini-2',
    name: 'Yukina savoy - Rapini 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Rapini 2 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Rapini 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-broccoli-raab-2',
    name: 'Brussels sprout - Broccoli Raab 2',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Broccoli Raab 2 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Broccoli Raab 2'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-rabe-2',
    name: 'Kohlrabi - Rabe 2',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Rabe 2 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Rabe 2'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-rapine-2',
    name: 'Rapini - Rapine 2',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Rapine 2 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Rapine 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-chinese-broccoli-2',
    name: 'Mizuna - Chinese Broccoli 2',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Chinese Broccoli 2 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Chinese Broccoli 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-sessantina-2',
    name: 'Mibuna - Sessantina 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Sessantina 2 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Sessantina 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-quarantina-2',
    name: 'Tatsol - Quarantina 2',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Quarantina 2 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Quarantina 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-cima-di-rapa-2',
    name: 'Hon tsai tai - Cima di Rapa 2',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Cima di Rapa 2 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Cima di Rapa 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-spring-2',
    name: 'Yukina savoy - Spring 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Spring 2 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Spring 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-fall-2',
    name: 'Brussels sprout - Fall 2',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Fall 2 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Fall 2'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-zamboni-2',
    name: 'Kohlrabi - Zamboni 2',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Zamboni 2 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Zamboni 2'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-sorrento-2',
    name: 'Rapini - Sorrento 2',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Sorrento 2 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Sorrento 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-novantina-2',
    name: 'Mizuna - Novantina 2',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Novantina 2 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Novantina 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-centoventina-2',
    name: 'Mibuna - Centoventina 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Centoventina 2 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Centoventina 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-super-rapini-2',
    name: 'Tatsol - Super Rapini 2',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Super Rapini 2 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Super Rapini 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-kyoto-2',
    name: 'Hon tsai tai - Kyoto 2',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Kyoto 2 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Kyoto 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-mizuna-2',
    name: 'Yukina savoy - Mizuna 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Mizuna 2 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mizuna 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-kyona-2',
    name: 'Brussels sprout - Kyona 2',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Kyona 2 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Kyona 2'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-early-2',
    name: 'Kohlrabi - Early 2',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Early 2 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Early 2'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-shogoin-2',
    name: 'Rapini - Shogoin 2',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Shogoin 2 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Shogoin 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-mibuna-2',
    name: 'Mizuna - Mibuna 2',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Mibuna 2 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mibuna 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-japanese-mustard-2',
    name: 'Mibuna - Japanese Mustard 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Japanese Mustard 2 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Japanese Mustard 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-spoon-2',
    name: 'Tatsol - Spoon 2',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Spoon 2 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Spoon 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-tendergreen-2',
    name: 'Hon tsai tai - Tendergreen 2',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Tendergreen 2 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Tendergreen 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-mustard-2',
    name: 'Yukina savoy - Mustard 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Mustard 2 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mustard 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-tatsoi-2',
    name: 'Brussels sprout - Tatsoi 2',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Tatsoi 2 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Tatsoi 2'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-rosette-2',
    name: 'Kohlrabi - Rosette 2',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Rosette 2 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Rosette 2'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-spoon-2',
    name: 'Rapini - Spoon 2',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Spoon 2 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Spoon 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-flat-2',
    name: 'Mizuna - Flat 2',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Flat 2 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Flat 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-purple-2',
    name: 'Mibuna - Purple 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Purple 2 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Purple 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-golden-2',
    name: 'Tatsol - Golden 2',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Golden 2 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Golden 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-yellow-2',
    name: 'Hon tsai tai - Yellow 2',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Yellow 2 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Yellow 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-green-2',
    name: 'Yukina savoy - Green 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Green 2 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Green 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-red-2',
    name: 'Brussels sprout - Red 2',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Red 2 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Red 2'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-white-2',
    name: 'Kohlrabi - White 2',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'White 2 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['White 2'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-hon-tsai-tai-2',
    name: 'Rapini - Hon Tsai Tai 2',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Hon Tsai Tai 2 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Hon Tsai Tai 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-yu-choy-2',
    name: 'Mizuna - Yu Choy 2',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Yu Choy 2 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Yu Choy 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-choy-sum-2',
    name: 'Mibuna - Choy Sum 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Choy Sum 2 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Choy Sum 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-mock-2',
    name: 'Tatsol - Mock 2',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Mock 2 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mock 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-chinese-2',
    name: 'Hon tsai tai - Chinese 2',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Chinese 2 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Chinese 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-yukina-savoy-2',
    name: 'Yukina savoy - Yukina Savoy 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Yukina Savoy 2 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Yukina Savoy 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-savoy-2',
    name: 'Brussels sprout - Savoy 2',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Savoy 2 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Savoy 2'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-mild-2',
    name: 'Kohlrabi - Mild 2',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Mild 2 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Mild 2'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-tender-2',
    name: 'Rapini - Tender 2',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Tender 2 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Tender 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-asian-2',
    name: 'Mizuna - Asian 2',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Asian 2 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Asian 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-gai-choy-2',
    name: 'Mibuna - Gai Choy 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Gai Choy 2 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Gai Choy 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-chinese-mustard-2',
    name: 'Tatsol - Chinese Mustard 2',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Chinese Mustard 2 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Chinese Mustard 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-indian-2',
    name: 'Hon tsai tai - Indian 2',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Indian 2 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Indian 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-leaf-2',
    name: 'Yukina savoy - Leaf 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Leaf 2 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Leaf 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-stem-2',
    name: 'Brussels sprout - Stem 2',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Stem 2 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Stem 2'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-hanakan-2',
    name: 'Kohlrabi - Hanakan 2',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Hanakan 2 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Hanakan 2'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-ornamental-2',
    name: 'Rapini - Ornamental 2',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Ornamental 2 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Ornamental 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-edible-2',
    name: 'Mizuna - Edible 2',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Edible 2 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Edible 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-decorative-2',
    name: 'Mibuna - Decorative 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Decorative 2 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Decorative 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-beautiful-2',
    name: 'Tatsol - Beautiful 2',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Beautiful 2 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Beautiful 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-red-2',
    name: 'Hon tsai tai - Red 2',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Red 2 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Red 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-green-2',
    name: 'Yukina savoy - Green 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Green 2 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Green 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-purple-2',
    name: 'Brussels sprout - Purple 2',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Purple 2 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Purple 2'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-white-2',
    name: 'Kohlrabi - White 2',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'White 2 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['White 2'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-yellow-2',
    name: 'Rapini - Yellow 2',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Yellow 2 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Yellow 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-giant-2',
    name: 'Mizuna - Giant 2',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Giant 2 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Giant 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-dwarf-2',
    name: 'Mibuna - Dwarf 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Dwarf 2 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Dwarf 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-baby-2',
    name: 'Tatsol - Baby 2',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Baby 2 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Baby 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-micro-2',
    name: 'Hon tsai tai - Micro 2',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Micro 2 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Micro 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-mini-2',
    name: 'Yukina savoy - Mini 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Mini 2 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mini 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-large-2',
    name: 'Brussels sprout - Large 2',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Large 2 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Large 2'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-medium-2',
    name: 'Kohlrabi - Medium 2',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Medium 2 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Medium 2'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-small-2',
    name: 'Rapini - Small 2',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Small 2 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Small 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-extra-large-2',
    name: 'Mizuna - Extra Large 2',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Extra Large 2 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Extra Large 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-jumbo-2',
    name: 'Mibuna - Jumbo 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Jumbo 2 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Jumbo 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-quick-2',
    name: 'Tatsol - Quick 2',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Quick 2 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Quick 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-fast-2',
    name: 'Hon tsai tai - Fast 2',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Fast 2 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Fast 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-speedy-2',
    name: 'Yukina savoy - Speedy 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Speedy 2 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Speedy 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-rapid-2',
    name: 'Brussels sprout - Rapid 2',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Rapid 2 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Rapid 2'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-swift-2',
    name: 'Kohlrabi - Swift 2',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Swift 2 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Swift 2'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-slow-2',
    name: 'Rapini - Slow 2',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Slow 2 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Slow 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-long-season-2',
    name: 'Mizuna - Long Season 2',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Long Season 2 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Long Season 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-extended-2',
    name: 'Mibuna - Extended 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Extended 2 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Extended 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-prolonged-2',
    name: 'Tatsol - Prolonged 2',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Prolonged 2 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Prolonged 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-delayed-2',
    name: 'Hon tsai tai - Delayed 2',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Delayed 2 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Delayed 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-bolt-resistant-2',
    name: 'Yukina savoy - Bolt Resistant 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Bolt Resistant 2 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Bolt Resistant 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-slow-bolt-2',
    name: 'Brussels sprout - Slow Bolt 2',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Slow Bolt 2 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Slow Bolt 2'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-heat-tolerant-2',
    name: 'Kohlrabi - Heat Tolerant 2',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Heat Tolerant 2 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Heat Tolerant 2'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-cold-hardy-2',
    name: 'Rapini - Cold Hardy 2',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Cold Hardy 2 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Cold Hardy 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-frost-resistant-2',
    name: 'Mizuna - Frost Resistant 2',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Frost Resistant 2 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Frost Resistant 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-early-2',
    name: 'Mibuna - Early 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Early 2 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Early 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-mid-2',
    name: 'Tatsol - Mid 2',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Mid 2 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mid 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-late-2',
    name: 'Hon tsai tai - Late 2',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Late 2 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Late 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-main-season-2',
    name: 'Yukina savoy - Main Season 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Main Season 2 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Main Season 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-fall-2',
    name: 'Brussels sprout - Fall 2',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Fall 2 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Fall 2'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-spring-2',
    name: 'Kohlrabi - Spring 2',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Spring 2 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Spring 2'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-summer-2',
    name: 'Rapini - Summer 2',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Summer 2 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Summer 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-winter-2',
    name: 'Mizuna - Winter 2',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Winter 2 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Winter 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-all-season-2',
    name: 'Mibuna - All Season 2',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'All Season 2 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['All Season 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-year-round-2',
    name: 'Tatsol - Year Round 2',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Year Round 2 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Year Round 2'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-long-island-improved-3',
    name: 'Hon tsai tai - Long Island Improved 3',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Long Island Improved 3 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Long Island Improved 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-diablo-3',
    name: 'Yukina savoy - Diablo 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Diablo 3 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Diablo 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-jade-cross-3',
    name: 'Brussels sprout - Jade Cross 3',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Jade Cross 3 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Jade Cross 3'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-oliver-3',
    name: 'Kohlrabi - Oliver 3',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Oliver 3 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Oliver 3'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-nautic-3',
    name: 'Rapini - Nautic 3',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Nautic 3 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Nautic 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-brilliant-3',
    name: 'Mizuna - Brilliant 3',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Brilliant 3 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Brilliant 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-cryptus-3',
    name: 'Mibuna - Cryptus 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Cryptus 3 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Cryptus 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-dimitri-3',
    name: 'Tatsol - Dimitri 3',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Dimitri 3 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Dimitri 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-doric-3',
    name: 'Hon tsai tai - Doric 3',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Doric 3 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Doric 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-gustus-3',
    name: 'Yukina savoy - Gustus 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Gustus 3 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Gustus 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-hestia-3',
    name: 'Brussels sprout - Hestia 3',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Hestia 3 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Hestia 3'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-maximus-3',
    name: 'Kohlrabi - Maximus 3',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Maximus 3 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Maximus 3'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-octia-3',
    name: 'Rapini - Octia 3',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Octia 3 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Octia 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-revenge-3',
    name: 'Mizuna - Revenge 3',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Revenge 3 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Revenge 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-roodnerf-3',
    name: 'Mibuna - Roodnerf 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Roodnerf 3 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Roodnerf 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-rubine-3',
    name: 'Tatsol - Rubine 3',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Rubine 3 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Rubine 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-ruffles-3',
    name: 'Hon tsai tai - Ruffles 3',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Ruffles 3 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Ruffles 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-stratus-3',
    name: 'Yukina savoy - Stratus 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Stratus 3 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Stratus 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-tasty-nuggets-3',
    name: 'Brussels sprout - Tasty Nuggets 3',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Tasty Nuggets 3 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Tasty Nuggets 3'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-valiant-3',
    name: 'Kohlrabi - Valiant 3',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Valiant 3 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Valiant 3'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-white-vienna-3',
    name: 'Rapini - White Vienna 3',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'White Vienna 3 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['White Vienna 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-purple-vienna-3',
    name: 'Mizuna - Purple Vienna 3',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Purple Vienna 3 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Purple Vienna 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-grand-duke-3',
    name: 'Mibuna - Grand Duke 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Grand Duke 3 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Grand Duke 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-korridor-3',
    name: 'Tatsol - Korridor 3',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Korridor 3 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Korridor 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-kossak-3',
    name: 'Hon tsai tai - Kossak 3',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Kossak 3 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Kossak 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-winner-3',
    name: 'Yukina savoy - Winner 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Winner 3 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Winner 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-kolibri-3',
    name: 'Brussels sprout - Kolibri 3',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Kolibri 3 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Kolibri 3'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-azur-star-3',
    name: 'Kohlrabi - Azur Star 3',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Azur Star 3 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Azur Star 3'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-blaro-3',
    name: 'Rapini - Blaro 3',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Blaro 3 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Blaro 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-delicacy-3',
    name: 'Mizuna - Delicacy 3',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Delicacy 3 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Delicacy 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-early-white-3',
    name: 'Mibuna - Early White 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Early White 3 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Early White 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-early-purple-3',
    name: 'Tatsol - Early Purple 3',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Early Purple 3 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Early Purple 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-gigante-3',
    name: 'Hon tsai tai - Gigante 3',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Gigante 3 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Gigante 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-kongo-3',
    name: 'Yukina savoy - Kongo 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Kongo 3 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Kongo 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-kossak-3',
    name: 'Brussels sprout - Kossak 3',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Kossak 3 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Kossak 3'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-rapid-3',
    name: 'Kohlrabi - Rapid 3',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Rapid 3 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Rapid 3'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-superschmelz-3',
    name: 'Rapini - Superschmelz 3',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Superschmelz 3 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Superschmelz 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-white-danube-3',
    name: 'Mizuna - White Danube 3',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'White Danube 3 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['White Danube 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-blanc-3',
    name: 'Mibuna - Blanc 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Blanc 3 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Blanc 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-rouge-3',
    name: 'Tatsol - Rouge 3',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Rouge 3 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Rouge 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-rapini-3',
    name: 'Hon tsai tai - Rapini 3',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Rapini 3 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Rapini 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-broccoli-raab-3',
    name: 'Yukina savoy - Broccoli Raab 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Broccoli Raab 3 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Broccoli Raab 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-rabe-3',
    name: 'Brussels sprout - Rabe 3',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Rabe 3 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Rabe 3'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-rapine-3',
    name: 'Kohlrabi - Rapine 3',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Rapine 3 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Rapine 3'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-chinese-broccoli-3',
    name: 'Rapini - Chinese Broccoli 3',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Chinese Broccoli 3 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Chinese Broccoli 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-sessantina-3',
    name: 'Mizuna - Sessantina 3',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Sessantina 3 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Sessantina 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-quarantina-3',
    name: 'Mibuna - Quarantina 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Quarantina 3 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Quarantina 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-cima-di-rapa-3',
    name: 'Tatsol - Cima di Rapa 3',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Cima di Rapa 3 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Cima di Rapa 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-spring-3',
    name: 'Hon tsai tai - Spring 3',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Spring 3 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Spring 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-fall-3',
    name: 'Yukina savoy - Fall 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Fall 3 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Fall 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-zamboni-3',
    name: 'Brussels sprout - Zamboni 3',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Zamboni 3 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Zamboni 3'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-sorrento-3',
    name: 'Kohlrabi - Sorrento 3',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Sorrento 3 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Sorrento 3'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-novantina-3',
    name: 'Rapini - Novantina 3',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Novantina 3 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Novantina 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-centoventina-3',
    name: 'Mizuna - Centoventina 3',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Centoventina 3 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Centoventina 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-super-rapini-3',
    name: 'Mibuna - Super Rapini 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Super Rapini 3 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Super Rapini 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-kyoto-3',
    name: 'Tatsol - Kyoto 3',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Kyoto 3 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Kyoto 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-mizuna-3',
    name: 'Hon tsai tai - Mizuna 3',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Mizuna 3 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mizuna 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-kyona-3',
    name: 'Yukina savoy - Kyona 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Kyona 3 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Kyona 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-early-3',
    name: 'Brussels sprout - Early 3',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Early 3 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Early 3'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-shogoin-3',
    name: 'Kohlrabi - Shogoin 3',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Shogoin 3 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Shogoin 3'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-mibuna-3',
    name: 'Rapini - Mibuna 3',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Mibuna 3 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mibuna 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-japanese-mustard-3',
    name: 'Mizuna - Japanese Mustard 3',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Japanese Mustard 3 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Japanese Mustard 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-spoon-3',
    name: 'Mibuna - Spoon 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Spoon 3 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Spoon 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-tendergreen-3',
    name: 'Tatsol - Tendergreen 3',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Tendergreen 3 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Tendergreen 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-mustard-3',
    name: 'Hon tsai tai - Mustard 3',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Mustard 3 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mustard 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-tatsoi-3',
    name: 'Yukina savoy - Tatsoi 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Tatsoi 3 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Tatsoi 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-rosette-3',
    name: 'Brussels sprout - Rosette 3',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Rosette 3 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Rosette 3'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-spoon-3',
    name: 'Kohlrabi - Spoon 3',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Spoon 3 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Spoon 3'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-flat-3',
    name: 'Rapini - Flat 3',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Flat 3 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Flat 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-purple-3',
    name: 'Mizuna - Purple 3',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Purple 3 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Purple 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-golden-3',
    name: 'Mibuna - Golden 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Golden 3 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Golden 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-yellow-3',
    name: 'Tatsol - Yellow 3',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Yellow 3 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Yellow 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-green-3',
    name: 'Hon tsai tai - Green 3',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Green 3 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Green 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-red-3',
    name: 'Yukina savoy - Red 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Red 3 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Red 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-white-3',
    name: 'Brussels sprout - White 3',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'White 3 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['White 3'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-hon-tsai-tai-3',
    name: 'Kohlrabi - Hon Tsai Tai 3',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Hon Tsai Tai 3 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Hon Tsai Tai 3'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-yu-choy-3',
    name: 'Rapini - Yu Choy 3',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Yu Choy 3 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Yu Choy 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-choy-sum-3',
    name: 'Mizuna - Choy Sum 3',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Choy Sum 3 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Choy Sum 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-mock-3',
    name: 'Mibuna - Mock 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Mock 3 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mock 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-chinese-3',
    name: 'Tatsol - Chinese 3',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Chinese 3 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Chinese 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-yukina-savoy-3',
    name: 'Hon tsai tai - Yukina Savoy 3',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Yukina Savoy 3 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Yukina Savoy 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-savoy-3',
    name: 'Yukina savoy - Savoy 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Savoy 3 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Savoy 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-mild-3',
    name: 'Brussels sprout - Mild 3',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Mild 3 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Mild 3'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-tender-3',
    name: 'Kohlrabi - Tender 3',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Tender 3 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Tender 3'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-asian-3',
    name: 'Rapini - Asian 3',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Asian 3 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Asian 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-gai-choy-3',
    name: 'Mizuna - Gai Choy 3',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Gai Choy 3 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Gai Choy 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-chinese-mustard-3',
    name: 'Mibuna - Chinese Mustard 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Chinese Mustard 3 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Chinese Mustard 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-indian-3',
    name: 'Tatsol - Indian 3',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Indian 3 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Indian 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-leaf-3',
    name: 'Hon tsai tai - Leaf 3',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Leaf 3 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Leaf 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-stem-3',
    name: 'Yukina savoy - Stem 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Stem 3 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Stem 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-hanakan-3',
    name: 'Brussels sprout - Hanakan 3',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Hanakan 3 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Hanakan 3'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-ornamental-3',
    name: 'Kohlrabi - Ornamental 3',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Ornamental 3 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Ornamental 3'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-edible-3',
    name: 'Rapini - Edible 3',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Edible 3 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Edible 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-decorative-3',
    name: 'Mizuna - Decorative 3',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Decorative 3 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Decorative 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-beautiful-3',
    name: 'Mibuna - Beautiful 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Beautiful 3 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Beautiful 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-red-3',
    name: 'Tatsol - Red 3',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Red 3 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Red 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-green-3',
    name: 'Hon tsai tai - Green 3',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Green 3 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Green 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-purple-3',
    name: 'Yukina savoy - Purple 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Purple 3 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Purple 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-white-3',
    name: 'Brussels sprout - White 3',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'White 3 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['White 3'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-yellow-3',
    name: 'Kohlrabi - Yellow 3',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Yellow 3 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Yellow 3'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-giant-3',
    name: 'Rapini - Giant 3',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Giant 3 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Giant 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-dwarf-3',
    name: 'Mizuna - Dwarf 3',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Dwarf 3 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Dwarf 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-baby-3',
    name: 'Mibuna - Baby 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Baby 3 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Baby 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-micro-3',
    name: 'Tatsol - Micro 3',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Micro 3 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Micro 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-mini-3',
    name: 'Hon tsai tai - Mini 3',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Mini 3 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mini 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-large-3',
    name: 'Yukina savoy - Large 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Large 3 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Large 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-medium-3',
    name: 'Brussels sprout - Medium 3',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Medium 3 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Medium 3'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-small-3',
    name: 'Kohlrabi - Small 3',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Small 3 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Small 3'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-extra-large-3',
    name: 'Rapini - Extra Large 3',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Extra Large 3 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Extra Large 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-jumbo-3',
    name: 'Mizuna - Jumbo 3',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Jumbo 3 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Jumbo 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-quick-3',
    name: 'Mibuna - Quick 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Quick 3 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Quick 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-fast-3',
    name: 'Tatsol - Fast 3',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Fast 3 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Fast 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-speedy-3',
    name: 'Hon tsai tai - Speedy 3',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Speedy 3 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Speedy 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-rapid-3',
    name: 'Yukina savoy - Rapid 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Rapid 3 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Rapid 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-swift-3',
    name: 'Brussels sprout - Swift 3',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Swift 3 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Swift 3'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-slow-3',
    name: 'Kohlrabi - Slow 3',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Slow 3 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Slow 3'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-long-season-3',
    name: 'Rapini - Long Season 3',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Long Season 3 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Long Season 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-extended-3',
    name: 'Mizuna - Extended 3',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Extended 3 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Extended 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-prolonged-3',
    name: 'Mibuna - Prolonged 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Prolonged 3 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Prolonged 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-delayed-3',
    name: 'Tatsol - Delayed 3',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Delayed 3 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Delayed 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-bolt-resistant-3',
    name: 'Hon tsai tai - Bolt Resistant 3',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Bolt Resistant 3 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Bolt Resistant 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-slow-bolt-3',
    name: 'Yukina savoy - Slow Bolt 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Slow Bolt 3 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Slow Bolt 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'brussels-sprout-heat-tolerant-3',
    name: 'Brussels sprout - Heat Tolerant 3',
    scientificName: 'Brassica oleracea var. gemmifera',
    category: 'vegetable',
    spacing: 18,
    rowSpacing: 24,
    daysToGermination: 7,
    daysToHarvest: 90,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Heat Tolerant 3 brussels sprout. Mini cabbages on tall stalks, improved by frost.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '2-3 feet',
    spread: '18-24 inches',
    family: 'Brassicaceae',
    varieties: ['Heat Tolerant 3'],
    uses: ['roasting', 'saute', 'bacon']
  },
  {
    id: 'kohlrabi-cold-hardy-3',
    name: 'Kohlrabi - Cold Hardy 3',
    scientificName: 'Brassica oleracea var. gongylodes',
    category: 'vegetable',
    spacing: 8,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 60,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Cold Hardy 3 kohlrabi. Alien-looking bulb stem, mild and crisp.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '12-18 inches',
    spread: '6-8 inches',
    family: 'Brassicaceae',
    varieties: ['Cold Hardy 3'],
    uses: ['raw', 'slaw', 'roasting']
  },
  {
    id: 'rapini-frost-resistant-3',
    name: 'Rapini - Frost Resistant 3',
    scientificName: 'Brassica rapa var. ruvo',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Frost Resistant 3 rapini. Bitter green with small florets, Italian favorite.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Frost Resistant 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mizuna-early-3',
    name: 'Mizuna - Early 3',
    scientificName: 'Brassica rapa var. nipposinica',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Early 3 mizuna. Feathery mild mustard green.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Early 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'mibuna-mid-3',
    name: 'Mibuna - Mid 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Mid 3 mibuna. Spoon-shaped mild mustard.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Mid 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'tatsol-late-3',
    name: 'Tatsol - Late 3',
    scientificName: 'Brassica rapa subsp. narinosa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Late 3 tatsol. Flat rosette, very cold hardy.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Late 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'hon-tsai tai-main-season-3',
    name: 'Hon tsai tai - Main Season 3',
    scientificName: 'Brassica rapa var. parachinensis',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Main Season 3 hon tsai tai. Purple stems, sweet flowering shoots.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Main Season 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  },
  {
    id: 'yukina-savoy-fall-3',
    name: 'Yukina savoy - Fall 3',
    scientificName: 'Brassica rapa',
    category: 'vegetable',
    spacing: 6,
    rowSpacing: 12,
    daysToGermination: 7,
    daysToHarvest: 45,
    sun: 'full',
    water: 'medium',
    soil: 'loamy',
    phMin: 6,
    phMax: 7.5,
    companions: ['sage', 'thyme'],
    enemies: ['strawberry'],
    description: 'Fall 3 yukina savoy. Savoyed Asian green, cold tolerant.',
    hardinessZones: '3-10',
    plantingSeason: 'spring',
    height: '8-12 inches',
    spread: '6-10 inches',
    family: 'Brassicaceae',
    varieties: ['Fall 3'],
    uses: ['stir fry', 'soup', 'asian cuisine']
  }
]
